<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1 maximum-scale=1">
<meta version="0.0.31" content="build:version">

<section class="hero-section">
    
    <div class="channel-html">
        <!--BEGIN > FIXED | HERO (DARK)-->
        <div class="section theme-dark u02CAA2">
          <div class="section-content">
            <div class="row j29BAE3">
              <!---->
              <div class="column large-12 yC6984C">
                <div>
                  <!---->
                </div>
                <div class="row large-display-bleed medium-display-bleed small-display-bleed fDD71ED">
                  <!---->
                  <div class="column sDC9BEE">
                    <div>
                      <!---->
                    </div>
                    <h2>
                      <picture class="picture">
                        <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 179px" srcset="assets/images/iPhone16images/hero_logo_large.png?600061c7f9c0 179w,assets/images/iPhone16images/hero_logo_large_2x.png?600061cc7390 358w" type="image/png">
                        <source media="(min-width: 735px)" sizes="(min-width: 735px) 131px" srcset="assets/images/iPhone16images/hero_logo_medium_2x.png?600061c00790 262w,assets/images/iPhone16images/hero_logo_medium.png?600029f41340 131w" type="image/png"><img sizes="120px" srcset="assets/images/iPhone16images/hero_logo_small_2x.png?600061c07a70 240w,assets/images/iPhone16images/hero_logo_small.png?600061c7db80 120w" src="assets/images/iPhone16images/hero_logo_small_2x.png?600061c07a70" alt="iPhone 16 Pro" class="image gF3008B"></picture>
                    </h2>
                  </div>
                </div>
                <div class="row large-display-bleed medium-display-bleed small-display-bleed b56655F">
                  <!---->
                  <div class="column large-12 p140A0C">
                    <div>
                      <!---->
                    </div>
                    <p>
                      <picture class="picture">
                        <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 741px" srcset="assets/images/iPhone16images/headline_large.png?600061c032e0 741w,assets/images/iPhone16images/headline_large_2x.png?600061c148f0 1482w" type="image/png">
                        <source media="(min-width: 735px)" sizes="(min-width: 735px) 492px" srcset="assets/images/iPhone16images/headline_medium_2x.png?600061c14370 984w,assets/images/iPhone16images/headline_medium.png?600061c144d0 492w" type="image/png"><img sizes="435px" srcset="assets/images/iPhone16images/headline_small.png?600061c02aa0 435w,assets/images/iPhone16images/headline_small_2x.png?600061c16680 870w" src="assets/images/iPhone16images/headline_small.png?600061c02aa0" alt="Hello, Apple Intelligence" class="image s8B988E"></picture>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row large-display-bleed medium-display-bleed small-display-bleed q540661">
              <!---->
              <div class="column large-12 n6DE495">
                <div>
                  <!---->
                </div>
                <div>
                  <picture class="picture">
                    <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 1350px" srcset="assets/images/iPhone16images/hero_glow_large_2x.png?600029f7af70 2700w,assets/images/iPhone16images/hero_glow_large.png?600029ca8840 1350w" type="image/png">
                    <source media="(min-width: 735px)" sizes="(min-width: 735px) 960px" srcset="assets/images/iPhone16images/hero_glow_medium_2x.png?600051cade40 1920w,assets/images/iPhone16images/hero_glow_medium.png?600061c169f0 960w" type="image/png"><img sizes="439px" srcset="assets/images/iPhone16images/hero_glow_small_2x.png?600051caecb0 878w,assets/images/iPhone16images/hero_glow_small.png?600061c7cf20 439w" src="assets/images/iPhone16images/hero_glow_small_2x.png?600051caecb0" alt="" class="image z4D4C86"></picture>
                </div>
              </div>
            </div>
            <div class="row large-display-bleed medium-display-bleed small-display-bleed e7AFD3F">
              <!---->
              <div class="column large-12 uBA5BEB">
                <div>
                  <!---->
                </div>
                <div>
                  <picture class="picture">
                    <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 968px" srcset="assets/images/iPhone16images/hero_large.png?600061c7c9a0 968w,assets/images/iPhone16images/hero_large_2x.png?600051cb37b0 1936w" type="image/png">
                    <source media="(min-width: 735px)" sizes="(min-width: 735px) 960px" srcset="assets/images/iPhone16images/hero_medium_2x.png?600061c151e0 1920w,assets/images/iPhone16images/hero_medium.png?600055c274f0 960w" type="image/png"><img sizes="43px" srcset="assets/images/iPhone16images/hero_small_2x.png?600061cc7c80 86w,assets/images/iPhone16images/hero_small.png?600061cc48f0 43w" src="assets/images/iPhone16images/hero_small_2x.png?600061cc7c80" alt="iPhone 16 Pro in Desert Titanium finish, side exterior, Apple logo in center, raised Pro camera system, Side button, Camera Control button" class="image double-invert g0FCEFB"></picture>
                </div>
              </div>
            </div>
            <div class="row large-display-bleed medium-display-bleed small-display-bleed m1D2BFA">
              <!---->
              <div class="column large-12 lC76A9F">
                <div>
                  <!---->
                </div>
                <p class="copy helvetica-neue s3A747E channel-custom-font-custom-17-partner-message" style="--focus-color: rgba(0, 125, 250, 0.6);">[Your Message]</p>
                <!--BEGIN CHANNEL-BUTTON-->
                <a href="#" aria-label="Buy iPhone 16 Pro" class="button button-custom button-base o830110" style="--focus-color: rgba(0, 113, 227, 100%);"> Buy </a>
                <!--END CHANNEL-BUTTON-->
              </div>
            </div>
          </div>
        </div>
        <!--END > FIXED | HERO (DARK)-->
        <!--BEGIN > FIXED | BENTO (DARK)-->
        <div class="section theme-dark i0CFACE">
          <div class="section-content">
            <div class="row k3CA21E">
              <!---->
              <div class="column large-12 x6FE9BB">
                <div>
                  <!---->
                </div>
                <ul role="list" aria-label="iPhone 16 Pro feature highlights" class="list qB144EC">
                  <li role="listitem" class="list-item eFA8F87">
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed q9009B7">
                      <!---->
                      <div class="column large-12 mD56478">
                        <div>
                          <!---->
                        </div>
                        <div class="bento-box zBE9BB4">
                          <div class="bentobox-item s9184F6">
                            <!---->
                            <div class="row medium-display-bleed small-display-bleed u14F8BC">
                              <!---->
                              <div class="column large-12 small-12 w3FCA9E">
                                <div>
                                  <!---->
                                </div>
                                <p class="copy u546308 channel-custom-font-custom-" style="--focus-color: rgba(0, 125, 250, 0.6);">The first iPhone designed for <span style="background: linear-gradient(128deg, #0090f7 6%, #ba62fc 36%, #f2416b 69%, #f55600 100%); display: inline-block; -webkit-background-clip: text; -webkit-text-fill-color: transparent; ">Apple&nbsp;Intelligence. </span></p>
                                <p class="copy uDD2085 channel-custom-font-custom-" style="--focus-color: rgba(0, 125, 250, 0.6);">Personal, private, powerful.</p>
                                <p class="copy b1A1677 channel-custom-font-Custom-14-ai-disclaimer" style="--focus-color: rgba(0, 125, 250, 0.6);">Apple&nbsp;Intelligence starting in US English in&nbsp;late&nbsp;2024.<span aria-hidden="true" style="top: -0.35em; position: relative; font-size: 10px; vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></p>
                                <div class="row large-display-bleed medium-display-bleed small-display-bleed nF97BB7">
                                  <!---->
                                  <div class="column large-12 small-12 rC91049">
                                    <div>
                                      <!---->
                                    </div>
                                    <div>
                                      <picture class="picture">
                                        <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 655px" srcset="assets/images/iPhone16images/ai_large_2x.png?600061c7f910 1310w,assets/images/iPhone16images/ai_large.png?600061c7ff40 655w" type="image/png">
                                        <source media="(min-width: 735px)" sizes="(min-width: 735px) 540px" srcset="assets/images/iPhone16images/ai_medium.png?600061c021b0 540w,assets/images/iPhone16images/ai_medium_2x.png?600061c7dad0 1080w" type="image/png"><img sizes="320px" srcset="assets/images/iPhone16images/ai_small_2x.png?600029ca3f40 640w,assets/images/iPhone16images/ai_small.png?600061c7fa70 320w" src="assets/images/iPhone16images/ai_small_2x.png?600029ca3f40" alt="Apple Intelligence capabilities with Genmoji, Summary, Type to Siri on iPhone 16 Pro" class="image double-invert jA9E6F5"></picture>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li role="listitem" class="list-item r1EDCC1">
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed p8BEA93">
                      <!---->
                      <div class="column large-12 v565AFD">
                        <div>
                          <!---->
                        </div>
                        <div class="bento-box iED21C1">
                          <div class="bentobox-item p507B3A">
                            <!---->
                            <div class="row large-display-bleed medium-display-bleed small-display-bleed m20E611">
                              <!---->
                              <div class="column large-12 eCAACD3">
                                <div>
                                  <!---->
                                </div>
                                <p class="copy i620B16 channel-custom-font-custom-" style="--focus-color: rgba(0, 125, 250, 0.6);"><span style="color: #f5f5f7;">Thinnest borders yet — for even larger displays.<span aria-hidden="true" style="top: -0.35em; position: relative; font-size: .6em; vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></span> Brilliant.</p>
                                <div class="row large-display-bleed medium-display-bleed small-display-bleed bC68FC1">
                                  <!---->
                                  <div class="column large-7 medium-7 v8F61B5">
                                    <div>
                                      <!---->
                                    </div>
                                    <p class="copy xEF591D channel-custom-font-Custom-17-displays-wordmark" style="--focus-color: rgba(0, 125, 250, 0.6);">iPhone&nbsp;16&nbsp;Pro&nbsp;Max</p>
                                    <p class="copy g17EE6F channel-custom-font-custom-40-displays" style="--focus-color: rgba(0, 125, 250, 0.6);"><span style="background: linear-gradient(0deg, rgba(255,254,253) 0%, rgba(255,254,253) 15%, rgba(203,167,148) 60%, rgba(159,111,86) 80%); display: inline-block; -webkit-background-clip: text; -webkit-text-fill-color: transparent; ">17.43 cm <br>(6.9″)</span></p>
                                  </div>
                                  <div class="column large-5 medium-5 f251574">
                                    <div>
                                      <!---->
                                    </div>
                                    <p class="copy yE68EB1 channel-custom-font-Custom-17-displays-wordmark" style="--focus-color: rgba(0, 125, 250, 0.6);">iPhone&nbsp;16&nbsp;Pro</p>
                                    <p class="copy u27076F channel-custom-font-custom-40-displays" style="--focus-color: rgba(0, 125, 250, 0.6);"><span style="background: linear-gradient(0deg, rgba(255,254,253) 0%, rgba(255,254,253) 15%, rgba(203,167,148) 60%, rgba(159,111,86) 80%); display: inline-block; -webkit-background-clip: text; -webkit-text-fill-color: transparent; ">15.93 cm <br>(6.3″)</span></p>
                                  </div>
                                </div>
                                <div>
                                  <picture class="picture">
                                    <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 362px" srcset="assets/images/iPhone16images/display_large_2x.png?600029ca5c30 724w,assets/images/iPhone16images/display_large.png?600061c7eb50 362w" type="image/png">
                                    <source media="(min-width: 735px)" sizes="(min-width: 735px) 262px" srcset="assets/images/iPhone16images/display_medium_2x.png?600061c21ef0 524w,assets/images/iPhone16images/display_medium.png?600029f49810 262w" type="image/png"><img sizes="262px" srcset="assets/images/iPhone16images/display_small.png?600061c7ecb0 262w,assets/images/iPhone16images/display_small_2x.png?600061c21fa0 524w" src="assets/images/iPhone16images/display_small.png?600061c7ecb0" alt="6.9-inch iPhone 16 Pro Max and 6.3-inch iPhone 16 Pro, front exterior, Action button, volume buttons, Dynamic Island centered near top" class="image double-invert vF922EB"></picture>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li role="listitem" class="list-item iFF1126">
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed oDFCC47">
                      <!---->
                      <div class="column large-12 dB67C46">
                        <div>
                          <!---->
                        </div>
                        <div class="bento-box d3FEAA0">
                          <div class="bentobox-item p467CC9">
                            <!---->
                            <div class="row large-display-bleed medium-display-bleed small-display-bleed b90014E">
                              <!---->
                              <div class="column large-12 sD3FFB0">
                                <div>
                                  <!---->
                                </div><span class="copy u762865 channel-custom-font-custom-" style="--focus-color: rgba(0, 125, 250, 0.6);">Durable titanium design.</span>
                              </div>
                            </div>
                            <div class="row large-display-bleed medium-display-bleed small-display-bleed oAA004D">
                              <!---->
                              <div class="column large-12 u2E87D8">
                                <div>
                                  <!---->
                                </div>
                                <div>
                                  <picture class="picture">
                                    <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 482px" srcset="assets/images/iPhone16images/design_large_2x.png?600061c02cb0 964w,assets/images/iPhone16images/design_large.png?600061c03390 482w" type="image/png">
                                    <source media="(min-width: 735px)" sizes="(min-width: 735px) 338px" srcset="assets/images/iPhone16images/design_medium.png?600029f7c630 338w,assets/images/iPhone16images/design_medium_2x.png?600061c02c00 676w" type="image/png"><img sizes="322px" srcset="assets/images/iPhone16images/design_small.png?600061c02d60 322w,assets/images/iPhone16images/design_small_2x.png?600061c02e10 644w" src="assets/images/iPhone16images/design_small.png?600061c02d60" alt="Two iPhone 16 Pro models, side exterior, side button, raised Pro camera system" class="image double-invert tE26E05"></picture>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li role="listitem" class="list-item l01FA6C">
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed tCC5E4C">
                      <!---->
                      <div class="column large-12 w4FA988">
                        <div>
                          <!---->
                        </div>
                        <div class="bento-box z85B8F5">
                          <div class="bentobox-item o6F724D">
                            <!---->
                            <div class="row medium-display-bleed small-display-bleed vE86FC2">
                              <!---->
                              <div class="column large-12 y84C8A1">
                                <div>
                                  <!---->
                                </div>
                                <p class="copy uCBD479 channel-custom-font-custom-" style="--focus-color: rgba(0, 125, 250, 0.6);">So fast. So fluid.</p>
                                <p class="copy y0B5688 channel-custom-font-custom-" style="--focus-color: rgba(0, 125, 250, 0.6);">Get a feel for Camera&nbsp;Control.</p>
                              </div>
                            </div>
                            <div class="row large-display-bleed medium-display-bleed small-display-bleed u9A64C6">
                              <!---->
                              <div class="column large-12 eB6C550">
                                <div>
                                  <!---->
                                </div>
                                <div>
                                  <picture class="picture">
                                    <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 907px" srcset="assets/images/iPhone16images/camera_control_large.png?600051caf020 907w,assets/images/iPhone16images/camera_control_large_2x.png?600029ca3230 1814w" type="image/png">
                                    <source media="(min-width: 735px)" sizes="(min-width: 735px) 693px" srcset="assets/images/iPhone16images/camera_control_medium_2x.png?600061c22100 1386w,assets/images/iPhone16images/camera_control_medium.png?600061c06680 693w" type="image/png"><img sizes="320px" srcset="assets/images/iPhone16images/camera_control_small_2x.png?600061c7f650 640w,assets/images/iPhone16images/camera_control_small.png?600061c7f700 320w" src="assets/images/iPhone16images/camera_control_small_2x.png?600061c7f650" alt="Camera Control on iPhone 16 Pro, right finger slides along side of phone to adjust the depth of field" class="image double-invert z5E9DCC"></picture>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li role="listitem" class="list-item n6A5BD1">
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed f0773CA">
                      <!---->
                      <div class="column m206E7E">
                        <div>
                          <!---->
                        </div>
                        <div class="bento-box lBE819D">
                          <div class="bentobox-item yD32528">
                            <!---->
                            <div class="row large-display-bleed medium-display-bleed small-display-bleed b13A3EC">
                              <!---->
                              <div class="column large-12 l225BB2">
                                <div>
                                  <!---->
                                </div>
                                <p class="copy dDFAD9B channel-custom-font-custom-" style="--focus-color: rgba(0, 125, 250, 0.6);"><span style="color: #f5f5f7;">4K&nbsp;120 fps Dolby Vision.</span> Cinemasterful.</p>
                              </div>
                            </div>
                            <div class="row large-display-bleed medium-display-bleed small-display-bleed w0BC567">
                              <!---->
                              <div class="column large-12 gA5F99E">
                                <div>
                                  <!---->
                                </div>
                                <div>
                                  <picture class="picture">
                                    <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 480px" srcset="assets/images/iPhone16images/video_large.png?600029ca7b20 480w,assets/images/iPhone16images/video_large_2x.png?600061c21550 960w" type="image/png">
                                    <source media="(min-width: 735px)" sizes="(min-width: 735px) 336px" srcset="assets/images/iPhone16images/video_medium.png?600061c04fd0 336w,assets/images/iPhone16images/video_medium_2x.png?600061c06f70 672w" type="image/png"><img sizes="320px" srcset="assets/images/iPhone16images/video_small.png?600061c7ec00 320w,assets/images/iPhone16images/video_small_2x.png?600061c07e90 640w" src="assets/images/iPhone16images/video_small.png?600061c7ec00" alt="" class="image double-invert jE7A2E5"></picture>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li role="listitem" class="list-item o6A92D7">
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed k7DD634">
                      <!---->
                      <div class="column large-12 aA3C87B">
                        <div>
                          <!---->
                        </div>
                        <div class="bento-box i02742A">
                          <div class="bentobox-item eB87463">
                            <!---->
                            <div class="row large-display-bleed medium-display-bleed small-display-bleed m48BB38">
                              <!---->
                              <div class="column large-12 j76498E">
                                <div>
                                  <!---->
                                </div>
                                <p class="copy l5F4782 channel-custom-font-custom-" style="--focus-color: rgba(0, 125, 250, 0.6);"><span style="color: #f5f5f7;">48MP Ultra Wide camera.</span> Viva la resolution.</p>
                              </div>
                            </div>
                            <div class="row large-display-bleed medium-display-bleed small-display-bleed rEE9C4D">
                              <!---->
                              <div class="column large-12 d7AFEA7">
                                <div>
                                  <!---->
                                </div>
                                <div>
                                  <picture class="picture">
                                    <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 480px" srcset="assets/images/iPhone16images/camera_large.png?600061c7c580 480w,assets/images/iPhone16images/camera_large_2x.png?600061c7c370 960w" type="image/png">
                                    <source media="(min-width: 735px)" sizes="(min-width: 735px) 336px" srcset="assets/images/iPhone16images/camera_medium_2x.png?600061c7c6e0 672w,assets/images/iPhone16images/camera_medium.png?600029f7a5d0 336w" type="image/png"><img sizes="320px" srcset="assets/images/iPhone16images/camera_small.png?600029cac160 320w,assets/images/iPhone16images/camera_small_2x.png?600061c7c630 640w" src="assets/images/iPhone16images/camera_small.png?600029cac160" alt="A person dressed in a metallic suit standing on a square center stage and encompassing the background showcasing the Ultra Wide camera on iPhone 16 Pro Max" class="image double-invert g98F8CA"></picture>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li role="listitem" class="list-item x5DF028">
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed k23F530">
                      <!---->
                      <div class="column large-12 yE47EC1">
                        <div>
                          <!---->
                        </div>
                        <div class="bento-box gB25313">
                          <div class="bentobox-item a4FDBD7">
                            <!---->
                            <div class="row large-display-bleed medium-display-bleed small-display-bleed h1EFCD9">
                              <!---->
                              <div class="column large-12 x2510B4">
                                <div>
                                  <!---->
                                </div>
                                <p class="copy n3E8837 channel-custom-font-custom-" style="--focus-color: rgba(0, 125, 250, 0.6);"><span style="color: #f5f5f7;">Choose your Photographic&nbsp;Style.</span>
                                  <br>Change it up. Change it back.</p>
                              </div>
                              <div class="column large-12 bE27885">
                                <div>
                                  <!---->
                                </div>
                                <div>
                                  <picture class="picture">
                                    <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 250px" srcset="assets/images/iPhone16images/styles_large_2x.png?600061c04790 500w,assets/images/iPhone16images/styles_large.png?600061c7eaa0 250w" type="image/png">
                                    <source media="(min-width: 735px)" sizes="(min-width: 735px) 203px" srcset="assets/images/iPhone16images/styles_medium.png?600061c17230 203w,assets/images/iPhone16images/styles_medium_2x.png?600029f79c30 406w" type="image/png"><img sizes="220px" srcset="assets/images/iPhone16images/styles_small_2x.png?600029f70000 440w,assets/images/iPhone16images/styles_small.png?600061c7e9f0 220w" src="assets/images/iPhone16images/styles_small_2x.png?600029f70000" alt="Photographic Styles capabilities on iPhone 16 Pro include adjusting tone and color" class="image double-invert a2F4DA2"></picture>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row large-display-bleed medium-display-bleed small-display-bleed p899B1F">
                          <!---->
                        </div>
                      </div>
                    </div>
                  </li>
                  <li role="listitem" class="list-item x5B9EE2">
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed iA51118">
                      <!---->
                      <div class="column large-12 b0705E4">
                        <div>
                          <!---->
                        </div>
                        <div class="bento-box s4783BB">
                          <div class="bentobox-item sC07FC3">
                            <!---->
                            <div class="row large-display-bleed medium-display-bleed small-display-bleed wEDB8DC">
                              <!---->
                              <div class="column large-12 v0343E5">
                                <div>
                                  <!---->
                                </div><span class="copy k578A55 channel-custom-font-custom-" style="--focus-color: rgba(0, 125, 250, 0.6);"><span style="color: #f5f5f7;">A18&nbsp;Pro chip.</span>
                                <br>The brains behind Apple&nbsp;Intelligence.</span>
                                <div>
                                  <picture class="picture">
                                    <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 224px" srcset="assets/images/iPhone16images/chip_large.png?600029ca7a70 224w,assets/images/iPhone16images/chip_large_2x.png?600061c7e890 448w" type="image/png">
                                    <source media="(min-width: 735px)" sizes="(min-width: 735px) 183px" srcset="assets/images/iPhone16images/chip_medium_2x.png?600061c7e310 366w,assets/images/iPhone16images/chip_medium.png?600061c04e70 183w" type="image/png"><img sizes="170px" srcset="assets/images/iPhone16images/chip_small_2x.png?600061c22050 340w,assets/images/iPhone16images/chip_small.png?600029ca53f0 170w" src="assets/images/iPhone16images/chip_small_2x.png?600061c22050" alt="A18 Pro chip for iPhone 16 Pro" class="image double-invert sD391E6"></picture>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li role="listitem" class="list-item aDE79BE">
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed w7C5890">
                      <!---->
                      <div class="column large-12 o047C6A">
                        <div>
                          <!---->
                        </div>
                        <div class="bento-box rE1A0EB">
                          <div class="bentobox-item zA37890">
                            <!---->
                            <div class="row medium-display-bleed small-display-bleed dB6FCD6">
                              <!---->
                              <div class="column large-12 vB91C3F">
                                <div>
                                  <!---->
                                </div>
                                <p class="copy s1619B3 channel-custom-font-custom-" style="--focus-color: rgba(0, 125, 250, 0.6);">Up to <span style="color: #f5f5f7;">4 more hours of battery life.<span aria-hidden="true" style="top: -0.35em; position: relative; font-size: .72em; vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></span> Stellar.</p>
                                <div>
                                  <picture class="picture">
                                    <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 525px" srcset="assets/images/iPhone16images/battery_large_2x.png?600061c7c790 1050w,assets/images/iPhone16images/battery_large.png?600061c7c840 525w" type="image/png">
                                    <source media="(min-width: 735px)" sizes="(min-width: 735px) 429px" srcset="assets/images/iPhone16images/battery_medium.png?600061c04420 429w,assets/images/iPhone16images/battery_medium_2x.png?600055c24580 858w" type="image/png"><img sizes="282px" srcset="assets/images/iPhone16images/battery_small_2x.png?600061c7c8f0 564w,assets/images/iPhone16images/battery_small.png?600055c25fa0 282w" src="assets/images/iPhone16images/battery_small_2x.png?600061c7c8f0" alt="The Red Moon: Episode 1 scene from the AppleTV+ series For All Mankind displayed on the iPhone 16 Pro" class="image double-invert vFFF903"></picture>
                                </div>
                                <p class="copy e7F8DBC channel-custom-font-Custom-24-battery-stats" style="--focus-color: rgba(0, 125, 250, 0.6);">Up to <span style=" color: rgb(61,107,211); background: linear-gradient(0deg, rgba(255,254,253) 0%, rgba(255,254,253) 15%, rgba(203,167,148) 60%, rgba(159,111,86) 80%); display: inline-block; -webkit-background-clip: text; -webkit-text-fill-color: transparent; ">33 hours</span> video&nbsp;playback on iPhone&nbsp;16&nbsp;Pro&nbsp;Max and up to <span style=" color: rgb(61,107,211); background: linear-gradient(0deg, rgba(255,254,253) 0%, rgba(255,254,253) 25%, rgba(203,167,148) 60%, rgba(159,111,86) 80%); display: inline-block; -webkit-background-clip: text; -webkit-text-fill-color: transparent; ">27 hours</span> video&nbsp;playback on iPhone&nbsp;16&nbsp;Pro.<span aria-hidden="true" style="top: -0.35em; position: relative; font-size: .72em; vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li role="listitem" class="list-item q48047C">
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed z488CC0">
                      <!---->
                      <div class="column large-12 s5B9D7B">
                        <div>
                          <!---->
                        </div>
                        <div class="bento-box eAD14AD">
                          <div class="bentobox-item lB39414">
                            <!---->
                            <div class="row medium-display-bleed small-display-bleed j7F1FBB">
                              <!---->
                              <div class="column large-6 small-12 pF93386">
                                <div>
                                  <!---->
                                </div>
                                <p class="copy qB6525A channel-custom-font-custom-" style="--focus-color: rgba(0, 125, 250, 0.6);">Crash Detection.<span aria-hidden="true" style="top: -0.35em; position: relative; font-size: 10px; vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></p>
                                <p class="copy dC1927D channel-custom-font-custom-17-satellite-small" style="--focus-color: rgba(0, 125, 250, 0.6);">In a severe car crash, iPhone can call for help when you can’t.</p>
                              </div>
                              <div class="column large-6 small-12 z7E0C75">
                                <div>
                                  <!---->
                                </div>
                                <div>
                                  <picture class="picture">
                                    <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 300px" srcset="assets/images/iPhone16images/satellite_large_2x.png?600061c06470 600w,assets/images/iPhone16images/satellite_large.png?600061c7e260 300w" type="image/png">
                                    <source media="(min-width: 735px)" sizes="(min-width: 735px) 244px" srcset="assets/images/iPhone16images/satellite_medium_2x.png?600061c05c30 488w,assets/images/iPhone16images/satellite_medium.png?600061c075a0 244w" type="image/png"><img sizes="201px" srcset="assets/images/iPhone16images/satellite_small.png?600061c7e1b0 201w,assets/images/iPhone16images/satellite_small_2x.png?600061c07d30 402w" src="assets/images/iPhone16images/satellite_small.png?600061c7e1b0" alt="Showing the user's GPS location and messaging via Satellite feature on iPhone 16 Pro" class="image double-invert jD600BC"></picture>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <!--END > FIXED | BENTO (DARK)-->
        <!--BEGIN > FLEX | COMPARE-->
        <div class="section p829266">
          <div class="section-content">
            <div class="row large-display-bleed medium-display-bleed small-display-bleed f8F57F7">
              <!---->
              <div class="column large-12 p8DE121">
                <div>
                  <!---->
                </div>
                <h2 class="copy gD415B9 channel-custom-font-custom-21-eyebrow-reduced" style="--focus-color: rgba(0, 125, 250, 0.6);">Compare</h2>
                <h3 class="copy rE46FD1 channel-custom-font-custom-40-headline-reduced" style="--focus-color: rgba(0, 125, 250, 0.6);">Which iPhone is right for you?</h3>
              </div>
            </div>
            <div class="row large-display-bleed medium-display-bleed small-display-bleed g737104">
              <!---->
              <div class="d12B9D1" style="--focus-color: rgba(0, 125, 250, 0.6);">
                <div data-export-class="channel-compare--hidden" data-channel-html-compare="{&quot;order&quot;:{&quot;small&quot;:[0,2,1,3,4],&quot;medium&quot;:[0,1,2,3,4],&quot;large&quot;:[0,1,2,3,4],&quot;max&quot;:{&quot;large&quot;:5,&quot;medium&quot;:3,&quot;small&quot;:2}},&quot;useStatic&quot;:false,&quot;isConfigurableCompare&quot;:false,&quot;selectorEls&quot;:&quot;[selector-dropdown]&quot;,&quot;labelEls&quot;:&quot;[compare-column-interactive]&quot;,&quot;swapEls&quot;:&quot;[data-column-group]&quot;,&quot;headerEl&quot;:&quot;[compare-header-row]&quot;,&quot;staticEl&quot;:&quot;[compare-column-header-static]&quot;}" class="channel-compare channel-compare--hidden">
                  <div class="section section-compare-table">
                    <div class="compare-wrapper">
                      <div role="table" aria-label="Compare models" class="compare compare-table with-fullwidthrowheader compare-column-range-large-5 compare-column-range-medium-3 compare-column-range-small-2">
                        <div>
                          <div role="rowgroup">
                            <div role="row" compare-header-row="" class="compare-row visuallyhidden">
                              <div role="columnheader">&nbsp;</div>
                              <div role="columnheader">iPhone SE (1st generation)</div>
                              <div role="columnheader">iPhone 16 Pro</div>
                              <div role="columnheader">iPhone 16 Plus</div>
                              <div role="columnheader">iPhone 16</div>
                              <div role="columnheader">iPhone SE (3rd generation)</div>
                            </div>
                          </div>
                          <div role="rowgroup" class="compare selector-table with-fullwidthrowheader">
                            <div id="static-compare-header" role="row" data-column-group="" class="compare-row" style="display: none;">
                              <div role="rowheader" aria-rowspan="0" class="compare-rowheader" style="order: unset; visibility: hidden; display: none;">
                                <div class="visuallyhidden">Choose models to compare.</div>
                              </div>
                              <div id="hidden-columnheader" role="columnheader" class="visuallyhidden">&nbsp;</div>
                              <div role="columnheader" compare-column-header-static="" class="static-dropdown compare-column compare-static-0 first-child">
                                <div index="0">iPhone 16 Pro Max</div>
                              </div>
                              <div role="columnheader" compare-column-header-static="" class="static-dropdown compare-column compare-static-1">
                                <div index="1">iPhone 16 Pro</div>
                              </div>
                              <div role="columnheader" compare-column-header-static="" class="static-dropdown compare-column compare-static-2">
                                <div index="2">iPhone 16 Plus</div>
                              </div>
                              <div role="columnheader" compare-column-header-static="" class="static-dropdown compare-column compare-static-3">
                                <div index="3">iPhone 16</div>
                              </div>
                              <div role="columnheader" compare-column-header-static="" class="static-dropdown compare-column compare-static-4">
                                <div index="4">iPhone SE (3rd generation)</div>
                              </div>
                              <div role="columnheader" compare-column-header-static="" class="static-dropdown compare-column compare-static-5">
                                <div index="5">iPhone 15 Pro Max</div>
                              </div>
                              <div role="columnheader" compare-column-header-static="" class="static-dropdown compare-column compare-static-6">
                                <div index="6">iPhone 15 Pro</div>
                              </div>
                              <div role="columnheader" compare-column-header-static="" class="static-dropdown compare-column compare-static-7">
                                <div index="7">iPhone 15 Plus</div>
                              </div>
                              <div role="columnheader" compare-column-header-static="" class="static-dropdown compare-column compare-static-8">
                                <div index="8">iPhone 15</div>
                              </div>
                              <div role="columnheader" compare-column-header-static="" class="static-dropdown compare-column compare-static-9">
                                <div index="9">iPhone 14 Pro Max</div>
                              </div>
                              <div role="columnheader" compare-column-header-static="" class="static-dropdown compare-column compare-static-10">
                                <div index="10">iPhone 14 Pro</div>
                              </div>
                              <div role="columnheader" compare-column-header-static="" class="static-dropdown compare-column compare-static-11">
                                <div index="11">iPhone 14 Plus</div>
                              </div>
                              <div role="columnheader" compare-column-header-static="" class="static-dropdown compare-column compare-static-12">
                                <div index="12">iPhone 14</div>
                              </div>
                              <div role="columnheader" compare-column-header-static="" class="static-dropdown compare-column compare-static-13">
                                <div index="13">iPhone 13 Pro Max</div>
                              </div>
                              <div role="columnheader" compare-column-header-static="" class="static-dropdown compare-column compare-static-14">
                                <div index="14">iPhone 13 Pro</div>
                              </div>
                              <div role="columnheader" compare-column-header-static="" class="static-dropdown compare-column compare-static-15">
                                <div index="15">iPhone 13</div>
                              </div>
                              <div role="columnheader" compare-column-header-static="" class="static-dropdown compare-column compare-static-16">
                                <div index="16">iPhone 13 mini</div>
                              </div>
                              <div role="columnheader" compare-column-header-static="" class="static-dropdown compare-column compare-static-17">
                                <div index="17">iPhone 12 Pro Max</div>
                              </div>
                              <div role="columnheader" compare-column-header-static="" class="static-dropdown compare-column compare-static-18">
                                <div index="18">iPhone 12 Pro</div>
                              </div>
                              <div role="columnheader" compare-column-header-static="" class="static-dropdown compare-column compare-static-19">
                                <div index="19">iPhone 12</div>
                              </div>
                              <div role="columnheader" compare-column-header-static="" class="static-dropdown compare-column compare-static-20">
                                <div index="20">iPhone 12 mini</div>
                              </div>
                              <div role="columnheader" compare-column-header-static="" class="static-dropdown compare-column compare-static-21">
                                <div index="21">iPhone 11 Pro Max</div>
                              </div>
                              <div role="columnheader" compare-column-header-static="" class="static-dropdown compare-column compare-static-22">
                                <div index="22">iPhone 11 Pro</div>
                              </div>
                              <div role="columnheader" compare-column-header-static="" class="static-dropdown compare-column compare-static-23">
                                <div index="23">iPhone 11</div>
                              </div>
                              <div role="columnheader" compare-column-header-static="" class="static-dropdown compare-column compare-static-24">
                                <div index="24">iPhone SE (2nd generation)</div>
                              </div>
                              <div role="columnheader" compare-column-header-static="" class="static-dropdown compare-column compare-static-25">
                                <div index="25">iPhone XS Max</div>
                              </div>
                              <div role="columnheader" compare-column-header-static="" class="static-dropdown compare-column compare-static-26">
                                <div index="26">iPhone XS</div>
                              </div>
                              <div role="columnheader" compare-column-header-static="" class="static-dropdown compare-column compare-static-27">
                                <div index="27">iPhone XR</div>
                              </div>
                              <div role="columnheader" compare-column-header-static="" class="static-dropdown compare-column compare-static-28">
                                <div index="28">iPhone X</div>
                              </div>
                              <div role="columnheader" compare-column-header-static="" class="static-dropdown compare-column compare-static-29">
                                <div index="29">iPhone 8 Plus</div>
                              </div>
                              <div role="columnheader" compare-column-header-static="" class="static-dropdown compare-column compare-static-30">
                                <div index="30">iPhone 8</div>
                              </div>
                              <div role="columnheader" compare-column-header-static="" class="static-dropdown compare-column compare-static-31">
                                <div index="31">iPhone 7 Plus</div>
                              </div>
                              <div role="columnheader" compare-column-header-static="" class="static-dropdown compare-column compare-static-32">
                                <div index="32">iPhone 7</div>
                              </div>
                              <div role="columnheader" compare-column-header-static="" class="static-dropdown compare-column compare-static-33">
                                <div index="33">iPhone 6s Plus</div>
                              </div>
                              <div role="columnheader" compare-column-header-static="" class="static-dropdown compare-column compare-static-34">
                                <div index="34">iPhone 6s</div>
                              </div>
                              <div role="columnheader" compare-column-header-static="" class="static-dropdown compare-column compare-static-35">
                                <div index="35">iPhone 6 Plus</div>
                              </div>
                              <div role="columnheader" compare-column-header-static="" class="static-dropdown compare-column compare-static-36">
                                <div index="36">iPhone 6</div>
                              </div>
                              <div role="columnheader" compare-column-header-static="" class="static-dropdown compare-column compare-static-37">
                                <div index="37">iPhone SE (1st generation)</div>
                              </div>
                            </div>
                            <div id="interactive-compare-header" role="row" class="compare-row">
                              <div role="rowheader" aria-rowspan="0" class="compare-rowheader">
                                <div class="visuallyhidden">Choose models to compare.</div>
                              </div>
                              <div role="cell" compare-column-interactive="true" class="compare-column-interactive compare-column compare-column-0  first-child">
                                <form autocomplete="off" class="selector-element"><label for="0" class="visuallyhidden">Select a model</label><select id="0" selector-dropdown="true" class="selector-dropdown">
                                    <optgroup label="New iPhone models">
                                      <option value="0" aria-selected="true" selected="true">iPhone 16 Pro Max</option>
                                      <option value="1">iPhone 16 Pro</option>
                                      <option value="2">iPhone 16 Plus</option>
                                      <option value="3">iPhone 16</option>
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                    </optgroup>
                                    <optgroup label="More iPhone models">
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <option value="4">iPhone SE (3rd generation)</option>
                                      <option value="5">iPhone 15 Pro Max</option>
                                      <option value="6">iPhone 15 Pro</option>
                                      <option value="7">iPhone 15 Plus</option>
                                      <option value="8">iPhone 15</option>
                                      <option value="9">iPhone 14 Pro Max</option>
                                      <option value="10">iPhone 14 Pro</option>
                                      <option value="11">iPhone 14 Plus</option>
                                      <option value="12">iPhone 14</option>
                                      <option value="13">iPhone 13 Pro Max</option>
                                      <option value="14">iPhone 13 Pro</option>
                                      <option value="15">iPhone 13</option>
                                      <option value="16">iPhone 13 mini</option>
                                      <option value="17">iPhone 12 Pro Max</option>
                                      <option value="18">iPhone 12 Pro</option>
                                      <option value="19">iPhone 12</option>
                                      <option value="20">iPhone 12 mini</option>
                                      <option value="21">iPhone 11 Pro Max</option>
                                      <option value="22">iPhone 11 Pro</option>
                                      <option value="23">iPhone 11</option>
                                      <option value="24">iPhone SE (2nd generation)</option>
                                      <option value="25">iPhone XS Max</option>
                                      <option value="26">iPhone XS</option>
                                      <option value="27">iPhone XR</option>
                                      <option value="28">iPhone X</option>
                                      <option value="29">iPhone 8 Plus</option>
                                      <option value="30">iPhone 8</option>
                                      <option value="31">iPhone 7 Plus</option>
                                      <option value="32">iPhone 7</option>
                                      <option value="33">iPhone 6s Plus</option>
                                      <option value="34">iPhone 6s</option>
                                      <option value="35">iPhone 6 Plus</option>
                                      <option value="36">iPhone 6</option>
                                      <option value="37">iPhone SE (1st generation)</option>
                                    </optgroup>
                                  </select><span aria-hidden="true" class="selector-icon icon icon-chevrondown"></span></form>
                              </div>
                              <div role="cell" compare-column-interactive="true" class="compare-column-interactive compare-column compare-column-1 ">
                                <form autocomplete="off" class="selector-element"><label for="1" class="visuallyhidden">Select a model</label><select id="1" selector-dropdown="true" class="selector-dropdown">
                                    <optgroup label="New iPhone models">
                                      <option value="0">iPhone 16 Pro Max</option>
                                      <option value="1" aria-selected="true" selected="true">iPhone 16 Pro</option>
                                      <option value="2">iPhone 16 Plus</option>
                                      <option value="3">iPhone 16</option>
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                    </optgroup>
                                    <optgroup label="More iPhone models">
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <option value="4">iPhone SE (3rd generation)</option>
                                      <option value="5">iPhone 15 Pro Max</option>
                                      <option value="6">iPhone 15 Pro</option>
                                      <option value="7">iPhone 15 Plus</option>
                                      <option value="8">iPhone 15</option>
                                      <option value="9">iPhone 14 Pro Max</option>
                                      <option value="10">iPhone 14 Pro</option>
                                      <option value="11">iPhone 14 Plus</option>
                                      <option value="12">iPhone 14</option>
                                      <option value="13">iPhone 13 Pro Max</option>
                                      <option value="14">iPhone 13 Pro</option>
                                      <option value="15">iPhone 13</option>
                                      <option value="16">iPhone 13 mini</option>
                                      <option value="17">iPhone 12 Pro Max</option>
                                      <option value="18">iPhone 12 Pro</option>
                                      <option value="19">iPhone 12</option>
                                      <option value="20">iPhone 12 mini</option>
                                      <option value="21">iPhone 11 Pro Max</option>
                                      <option value="22">iPhone 11 Pro</option>
                                      <option value="23">iPhone 11</option>
                                      <option value="24">iPhone SE (2nd generation)</option>
                                      <option value="25">iPhone XS Max</option>
                                      <option value="26">iPhone XS</option>
                                      <option value="27">iPhone XR</option>
                                      <option value="28">iPhone X</option>
                                      <option value="29">iPhone 8 Plus</option>
                                      <option value="30">iPhone 8</option>
                                      <option value="31">iPhone 7 Plus</option>
                                      <option value="32">iPhone 7</option>
                                      <option value="33">iPhone 6s Plus</option>
                                      <option value="34">iPhone 6s</option>
                                      <option value="35">iPhone 6 Plus</option>
                                      <option value="36">iPhone 6</option>
                                      <option value="37">iPhone SE (1st generation)</option>
                                    </optgroup>
                                  </select><span aria-hidden="true" class="selector-icon icon icon-chevrondown"></span></form>
                              </div>
                              <div role="cell" compare-column-interactive="true" class="compare-column-interactive compare-column compare-column-2 ">
                                <form autocomplete="off" class="selector-element"><label for="2" class="visuallyhidden">Select a model</label><select id="2" selector-dropdown="true" class="selector-dropdown">
                                    <optgroup label="New iPhone models">
                                      <option value="0">iPhone 16 Pro Max</option>
                                      <option value="1">iPhone 16 Pro</option>
                                      <option value="2" aria-selected="true" selected="true">iPhone 16 Plus</option>
                                      <option value="3">iPhone 16</option>
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                    </optgroup>
                                    <optgroup label="More iPhone models">
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <option value="4">iPhone SE (3rd generation)</option>
                                      <option value="5">iPhone 15 Pro Max</option>
                                      <option value="6">iPhone 15 Pro</option>
                                      <option value="7">iPhone 15 Plus</option>
                                      <option value="8">iPhone 15</option>
                                      <option value="9">iPhone 14 Pro Max</option>
                                      <option value="10">iPhone 14 Pro</option>
                                      <option value="11">iPhone 14 Plus</option>
                                      <option value="12">iPhone 14</option>
                                      <option value="13">iPhone 13 Pro Max</option>
                                      <option value="14">iPhone 13 Pro</option>
                                      <option value="15">iPhone 13</option>
                                      <option value="16">iPhone 13 mini</option>
                                      <option value="17">iPhone 12 Pro Max</option>
                                      <option value="18">iPhone 12 Pro</option>
                                      <option value="19">iPhone 12</option>
                                      <option value="20">iPhone 12 mini</option>
                                      <option value="21">iPhone 11 Pro Max</option>
                                      <option value="22">iPhone 11 Pro</option>
                                      <option value="23">iPhone 11</option>
                                      <option value="24">iPhone SE (2nd generation)</option>
                                      <option value="25">iPhone XS Max</option>
                                      <option value="26">iPhone XS</option>
                                      <option value="27">iPhone XR</option>
                                      <option value="28">iPhone X</option>
                                      <option value="29">iPhone 8 Plus</option>
                                      <option value="30">iPhone 8</option>
                                      <option value="31">iPhone 7 Plus</option>
                                      <option value="32">iPhone 7</option>
                                      <option value="33">iPhone 6s Plus</option>
                                      <option value="34">iPhone 6s</option>
                                      <option value="35">iPhone 6 Plus</option>
                                      <option value="36">iPhone 6</option>
                                      <option value="37">iPhone SE (1st generation)</option>
                                    </optgroup>
                                  </select><span aria-hidden="true" class="selector-icon icon icon-chevrondown"></span></form>
                              </div>
                              <div role="cell" compare-column-interactive="true" class="compare-column-interactive compare-column compare-column-3 ">
                                <form autocomplete="off" class="selector-element"><label for="3" class="visuallyhidden">Select a model</label><select id="3" selector-dropdown="true" class="selector-dropdown">
                                    <optgroup label="New iPhone models">
                                      <option value="0">iPhone 16 Pro Max</option>
                                      <option value="1">iPhone 16 Pro</option>
                                      <option value="2">iPhone 16 Plus</option>
                                      <option value="3" aria-selected="true" selected="true">iPhone 16</option>
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                    </optgroup>
                                    <optgroup label="More iPhone models">
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <option value="4">iPhone SE (3rd generation)</option>
                                      <option value="5">iPhone 15 Pro Max</option>
                                      <option value="6">iPhone 15 Pro</option>
                                      <option value="7">iPhone 15 Plus</option>
                                      <option value="8">iPhone 15</option>
                                      <option value="9">iPhone 14 Pro Max</option>
                                      <option value="10">iPhone 14 Pro</option>
                                      <option value="11">iPhone 14 Plus</option>
                                      <option value="12">iPhone 14</option>
                                      <option value="13">iPhone 13 Pro Max</option>
                                      <option value="14">iPhone 13 Pro</option>
                                      <option value="15">iPhone 13</option>
                                      <option value="16">iPhone 13 mini</option>
                                      <option value="17">iPhone 12 Pro Max</option>
                                      <option value="18">iPhone 12 Pro</option>
                                      <option value="19">iPhone 12</option>
                                      <option value="20">iPhone 12 mini</option>
                                      <option value="21">iPhone 11 Pro Max</option>
                                      <option value="22">iPhone 11 Pro</option>
                                      <option value="23">iPhone 11</option>
                                      <option value="24">iPhone SE (2nd generation)</option>
                                      <option value="25">iPhone XS Max</option>
                                      <option value="26">iPhone XS</option>
                                      <option value="27">iPhone XR</option>
                                      <option value="28">iPhone X</option>
                                      <option value="29">iPhone 8 Plus</option>
                                      <option value="30">iPhone 8</option>
                                      <option value="31">iPhone 7 Plus</option>
                                      <option value="32">iPhone 7</option>
                                      <option value="33">iPhone 6s Plus</option>
                                      <option value="34">iPhone 6s</option>
                                      <option value="35">iPhone 6 Plus</option>
                                      <option value="36">iPhone 6</option>
                                      <option value="37">iPhone SE (1st generation)</option>
                                    </optgroup>
                                  </select><span aria-hidden="true" class="selector-icon icon icon-chevrondown"></span></form>
                              </div>
                              <div role="cell" compare-column-interactive="true" class="compare-column-interactive compare-column compare-column-4 ">
                                <form autocomplete="off" class="selector-element"><label for="4" class="visuallyhidden">Select a model</label><select id="4" selector-dropdown="true" class="selector-dropdown">
                                    <optgroup label="New iPhone models">
                                      <option value="0">iPhone 16 Pro Max</option>
                                      <option value="1">iPhone 16 Pro</option>
                                      <option value="2">iPhone 16 Plus</option>
                                      <option value="3">iPhone 16</option>
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                    </optgroup>
                                    <optgroup label="More iPhone models">
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <option value="4" aria-selected="true" selected="true">iPhone SE (3rd generation)</option>
                                      <option value="5">iPhone 15 Pro Max</option>
                                      <option value="6">iPhone 15 Pro</option>
                                      <option value="7">iPhone 15 Plus</option>
                                      <option value="8">iPhone 15</option>
                                      <option value="9">iPhone 14 Pro Max</option>
                                      <option value="10">iPhone 14 Pro</option>
                                      <option value="11">iPhone 14 Plus</option>
                                      <option value="12">iPhone 14</option>
                                      <option value="13">iPhone 13 Pro Max</option>
                                      <option value="14">iPhone 13 Pro</option>
                                      <option value="15">iPhone 13</option>
                                      <option value="16">iPhone 13 mini</option>
                                      <option value="17">iPhone 12 Pro Max</option>
                                      <option value="18">iPhone 12 Pro</option>
                                      <option value="19">iPhone 12</option>
                                      <option value="20">iPhone 12 mini</option>
                                      <option value="21">iPhone 11 Pro Max</option>
                                      <option value="22">iPhone 11 Pro</option>
                                      <option value="23">iPhone 11</option>
                                      <option value="24">iPhone SE (2nd generation)</option>
                                      <option value="25">iPhone XS Max</option>
                                      <option value="26">iPhone XS</option>
                                      <option value="27">iPhone XR</option>
                                      <option value="28">iPhone X</option>
                                      <option value="29">iPhone 8 Plus</option>
                                      <option value="30">iPhone 8</option>
                                      <option value="31">iPhone 7 Plus</option>
                                      <option value="32">iPhone 7</option>
                                      <option value="33">iPhone 6s Plus</option>
                                      <option value="34">iPhone 6s</option>
                                      <option value="35">iPhone 6 Plus</option>
                                      <option value="36">iPhone 6</option>
                                      <option value="37">iPhone SE (1st generation)</option>
                                    </optgroup>
                                  </select><span aria-hidden="true" class="selector-icon icon icon-chevrondown"></span></form>
                              </div>
                              <!---->
                              <!---->
                              <!---->
                              <!---->
                              <!---->
                              <!---->
                              <!---->
                              <!---->
                              <!---->
                              <!---->
                              <!---->
                              <!---->
                              <!---->
                              <!---->
                              <!---->
                              <!---->
                              <!---->
                              <!---->
                              <!---->
                              <!---->
                              <!---->
                              <!---->
                              <!---->
                              <!---->
                              <!---->
                              <!---->
                              <!---->
                              <!---->
                              <!---->
                              <!---->
                              <!---->
                              <!---->
                              <!---->
                            </div>
                          </div>
                        </div>
                        <!--BEGIN > CATEGORY > IMAGES-->
                        <div role="rowgroup" class="compare-section section-images no-padding-top">
                          <!--BEGIN > CATEGORY > IMAGES > FEATURE > IMAGES-->
                          <div role="row" data-column-group="" class="compare-row compare-template-preview-item-default">
                            <div role="rowheader" aria-rowspan="0" class="compare-rowheader">
                              <div class="visuallyhidden">Images</div>
                            </div>
                            <div role="cell" class="first-child compare-column product-0 compare-column-0">
                              <div class="pEAAE44 embed-image" index="0">
                                <figure role="img" aria-label="iPhone 16 Pro Max" class="compare-image image-header_iphone_16_pro_max_rose_titanium double-invert"></figure>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-1 compare-column-1">
                              <div class="tF9A889 embed-image" index="1">
                                <figure role="img" aria-label="iPhone 16 Pro" class="compare-image image-header_iphone_16_pro_rose_titanium double-invert"></figure>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-2 compare-column-2">
                              <div class="x4DF343 embed-image" index="2">
                                <figure role="img" aria-label="iPhone 16 Plus" class="compare-image image-header_iphone_16_plus_blue double-invert"></figure>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-3 compare-column-3">
                              <div class="h3D5009 embed-image" index="3">
                                <figure role="img" aria-label="iPhone 16" class="compare-image image-header_iphone_16_blue double-invert"></figure>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-4 compare-column-4">
                              <div class="bFB227A embed-image" index="4">
                                <figure role="img" aria-label="iPhone SE (3rd generation)" class="compare-image image-header_iphone_se_gen03_midnight double-invert"></figure>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-5">
                              <div class="g31AE6F embed-image" index="5">
                                <figure role="img" aria-label="iPhone 15 Pro Max" class="compare-image image-header_iphone_15_pro_max_tigry double-invert"></figure>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-6">
                              <div class="y2FDEF8 embed-image" index="6">
                                <figure role="img" aria-label="iPhone 15 Pro" class="compare-image image-header_iphone_15_pro_tigry double-invert"></figure>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-7">
                              <div class="z7A2DD8 embed-image" index="7">
                                <figure role="img" aria-label="iPhone 15 Plus" class="compare-image image-header_iphone_15_plus_pink double-invert"></figure>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-8">
                              <div class="hF26138 embed-image" index="8">
                                <figure role="img" aria-label="iPhone 15" class="compare-image image-header_iphone_15_pink double-invert"></figure>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-9">
                              <div class="pAEF02D embed-image" index="9">
                                <figure role="img" aria-label="iPhone 14 Pro Max" class="compare-image image-header_iphone_14_pro_max_twilight_purple double-invert"></figure>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-10">
                              <div class="b0AAFE5 embed-image" index="10">
                                <figure role="img" aria-label="iPhone 14 Pro" class="compare-image image-header_iphone_14_pro_twilight_purple double-invert"></figure>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-11">
                              <div class="z36EE19 embed-image" index="11">
                                <figure role="img" aria-label="iPhone 14 Plus" class="compare-image image-header_iphone_14_plus_blue double-invert"></figure>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-12">
                              <div class="v615459 embed-image" index="12">
                                <figure role="img" aria-label="iPhone 14" class="compare-image image-header_iphone_14_blue double-invert"></figure>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-13">
                              <div class="n495896 embed-image" index="13">
                                <figure role="img" aria-label="iPhone 13 Pro Max" class="compare-image image-header_iphone_13_pro_max_sierra_blue double-invert"></figure>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-14">
                              <div class="k18E9B1 embed-image" index="14">
                                <figure role="img" aria-label="iPhone 13 Pro" class="compare-image image-header_iphone_13_pro_sierra_blue double-invert"></figure>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-15">
                              <div class="i1F6E52 embed-image" index="15">
                                <figure role="img" aria-label="iPhone 13" class="compare-image image-header_iphone_13_pink double-invert"></figure>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-16">
                              <div class="b3B4D12 embed-image" index="16">
                                <figure role="img" aria-label="iPhone 13 mini" class="compare-image image-header_iphone_13_mini_pink double-invert"></figure>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-17">
                              <div class="o47741B embed-image" index="17">
                                <figure role="img" aria-label="iPhone 12 Pro Max" class="compare-image image-header_iphone_12_pro_max_pacific_blue double-invert"></figure>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-18">
                              <div class="lC34693 embed-image" index="18">
                                <figure role="img" aria-label="iPhone 12 Pro" class="compare-image image-header_iphone_12_pro_pacific_blue double-invert"></figure>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-19">
                              <div class="g9708DC embed-image" index="19">
                                <figure role="img" aria-label="iPhone 12" class="compare-image image-header_iphone_12_purple double-invert"></figure>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-20">
                              <div class="jB24ECE embed-image" index="20">
                                <figure role="img" aria-label="iPhone 12 mini" class="compare-image image-header_iphone_12_mini_purple double-invert"></figure>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-21">
                              <div class="cB9D72F embed-image" index="21">
                                <figure role="img" aria-label="iPhone 11 Pro Max" class="compare-image image-header_iphone_11_pro_max_midnight_green double-invert"></figure>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-22">
                              <div class="b8F5705 embed-image" index="22">
                                <figure role="img" aria-label="iPhone 11 Pro" class="compare-image image-header_iphone_11_pro_midnight_green double-invert"></figure>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-23">
                              <div class="b4DB063 embed-image" index="23">
                                <figure role="img" aria-label="iPhone 11" class="compare-image image-header_iphone_11_purple double-invert"></figure>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-24">
                              <div class="r723B40 embed-image" index="24">
                                <figure role="img" aria-label="iPhone SE (2nd generation)" class="compare-image image-header_iphone_se_gen02_black double-invert"></figure>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-25">
                              <div class="c267E26 embed-image" index="25">
                                <figure role="img" aria-label="iPhone XS Max" class="compare-image image-header_iphone_xs_max_silver double-invert"></figure>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-26">
                              <div class="j686132 embed-image" index="26">
                                <figure role="img" aria-label="iPhone XS" class="compare-image image-header_iphone_xs_silver double-invert"></figure>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-27">
                              <div class="i16A2FE embed-image" index="27">
                                <figure role="img" aria-label="iPhone XR" class="compare-image image-header_iphone_xr_blue double-invert"></figure>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-28">
                              <div class="x95F731 embed-image" index="28">
                                <figure role="img" aria-label="iPhone X" class="compare-image image-header_iphone_x_silver double-invert"></figure>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-29">
                              <div class="y92D891 embed-image" index="29">
                                <figure role="img" aria-label="iPhone 8 Plus" class="compare-image image-header_iphone_8_plus_silver double-invert"></figure>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-30">
                              <div class="rCC594F embed-image" index="30">
                                <figure role="img" aria-label="iPhone 8" class="compare-image image-header_iphone_8_silver double-invert"></figure>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-31">
                              <div class="r782602 embed-image" index="31">
                                <figure role="img" aria-label="iPhone 7 Plus" class="compare-image image-header_iphone_7_plus_black double-invert"></figure>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-32">
                              <div class="p3C9D72 embed-image" index="32">
                                <figure role="img" aria-label="iPhone 7" class="compare-image image-header_iphone_7_black double-invert"></figure>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-33">
                              <div class="gF0BFC6 embed-image" index="33">
                                <figure role="img" aria-label="iPhone 6s Plus" class="compare-image image-header_iphone_6s_plus_space_gray double-invert"></figure>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-34">
                              <div class="x46467A embed-image" index="34">
                                <figure role="img" aria-label="iPhone 6s" class="compare-image image-header_iphone_6s_space_gray double-invert"></figure>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-35">
                              <div class="x52937F embed-image" index="35">
                                <figure role="img" aria-label="iPhone 6 Plus" class="compare-image image-header_iphone_6_plus_space_gray double-invert"></figure>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-36">
                              <div class="b10C811 embed-image" index="36">
                                <figure role="img" aria-label="iPhone 6" class="compare-image image-header_iphone_6_space_gray double-invert"></figure>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-37">
                              <div class="k91417F embed-image" index="37">
                                <figure role="img" aria-label="iPhone SE (1st generation)" class="compare-image image-header_iphone_se_space_gray double-invert"></figure>
                              </div>
                            </div>
                          </div>
                          <!--END > CATEGORY > IMAGES > FEATURE > IMAGES-->
                        </div>
                        <!--END > CATEGORY > IMAGES-->
                        <!--BEGIN > CATEGORY > FINISH-->
                        <div role="rowgroup" class="compare-section section-finish no-padding-top">
                          <!--BEGIN > CATEGORY > FINISH > FEATURE > COLOR-NAV-->
                          <div role="row" data-column-group="" class="compare-row compare-template-preview-item-color-nav">
                            <div role="rowheader" aria-rowspan="0" class="compare-rowheader">
                              <div class="visuallyhidden">Finish</div>
                            </div>
                            <div role="cell" class="first-child compare-column product-0 compare-column-0">
                              <div product-name="iPhone 16 Pro Max" class="row-colors" index="0">
                                <!---->
                                <div>
                                  <div role="list" aria-label="Available colors for iPhone 16 Pro Max" class="colornav-items">
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Desert Titanium" class="colornav-swatch" style="background-color: rgb(191, 164, 143);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Natural Titanium" class="colornav-swatch" style="background-color: rgb(194, 188, 178);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="White Titanium" class="colornav-swatch" style="background-color: rgb(242, 241, 237);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Black Titanium" class="colornav-swatch" style="background-color: rgb(60, 60, 61);"></figure>
                                      </div>
                                    </div>
                                    <!---->
                                  </div>
                                  <div class="colornav-label-container">
                                    <p class="channel-colornav-label copy">Desert Titanium, Natural Titanium, White Titanium, Black Titanium</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-1 compare-column-1">
                              <div product-name="iPhone 16 Pro" class="row-colors" index="1">
                                <!---->
                                <div>
                                  <div role="list" aria-label="Available colors for iPhone 16 Pro" class="colornav-items">
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Desert Titanium" class="colornav-swatch" style="background-color: rgb(191, 164, 143);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Natural Titanium" class="colornav-swatch" style="background-color: rgb(194, 188, 178);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="White Titanium" class="colornav-swatch" style="background-color: rgb(242, 241, 237);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Black Titanium" class="colornav-swatch" style="background-color: rgb(60, 60, 61);"></figure>
                                      </div>
                                    </div>
                                    <!---->
                                  </div>
                                  <div class="colornav-label-container">
                                    <p class="channel-colornav-label copy">Desert Titanium, Natural Titanium, White Titanium, Black Titanium</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-2 compare-column-2">
                              <div product-name="iPhone 16 Plus" class="row-colors" index="2">
                                <!---->
                                <div>
                                  <div role="list" aria-label="Available colors for iPhone 16 Plus" class="colornav-items">
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Ultramarine" class="colornav-swatch" style="background-color: rgb(154, 173, 246);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Teal" class="colornav-swatch" style="background-color: rgb(176, 212, 210);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Pink" class="colornav-swatch" style="background-color: rgb(242, 173, 218);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="White" class="colornav-swatch" style="background-color: rgb(250, 250, 250);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Black" class="colornav-swatch" style="background-color: rgb(60, 64, 66);"></figure>
                                      </div>
                                    </div>
                                    <!---->
                                  </div>
                                  <div class="colornav-label-container">
                                    <p class="channel-colornav-label copy">Ultramarine, Teal, Pink, White, Black</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-3 compare-column-3">
                              <div product-name="iPhone 16" class="row-colors" index="3">
                                <!---->
                                <div>
                                  <div role="list" aria-label="Available colors for iPhone 16" class="colornav-items">
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Ultramarine" class="colornav-swatch" style="background-color: rgb(154, 173, 246);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Teal" class="colornav-swatch" style="background-color: rgb(176, 212, 210);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Pink" class="colornav-swatch" style="background-color: rgb(242, 173, 218);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="White" class="colornav-swatch" style="background-color: rgb(250, 250, 250);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Black" class="colornav-swatch" style="background-color: rgb(60, 64, 66);"></figure>
                                      </div>
                                    </div>
                                    <!---->
                                  </div>
                                  <div class="colornav-label-container">
                                    <p class="channel-colornav-label copy">Ultramarine, Teal, Pink, White, Black</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-4 compare-column-4">
                              <div product-name="iPhone SE (3rd generation)" class="row-colors" index="4">
                                <!---->
                                <div>
                                  <div role="list" aria-label="Available colors for iPhone SE (3rd generation)" class="colornav-items">
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Midnight" class="colornav-swatch" style="background-color: rgb(35, 42, 49);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Starlight" class="colornav-swatch" style="background-color: rgb(250, 246, 242);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="(PRODUCT)RED" class="colornav-swatch" style="background-color: rgb(191, 0, 19);"></figure>
                                      </div>
                                    </div>
                                    <!---->
                                  </div>
                                  <div class="colornav-label-container">
                                    <p class="channel-colornav-label copy">Midnight, Starlight, (PRODUCT)RED</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-5">
                              <div product-name="iPhone 15 Pro Max" class="row-colors" index="5">
                                <!---->
                                <div>
                                  <div role="list" aria-label="Available colors for iPhone 15 Pro Max" class="colornav-items">
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Natural Titanium" class="colornav-swatch" style="background-color: rgb(186, 180, 169);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Blue Titanium" class="colornav-swatch" style="background-color: rgb(61, 69, 85);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="White Titanium" class="colornav-swatch" style="background-color: rgb(242, 241, 235);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Black Titanium" class="colornav-swatch" style="background-color: rgb(63, 64, 66);"></figure>
                                      </div>
                                    </div>
                                    <!---->
                                  </div>
                                  <div class="colornav-label-container">
                                    <p class="channel-colornav-label copy">Natural Titanium, Blue Titanium, White Titanium, Black Titanium</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-6">
                              <div product-name="iPhone 15 Pro" class="row-colors" index="6">
                                <!---->
                                <div>
                                  <div role="list" aria-label="Available colors for iPhone 15 Pro" class="colornav-items">
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Natural Titanium" class="colornav-swatch" style="background-color: rgb(186, 180, 169);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Blue Titanium" class="colornav-swatch" style="background-color: rgb(61, 69, 85);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="White Titanium" class="colornav-swatch" style="background-color: rgb(242, 241, 235);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Black Titanium" class="colornav-swatch" style="background-color: rgb(63, 64, 66);"></figure>
                                      </div>
                                    </div>
                                    <!---->
                                  </div>
                                  <div class="colornav-label-container">
                                    <p class="channel-colornav-label copy">Natural Titanium, Blue Titanium, White Titanium, Black Titanium</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-7">
                              <div product-name="iPhone 15 Plus" class="row-colors" index="7">
                                <!---->
                                <div>
                                  <div role="list" aria-label="Available colors for iPhone 15 Plus" class="colornav-items">
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Pink" class="colornav-swatch" style="background-color: rgb(235, 208, 210);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Yellow" class="colornav-swatch" style="background-color: rgb(236, 230, 198);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Green" class="colornav-swatch" style="background-color: rgb(207, 217, 201);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Blue" class="colornav-swatch" style="background-color: rgb(213, 221, 224);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Black" class="colornav-swatch" style="background-color: rgb(60, 64, 66);"></figure>
                                      </div>
                                    </div>
                                    <!---->
                                  </div>
                                  <div class="colornav-label-container">
                                    <p class="channel-colornav-label copy">Pink, Yellow, Green, Blue, Black</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-8">
                              <div product-name="iPhone 15" class="row-colors" index="8">
                                <!---->
                                <div>
                                  <div role="list" aria-label="Available colors for iPhone 15" class="colornav-items">
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Pink" class="colornav-swatch" style="background-color: rgb(235, 208, 210);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Yellow" class="colornav-swatch" style="background-color: rgb(236, 230, 198);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Green" class="colornav-swatch" style="background-color: rgb(207, 217, 201);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Blue" class="colornav-swatch" style="background-color: rgb(213, 221, 224);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Black" class="colornav-swatch" style="background-color: rgb(60, 64, 66);"></figure>
                                      </div>
                                    </div>
                                    <!---->
                                  </div>
                                  <div class="colornav-label-container">
                                    <p class="channel-colornav-label copy">Pink, Yellow, Green, Blue, Black</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-9">
                              <div product-name="iPhone 14 Pro Max" class="row-colors" index="9">
                                <!---->
                                <div>
                                  <div role="list" aria-label="Available colors for iPhone 14 Pro Max" class="colornav-items">
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Deep Purple" class="colornav-swatch" style="background-color: rgb(89, 79, 99);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Gold" class="colornav-swatch" style="background-color: rgb(244, 232, 206);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Silver" class="colornav-swatch" style="background-color: rgb(240, 242, 242);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Space Black" class="colornav-swatch" style="background-color: rgb(64, 62, 61);"></figure>
                                      </div>
                                    </div>
                                    <!---->
                                  </div>
                                  <div class="colornav-label-container">
                                    <p class="channel-colornav-label copy">Deep Purple, Gold, Silver, Space Black</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-10">
                              <div product-name="iPhone 14 Pro" class="row-colors" index="10">
                                <!---->
                                <div>
                                  <div role="list" aria-label="Available colors for iPhone 14 Pro" class="colornav-items">
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Deep Purple" class="colornav-swatch" style="background-color: rgb(89, 79, 99);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Gold" class="colornav-swatch" style="background-color: rgb(244, 232, 206);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Silver" class="colornav-swatch" style="background-color: rgb(240, 242, 242);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Space Black" class="colornav-swatch" style="background-color: rgb(64, 62, 61);"></figure>
                                      </div>
                                    </div>
                                    <!---->
                                  </div>
                                  <div class="colornav-label-container">
                                    <p class="channel-colornav-label copy">Deep Purple, Gold, Silver, Space Black</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-11">
                              <div product-name="iPhone 14 Plus" class="row-colors" index="11">
                                <!---->
                                <div>
                                  <div role="list" aria-label="Available colors for iPhone 14 Plus" class="colornav-items">
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Blue" class="colornav-swatch" style="background-color: rgb(160, 180, 199);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Purple" class="colornav-swatch" style="background-color: rgb(230, 221, 235);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Yellow" class="colornav-swatch" style="background-color: rgb(249, 228, 121);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Midnight" class="colornav-swatch" style="background-color: rgb(34, 41, 48);"></figure>
                                      </div>
                                    </div>
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Starlight" class="colornav-swatch" style="background-color: rgb(250, 246, 242);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="(PRODUCT)RED" class="colornav-swatch" style="background-color: rgb(252, 3, 36);"></figure>
                                      </div>
                                    </div>
                                    <!---->
                                  </div>
                                  <div class="colornav-label-container">
                                    <p class="channel-colornav-label copy">Blue, Purple, Yellow, Midnight, Starlight, (PRODUCT)RED</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-12">
                              <div product-name="iPhone 14" class="row-colors" index="12">
                                <!---->
                                <div>
                                  <div role="list" aria-label="Available colors for iPhone 14" class="colornav-items">
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Blue" class="colornav-swatch" style="background-color: rgb(160, 180, 199);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Purple" class="colornav-swatch" style="background-color: rgb(230, 221, 235);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Yellow" class="colornav-swatch" style="background-color: rgb(249, 228, 121);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Midnight" class="colornav-swatch" style="background-color: rgb(34, 41, 48);"></figure>
                                      </div>
                                    </div>
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Starlight" class="colornav-swatch" style="background-color: rgb(250, 246, 242);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="(PRODUCT)RED" class="colornav-swatch" style="background-color: rgb(252, 3, 36);"></figure>
                                      </div>
                                    </div>
                                    <!---->
                                  </div>
                                  <div class="colornav-label-container">
                                    <p class="channel-colornav-label copy">Blue, Purple, Yellow, Midnight, Starlight, (PRODUCT)RED</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-13">
                              <div product-name="iPhone 13 Pro Max" class="row-colors" index="13">
                                <!---->
                                <div>
                                  <div role="list" aria-label="Available colors for iPhone 13 Pro Max" class="colornav-items">
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Alpine Green" class="colornav-swatch" style="background-color: rgb(87, 104, 86);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Silver" class="colornav-swatch" style="background-color: rgb(241, 242, 237);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Gold" class="colornav-swatch" style="background-color: rgb(250, 231, 207);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Graphite" class="colornav-swatch" style="background-color: rgb(84, 82, 79);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Sierra Blue" class="colornav-swatch" style="background-color: rgb(167, 193, 217);"></figure>
                                      </div>
                                    </div>
                                    <!---->
                                  </div>
                                  <div class="colornav-label-container">
                                    <p class="channel-colornav-label copy">Alpine Green, Silver, Gold, Graphite, Sierra Blue</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-14">
                              <div product-name="iPhone 13 Pro" class="row-colors" index="14">
                                <!---->
                                <div>
                                  <div role="list" aria-label="Available colors for iPhone 13 Pro" class="colornav-items">
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Alpine Green" class="colornav-swatch" style="background-color: rgb(87, 104, 86);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Silver" class="colornav-swatch" style="background-color: rgb(241, 242, 237);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Gold" class="colornav-swatch" style="background-color: rgb(250, 231, 207);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Graphite" class="colornav-swatch" style="background-color: rgb(84, 82, 79);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Sierra Blue" class="colornav-swatch" style="background-color: rgb(167, 193, 217);"></figure>
                                      </div>
                                    </div>
                                    <!---->
                                  </div>
                                  <div class="colornav-label-container">
                                    <p class="channel-colornav-label copy">Alpine Green, Silver, Gold, Graphite, Sierra Blue</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-15">
                              <div product-name="iPhone 13" class="row-colors" index="15">
                                <!---->
                                <div>
                                  <div role="list" aria-label="Available colors for iPhone 13" class="colornav-items">
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Green" class="colornav-swatch" style="background-color: rgb(57, 76, 56);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Pink" class="colornav-swatch" style="background-color: rgb(250, 221, 215);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Blue" class="colornav-swatch" style="background-color: rgb(39, 103, 135);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Midnight" class="colornav-swatch" style="background-color: rgb(35, 42, 49);"></figure>
                                      </div>
                                    </div>
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Starlight" class="colornav-swatch" style="background-color: rgb(250, 246, 242);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="(PRODUCT)RED" class="colornav-swatch" style="background-color: rgb(191, 0, 19);"></figure>
                                      </div>
                                    </div>
                                    <!---->
                                  </div>
                                  <div class="colornav-label-container">
                                    <p class="channel-colornav-label copy">Green, Pink, Blue, Midnight, Starlight, (PRODUCT)RED</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-16">
                              <div product-name="iPhone 13 mini" class="row-colors" index="16">
                                <!---->
                                <div>
                                  <div role="list" aria-label="Available colors for iPhone 13 mini" class="colornav-items">
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Green" class="colornav-swatch" style="background-color: rgb(57, 76, 56);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Pink" class="colornav-swatch" style="background-color: rgb(250, 221, 215);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Blue" class="colornav-swatch" style="background-color: rgb(39, 103, 135);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Midnight" class="colornav-swatch" style="background-color: rgb(35, 42, 49);"></figure>
                                      </div>
                                    </div>
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Starlight" class="colornav-swatch" style="background-color: rgb(250, 246, 242);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="(PRODUCT)RED" class="colornav-swatch" style="background-color: rgb(191, 0, 19);"></figure>
                                      </div>
                                    </div>
                                    <!---->
                                  </div>
                                  <div class="colornav-label-container">
                                    <p class="channel-colornav-label copy">Green, Pink, Blue, Midnight, Starlight, (PRODUCT)RED</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-17">
                              <div product-name="iPhone 12 Pro Max" class="row-colors" index="17">
                                <!---->
                                <div>
                                  <div role="list" aria-label="Available colors for iPhone 12 Pro Max" class="colornav-items">
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Pacific Blue" class="colornav-swatch" style="background-color: rgb(45, 78, 92);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Gold" class="colornav-swatch" style="background-color: rgb(252, 235, 211);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Graphite" class="colornav-swatch" style="background-color: rgb(82, 81, 77);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Silver" class="colornav-swatch" style="background-color: rgb(227, 228, 223);"></figure>
                                      </div>
                                    </div>
                                    <!---->
                                  </div>
                                  <div class="colornav-label-container">
                                    <p class="channel-colornav-label copy">Pacific Blue, Gold, Graphite, Silver</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-18">
                              <div product-name="iPhone 12 Pro" class="row-colors" index="18">
                                <!---->
                                <div>
                                  <div role="list" aria-label="Available colors for iPhone 12 Pro" class="colornav-items">
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Pacific Blue" class="colornav-swatch" style="background-color: rgb(45, 78, 92);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Gold" class="colornav-swatch" style="background-color: rgb(252, 235, 211);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Graphite" class="colornav-swatch" style="background-color: rgb(82, 81, 77);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Silver" class="colornav-swatch" style="background-color: rgb(227, 228, 223);"></figure>
                                      </div>
                                    </div>
                                    <!---->
                                  </div>
                                  <div class="colornav-label-container">
                                    <p class="channel-colornav-label copy">Pacific Blue, Gold, Graphite, Silver</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-19">
                              <div product-name="iPhone 12" class="row-colors" index="19">
                                <!---->
                                <div>
                                  <div role="list" aria-label="Available colors for iPhone 12" class="colornav-items">
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Purple" class="colornav-swatch" style="background-color: rgb(183, 175, 230);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Blue" class="colornav-swatch" style="background-color: rgb(2, 59, 99);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Green" class="colornav-swatch" style="background-color: rgb(216, 239, 213);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="(PRODUCT)RED" class="colornav-swatch" style="background-color: rgb(216, 46, 46);"></figure>
                                      </div>
                                    </div>
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="White" class="colornav-swatch" style="background-color: rgb(246, 242, 239);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Black" class="colornav-swatch" style="background-color: rgb(37, 33, 43);"></figure>
                                      </div>
                                    </div>
                                    <!---->
                                  </div>
                                  <div class="colornav-label-container">
                                    <p class="channel-colornav-label copy">Purple, Blue, Green, (PRODUCT)RED, White, Black</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-20">
                              <div product-name="iPhone 12 mini" class="row-colors" index="20">
                                <!---->
                                <div>
                                  <div role="list" aria-label="Available colors for iPhone 12 mini" class="colornav-items">
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Purple" class="colornav-swatch" style="background-color: rgb(183, 175, 230);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Blue" class="colornav-swatch" style="background-color: rgb(2, 59, 99);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Green" class="colornav-swatch" style="background-color: rgb(216, 239, 213);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="(PRODUCT)RED" class="colornav-swatch" style="background-color: rgb(216, 46, 46);"></figure>
                                      </div>
                                    </div>
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="White" class="colornav-swatch" style="background-color: rgb(246, 242, 239);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Black" class="colornav-swatch" style="background-color: rgb(37, 33, 43);"></figure>
                                      </div>
                                    </div>
                                    <!---->
                                  </div>
                                  <div class="colornav-label-container">
                                    <p class="channel-colornav-label copy">Purple, Blue, Green, (PRODUCT)RED, White, Black</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-21">
                              <div product-name="iPhone 11 Pro Max" class="row-colors" index="21">
                                <!---->
                                <div>
                                  <div role="list" aria-label="Available colors for iPhone 11 Pro Max" class="colornav-items">
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Midnight Green" class="colornav-swatch" style="background-color: rgb(78, 88, 81);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Silver" class="colornav-swatch" style="background-color: rgb(235, 235, 227);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Space Gray" class="colornav-swatch" style="background-color: rgb(83, 81, 80);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Gold" class="colornav-swatch" style="background-color: rgb(250, 215, 189);"></figure>
                                      </div>
                                    </div>
                                    <!---->
                                  </div>
                                  <div class="colornav-label-container">
                                    <p class="channel-colornav-label copy">Midnight Green, Silver, Space Gray, Gold</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-22">
                              <div product-name="iPhone 11 Pro" class="row-colors" index="22">
                                <!---->
                                <div>
                                  <div role="list" aria-label="Available colors for iPhone 11 Pro" class="colornav-items">
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Midnight Green" class="colornav-swatch" style="background-color: rgb(78, 88, 81);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Silver" class="colornav-swatch" style="background-color: rgb(235, 235, 227);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Space Gray" class="colornav-swatch" style="background-color: rgb(83, 81, 80);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Gold" class="colornav-swatch" style="background-color: rgb(250, 215, 189);"></figure>
                                      </div>
                                    </div>
                                    <!---->
                                  </div>
                                  <div class="colornav-label-container">
                                    <p class="channel-colornav-label copy">Midnight Green, Silver, Space Gray, Gold</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-23">
                              <div product-name="iPhone 11" class="row-colors" index="23">
                                <!---->
                                <div>
                                  <div role="list" aria-label="Available colors for iPhone 11" class="colornav-items">
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Purple" class="colornav-swatch" style="background-color: rgb(209, 205, 218);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Yellow" class="colornav-swatch" style="background-color: rgb(255, 230, 129);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Green" class="colornav-swatch" style="background-color: rgb(174, 225, 205);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Black" class="colornav-swatch" style="background-color: rgb(31, 32, 32);"></figure>
                                      </div>
                                    </div>
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="White" class="colornav-swatch" style="background-color: rgb(249, 246, 239);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="(PRODUCT)RED" class="colornav-swatch" style="background-color: rgb(186, 12, 46);"></figure>
                                      </div>
                                    </div>
                                    <!---->
                                  </div>
                                  <div class="colornav-label-container">
                                    <p class="channel-colornav-label copy">Purple, Yellow, Green, Black, White, (PRODUCT)RED</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-24">
                              <div product-name="iPhone SE (2nd generation)" class="row-colors" index="24">
                                <!---->
                                <div>
                                  <div role="list" aria-label="Available colors for iPhone SE (2nd generation)" class="colornav-items">
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Black" class="colornav-swatch" style="background-color: rgb(38, 37, 41);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="White" class="colornav-swatch" style="background-color: rgb(243, 243, 243);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="(PRODUCT)RED" class="colornav-swatch" style="background-color: rgb(180, 19, 37);"></figure>
                                      </div>
                                    </div>
                                    <!---->
                                  </div>
                                  <div class="colornav-label-container">
                                    <p class="channel-colornav-label copy">Black, White, (PRODUCT)RED</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-25">
                              <div product-name="iPhone XS Max" class="row-colors" index="25">
                                <!---->
                                <div>
                                  <div role="list" aria-label="Available colors for iPhone XS Max" class="colornav-items">
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Silver" class="colornav-swatch" style="background-color: rgb(228, 228, 226);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Space Gray" class="colornav-swatch" style="background-color: rgb(38, 37, 41);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Gold" class="colornav-swatch" style="background-color: rgb(250, 220, 194);"></figure>
                                      </div>
                                    </div>
                                    <!---->
                                  </div>
                                  <div class="colornav-label-container">
                                    <p class="channel-colornav-label copy">Silver, Space Gray, Gold</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-26">
                              <div product-name="iPhone XS" class="row-colors" index="26">
                                <!---->
                                <div>
                                  <div role="list" aria-label="Available colors for iPhone XS" class="colornav-items">
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Silver" class="colornav-swatch" style="background-color: rgb(228, 228, 226);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Space Gray" class="colornav-swatch" style="background-color: rgb(38, 37, 41);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Gold" class="colornav-swatch" style="background-color: rgb(250, 220, 194);"></figure>
                                      </div>
                                    </div>
                                    <!---->
                                  </div>
                                  <div class="colornav-label-container">
                                    <p class="channel-colornav-label copy">Silver, Space Gray, Gold</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-27">
                              <div product-name="iPhone XR" class="row-colors" index="27">
                                <!---->
                                <div>
                                  <div role="list" aria-label="Available colors for iPhone XR" class="colornav-items">
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Blue" class="colornav-swatch" style="background-color: rgb(72, 174, 230);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="White" class="colornav-swatch" style="background-color: rgb(243, 243, 243);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Black" class="colornav-swatch" style="background-color: rgb(46, 48, 52);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Yellow" class="colornav-swatch" style="background-color: rgb(249, 208, 69);"></figure>
                                      </div>
                                    </div>
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Coral" class="colornav-swatch" style="background-color: rgb(255, 110, 90);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="(PRODUCT)RED" class="colornav-swatch" style="background-color: rgb(180, 19, 37);"></figure>
                                      </div>
                                    </div>
                                    <!---->
                                  </div>
                                  <div class="colornav-label-container">
                                    <p class="channel-colornav-label copy">Blue, White, Black, Yellow, Coral, (PRODUCT)RED</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-28">
                              <div product-name="iPhone X" class="row-colors" index="28">
                                <!---->
                                <div>
                                  <div role="list" aria-label="Available colors for iPhone X" class="colornav-items">
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Silver" class="colornav-swatch" style="background-color: rgb(228, 228, 226);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Space Gray" class="colornav-swatch" style="background-color: rgb(38, 37, 41);"></figure>
                                      </div>
                                    </div>
                                    <!---->
                                  </div>
                                  <div class="colornav-label-container">
                                    <p class="channel-colornav-label copy">Silver, Space Gray</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-29">
                              <div product-name="iPhone 8 Plus" class="row-colors" index="29">
                                <!---->
                                <div>
                                  <div role="list" aria-label="Available colors for iPhone 8 Plus" class="colornav-items">
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Silver" class="colornav-swatch" style="background-color: rgb(226, 227, 228);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Space Gray" class="colornav-swatch" style="background-color: rgb(39, 39, 41);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Gold" class="colornav-swatch" style="background-color: rgb(247, 232, 221);"></figure>
                                      </div>
                                    </div>
                                    <!---->
                                  </div>
                                  <div class="colornav-label-container">
                                    <p class="channel-colornav-label copy">Silver, Space Gray, Gold</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-30">
                              <div product-name="iPhone 8" class="row-colors" index="30">
                                <!---->
                                <div>
                                  <div role="list" aria-label="Available colors for iPhone 8" class="colornav-items">
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Silver" class="colornav-swatch" style="background-color: rgb(226, 227, 228);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Space Gray" class="colornav-swatch" style="background-color: rgb(39, 39, 41);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Gold" class="colornav-swatch" style="background-color: rgb(247, 232, 221);"></figure>
                                      </div>
                                    </div>
                                    <!---->
                                  </div>
                                  <div class="colornav-label-container">
                                    <p class="channel-colornav-label copy">Silver, Space Gray, Gold</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-31">
                              <div product-name="iPhone 7 Plus" class="row-colors" index="31">
                                <!---->
                                <div>
                                  <div role="list" aria-label="Available colors for iPhone 7 Plus" class="colornav-items">
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Silver" class="colornav-swatch" style="background-color: rgb(226, 227, 228);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Black" class="colornav-swatch" style="background-color: rgb(46, 48, 52);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Gold" class="colornav-swatch" style="background-color: rgb(227, 204, 180);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Rose Gold" class="colornav-swatch" style="background-color: rgb(236, 198, 193);"></figure>
                                      </div>
                                    </div>
                                    <!---->
                                  </div>
                                  <div class="colornav-label-container">
                                    <p class="channel-colornav-label copy">Silver, Black, Gold, Rose Gold</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-32">
                              <div product-name="iPhone 7" class="row-colors" index="32">
                                <!---->
                                <div>
                                  <div role="list" aria-label="Available colors for iPhone 7" class="colornav-items">
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Silver" class="colornav-swatch" style="background-color: rgb(226, 227, 228);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Black" class="colornav-swatch" style="background-color: rgb(46, 48, 52);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Gold" class="colornav-swatch" style="background-color: rgb(227, 204, 180);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Rose Gold" class="colornav-swatch" style="background-color: rgb(236, 198, 193);"></figure>
                                      </div>
                                    </div>
                                    <!---->
                                  </div>
                                  <div class="colornav-label-container">
                                    <p class="channel-colornav-label copy">Silver, Black, Gold, Rose Gold</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-33">
                              <div product-name="iPhone 6s Plus" class="row-colors" index="33">
                                <!---->
                                <div>
                                  <div role="list" aria-label="Available colors for iPhone 6s Plus" class="colornav-items">
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Silver" class="colornav-swatch" style="background-color: rgb(226, 227, 228);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Space gray" class="colornav-swatch" style="background-color: rgb(177, 178, 183);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Gold" class="colornav-swatch" style="background-color: rgb(227, 204, 180);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Rose Gold" class="colornav-swatch" style="background-color: rgb(236, 198, 193);"></figure>
                                      </div>
                                    </div>
                                    <!---->
                                  </div>
                                  <div class="colornav-label-container">
                                    <p class="channel-colornav-label copy">Silver, Space Gray, Gold, Rose Gold</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-34">
                              <div product-name="iPhone 6s" class="row-colors" index="34">
                                <!---->
                                <div>
                                  <div role="list" aria-label="Available colors for iPhone 6s" class="colornav-items">
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Silver" class="colornav-swatch" style="background-color: rgb(226, 227, 228);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Space gray" class="colornav-swatch" style="background-color: rgb(177, 178, 183);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Gold" class="colornav-swatch" style="background-color: rgb(227, 204, 180);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Rose Gold" class="colornav-swatch" style="background-color: rgb(236, 198, 193);"></figure>
                                      </div>
                                    </div>
                                    <!---->
                                  </div>
                                  <div class="colornav-label-container">
                                    <p class="channel-colornav-label copy">Silver, Space Gray, Gold, Rose Gold</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-35">
                              <div product-name="iPhone 6 Plus" class="row-colors" index="35">
                                <!---->
                                <div>
                                  <div role="list" aria-label="Available colors for iPhone 6 Plus" class="colornav-items">
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Silver" class="colornav-swatch" style="background-color: rgb(226, 227, 228);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Space gray" class="colornav-swatch" style="background-color: rgb(177, 178, 183);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Gold" class="colornav-swatch" style="background-color: rgb(227, 204, 180);"></figure>
                                      </div>
                                    </div>
                                    <!---->
                                  </div>
                                  <div class="colornav-label-container">
                                    <p class="channel-colornav-label copy">Silver, Space Gray, Gold</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-36">
                              <div product-name="iPhone 6" class="row-colors" index="36">
                                <!---->
                                <div>
                                  <div role="list" aria-label="Available colors for iPhone 6" class="colornav-items">
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Silver" class="colornav-swatch" style="background-color: rgb(226, 227, 228);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Space gray" class="colornav-swatch" style="background-color: rgb(177, 178, 183);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Gold" class="colornav-swatch" style="background-color: rgb(227, 204, 180);"></figure>
                                      </div>
                                    </div>
                                    <!---->
                                  </div>
                                  <div class="colornav-label-container">
                                    <p class="channel-colornav-label copy">Silver, Space Gray, Gold</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-37">
                              <div product-name="iPhone SE (1st generation)" class="row-colors" index="37">
                                <!---->
                                <div>
                                  <div role="list" aria-label="Available colors for iPhone SE (1st generation)" class="colornav-items">
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Silver" class="colornav-swatch" style="background-color: rgb(228, 228, 226);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Space Gray" class="colornav-swatch" style="background-color: rgb(38, 37, 41);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Gold" class="colornav-swatch" style="background-color: rgb(250, 220, 194);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Rose Gold" class="colornav-swatch" style="background-color: rgb(236, 198, 193);"></figure>
                                      </div>
                                    </div>
                                    <!---->
                                  </div>
                                  <div class="colornav-label-container">
                                    <p class="channel-colornav-label copy">Silver, Space Gray, Gold, Rose Gold</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!--END > CATEGORY > FINISH > FEATURE > COLOR-NAV-->
                        </div>
                        <!--END > CATEGORY > FINISH-->
                        <!--BEGIN > CATEGORY > BUY-->
                        <div role="rowgroup" class="compare-section section-buy no-padding-top">
                          <!--BEGIN > CATEGORY > BUY > FEATURE > BUY-->
                          <div role="row" data-column-group="" class="compare-row compare-template-border-top compare-template-preview-item-default">
                            <div role="rowheader" aria-rowspan="0" class="compare-rowheader">
                              <div class="visuallyhidden">Buy</div>
                            </div>
                            <div role="cell" class="first-child compare-column product-0 compare-column-0">
                              <div class="button-container" index="0" product-name="iPhone 16 Pro Max"><a id="iPhone 16 Pro Max" href="#" aria-label="Buy, iPhone 16 Pro Max" class="button compare-button">Buy</a></div>
                            </div>
                            <div role="cell" class="compare-column product-1 compare-column-1">
                              <div class="button-container" index="1" product-name="iPhone 16 Pro"><a id="iPhone 16 Pro" href="#" aria-label="Buy, iPhone 16 Pro" class="button compare-button">Buy</a></div>
                            </div>
                            <div role="cell" class="compare-column product-2 compare-column-2">
                              <div class="button-container" index="2" product-name="iPhone 16 Plus"><a id="iPhone 16 Plus" href="#" aria-label="Buy, iPhone 16 Plus" class="button compare-button">Buy</a></div>
                            </div>
                            <div role="cell" class="compare-column product-3 compare-column-3">
                              <div class="button-container" index="3" product-name="iPhone 16"><a id="iPhone 16" href="#" aria-label="Buy, iPhone 16" class="button compare-button">Buy</a></div>
                            </div>
                            <div role="cell" class="compare-column product-4 compare-column-4">
                              <div class="button-container" index="4" product-name="iPhone SE (3rd generation)"><a id="iPhone SE (3rd generation)" href="#" aria-label="Buy, iPhone SE (3rd generation)" class="button compare-button">Buy</a></div>
                            </div>
                            <div role="cell" class="compare-column product-5">
                              <div class="button-container" index="5" product-name="iPhone 15 Pro Max"><a id="iPhone 15 Pro Max" href="#" aria-label="Buy, iPhone 15 Pro Max" class="button compare-button">Buy</a></div>
                            </div>
                            <div role="cell" class="compare-column product-6">
                              <div class="button-container" index="6" product-name="iPhone 15 Pro"><a id="iPhone 15 Pro" href="#" aria-label="Buy, iPhone 15 Pro" class="button compare-button">Buy</a></div>
                            </div>
                            <div role="cell" class="compare-column product-7">
                              <div class="button-container" index="7" product-name="iPhone 15 Plus"><a id="iPhone 15 Plus" href="#" aria-label="Buy, iPhone 15 Plus" class="button compare-button">Buy</a></div>
                            </div>
                            <div role="cell" class="compare-column product-8">
                              <div class="button-container" index="8" product-name="iPhone 15"><a id="iPhone 15" href="#" aria-label="Buy, iPhone 15" class="button compare-button">Buy</a></div>
                            </div>
                            <div role="cell" class="compare-column product-9">
                              <div class="button-container" index="9" product-name="iPhone 14 Pro Max"><a id="iPhone 14 Pro Max" href="#" aria-label="Buy, iPhone 14 Pro Max" class="button compare-button">Buy</a></div>
                            </div>
                            <div role="cell" class="compare-column product-10">
                              <div class="button-container" index="10" product-name="iPhone 14 Pro"><a id="iPhone 14 Pro" href="#" aria-label="Buy, iPhone 14 Pro" class="button compare-button">Buy</a></div>
                            </div>
                            <div role="cell" class="compare-column product-11">
                              <div class="button-container" index="11" product-name="iPhone 14 Plus"><a id="iPhone 14 Plus" href="#" aria-label="Buy, iPhone 14 Plus" class="button compare-button">Buy</a></div>
                            </div>
                            <div role="cell" class="compare-column product-12">
                              <div class="button-container" index="12" product-name="iPhone 14"><a id="iPhone 14" href="#" aria-label="Buy, iPhone 14" class="button compare-button">Buy</a></div>
                            </div>
                            <div role="cell" class="compare-column product-13">
                              <div class="button-container" index="13" product-name="iPhone 13 Pro Max"><a id="iPhone 13 Pro Max" href="#" aria-label="Buy, iPhone 13 Pro Max" class="button compare-button">Buy</a></div>
                            </div>
                            <div role="cell" class="compare-column product-14">
                              <div class="button-container" index="14" product-name="iPhone 13 Pro"><a id="iPhone 13 Pro" href="#" aria-label="Buy, iPhone 13 Pro" class="button compare-button">Buy</a></div>
                            </div>
                            <div role="cell" class="compare-column product-15">
                              <div class="button-container" index="15" product-name="iPhone 13"><a id="iPhone 13" href="#" aria-label="Buy, iPhone 13" class="button compare-button">Buy</a></div>
                            </div>
                            <div role="cell" class="compare-column product-16">
                              <div class="button-container" index="16" product-name="iPhone 13 mini"><a id="iPhone 13 mini" href="#" aria-label="Buy, iPhone 13 mini" class="button compare-button">Buy</a></div>
                            </div>
                            <div role="cell" class="compare-column product-17">
                              <div class="button-container" index="17" product-name="iPhone 12 Pro Max"><a id="iPhone 12 Pro Max" href="#" aria-label="Buy, iPhone 12 Pro Max" class="button compare-button">Buy</a></div>
                            </div>
                            <div role="cell" class="compare-column product-18">
                              <div class="button-container" index="18" product-name="iPhone 12 Pro"><a id="iPhone 12 Pro" href="#" aria-label="Buy, iPhone 12 Pro" class="button compare-button">Buy</a></div>
                            </div>
                            <div role="cell" class="compare-column product-19">
                              <div class="button-container" index="19" product-name="iPhone 12"><a id="iPhone 12" href="#" aria-label="Buy, iPhone 12" class="button compare-button">Buy</a></div>
                            </div>
                            <div role="cell" class="compare-column product-20">
                              <div class="button-container" index="20" product-name="iPhone 12 mini"><a id="iPhone 12 mini" href="#" aria-label="Buy, iPhone 12 mini" class="button compare-button">Buy</a></div>
                            </div>
                            <div role="cell" class="compare-column product-21">
                              <div class="button-container" index="21" product-name="iPhone 11 Pro Max"><a id="iPhone 11 Pro Max" href="#" aria-label="Buy, iPhone 11 Pro Max" class="button compare-button">Buy</a></div>
                            </div>
                            <div role="cell" class="compare-column product-22">
                              <div class="button-container" index="22" product-name="iPhone 11 Pro"><a id="iPhone 11 Pro" href="#" aria-label="Buy, iPhone 11 Pro" class="button compare-button">Buy</a></div>
                            </div>
                            <div role="cell" class="compare-column product-23">
                              <div class="button-container" index="23" product-name="iPhone 11"><a id="iPhone 11" href="#" aria-label="Buy, iPhone 11" class="button compare-button">Buy</a></div>
                            </div>
                            <div role="cell" class="compare-column product-24">
                              <div class="button-container" index="24" product-name="iPhone SE (2nd generation)"><a id="iPhone SE (2nd generation)" href="#" aria-label="Buy, iPhone SE (2nd generation)" class="button compare-button">Buy</a></div>
                            </div>
                            <div role="cell" class="compare-column product-25">
                              <div class="button-container" index="25" product-name="iPhone XS Max"><a id="iPhone XS Max" href="#" aria-label="Buy, iPhone XS Max" class="button compare-button">Buy</a></div>
                            </div>
                            <div role="cell" class="compare-column product-26">
                              <div class="button-container" index="26" product-name="iPhone XS"><a id="iPhone XS" href="#" aria-label="Buy, iPhone XS" class="button compare-button">Buy</a></div>
                            </div>
                            <div role="cell" class="compare-column product-27">
                              <div class="button-container" index="27" product-name="iPhone XR"><a id="iPhone XR" href="#" aria-label="Buy, iPhone XR" class="button compare-button">Buy</a></div>
                            </div>
                            <div role="cell" class="compare-column product-28">
                              <div class="button-container" index="28" product-name="iPhone X"><a id="iPhone X" href="#" aria-label="Buy, iPhone X" class="button compare-button">Buy</a></div>
                            </div>
                            <div role="cell" class="compare-column product-29">
                              <div class="button-container" index="29" product-name="iPhone 8 Plus"><a id="iPhone 8 Plus" href="#" aria-label="Buy, iPhone 8 Plus" class="button compare-button">Buy</a></div>
                            </div>
                            <div role="cell" class="compare-column product-30">
                              <div class="button-container" index="30" product-name="iPhone 8"><a id="iPhone 8" href="#" aria-label="Buy, iPhone 8" class="button compare-button">Buy</a></div>
                            </div>
                            <div role="cell" class="compare-column product-31">
                              <div class="button-container" index="31" product-name="iPhone 7 Plus"><a id="iPhone 7 Plus" href="#" aria-label="Buy, iPhone 7 Plus" class="button compare-button">Buy</a></div>
                            </div>
                            <div role="cell" class="compare-column product-32">
                              <div class="button-container" index="32" product-name="iPhone 7"><a id="iPhone 7" href="#" aria-label="Buy, iPhone 7" class="button compare-button">Buy</a></div>
                            </div>
                            <div role="cell" class="compare-column product-33">
                              <div class="button-container" index="33" product-name="iPhone 6s Plus"><a id="iPhone 6s Plus" href="#" aria-label="Buy, iPhone 6s Plus" class="button compare-button">Buy</a></div>
                            </div>
                            <div role="cell" class="compare-column product-34">
                              <div class="button-container" index="34" product-name="iPhone 6s"><a id="iPhone 6s" href="#" aria-label="Buy, iPhone 6s" class="button compare-button">Buy</a></div>
                            </div>
                            <div role="cell" class="compare-column product-35">
                              <div class="button-container" index="35" product-name="iPhone 6 Plus"><a id="iPhone 6 Plus" href="#" aria-label="Buy, iPhone 6 Plus" class="button compare-button">Buy</a></div>
                            </div>
                            <div role="cell" class="compare-column product-36">
                              <div class="button-container" index="36" product-name="iPhone 6"><a id="iPhone 6" href="#" aria-label="Buy, iPhone 6" class="button compare-button">Buy</a></div>
                            </div>
                            <div role="cell" class="compare-column product-37">
                              <div class="button-container" index="37" product-name="iPhone SE (1st generation)"><a id="iPhone SE (1st generation)" href="#" aria-label="Buy, iPhone SE (1st generation)" class="button compare-button">Buy</a></div>
                            </div>
                          </div>
                          <!--END > CATEGORY > BUY > FEATURE > BUY-->
                        </div>
                        <!--END > CATEGORY > BUY-->
                        <!--BEGIN > CATEGORY > QUICK-LOOK-->
                        <div role="rowgroup" class="compare-section section-quick-look no-padding-top multi-row">
                          <!--BEGIN > CATEGORY > QUICK-LOOK > FEATURE > DISPLAY-->
                          <div role="row" data-column-group="" class="compare-row compare-template-preview-item-stat">
                            <div role="rowheader" aria-rowspan="0" class="compare-rowheader">
                              <div class="visuallyhidden">Quick look</div>
                            </div>
                            <div role="cell" class="first-child compare-column product-0 compare-column-0">
                              <div role="presentation" class="stat" index="0">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <!----><span class="stat-value">17.43 cm</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">(6.9″) Super Retina XDR&nbsp;display<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">ProMotion technology</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Always-On display</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-1 compare-column-1">
                              <div role="presentation" class="stat" index="1">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <!----><span class="stat-value">15.93cm</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">(6.3″) Super Retina XDR&nbsp;display<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">ProMotion technology</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Always-On display</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-2 compare-column-2">
                              <div role="presentation" class="stat" index="2">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <!----><span class="stat-value">17.00cm</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">(6.7″) Super Retina XDR&nbsp;display<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers </span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-3 compare-column-3">
                              <div role="presentation" class="stat" index="3">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <!----><span class="stat-value"><span style="letter-spacing:0px">15.54cm</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">(6.1″) Super Retina XDR&nbsp;display<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers </span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-4 compare-column-4">
                              <div role="presentation" class="stat" index="4">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <!----><span class="stat-value">11.94cm</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">(4.7″) Retina HD&nbsp;display</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-5">
                              <div role="presentation" class="stat" index="5">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <!----><span class="stat-value">17.00cm</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">(6.7″) Super Retina XDR&nbsp;display<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers </span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">ProMotion technology</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Always-On display</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-6">
                              <div role="presentation" class="stat" index="6">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <!----><span class="stat-value"><span style="letter-spacing:0px">15.54cm</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">(6.1″) Super Retina XDR&nbsp;display<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers </span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">ProMotion technology</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Always-On display</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-7">
                              <div role="presentation" class="stat" index="7">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <!----><span class="stat-value">17.00cm</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">(6.7″) Super Retina XDR&nbsp;display<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers </span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-8">
                              <div role="presentation" class="stat" index="8">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <!----><span class="stat-value"><span style="letter-spacing:0px">15.54cm</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">(6.1″) Super Retina XDR&nbsp;display<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers </span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-9">
                              <div role="presentation" class="stat" index="9">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <!----><span class="stat-value">17.00cm</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">(6.7″) Super Retina XDR&nbsp;display<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers </span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">ProMotion technology</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Always-On display</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-10">
                              <div role="presentation" class="stat" index="10">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <!----><span class="stat-value"><span style="letter-spacing:0px">15.54cm</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">(6.1″) Super Retina XDR&nbsp;display<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers </span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">ProMotion technology</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Always-On display</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-11">
                              <div role="presentation" class="stat" index="11">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <!----><span class="stat-value">16.95cm</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">(6.7″) Super Retina XDR&nbsp;display<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers </span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-12">
                              <div role="presentation" class="stat" index="12">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <!----><span class="stat-value"><span style="letter-spacing:0px">15.40cm</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">(6.1″) Super Retina XDR&nbsp;display<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers </span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-13">
                              <div role="presentation" class="stat" index="13">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <!----><span class="stat-value">16.95cm</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">(6.7″) Super Retina XDR&nbsp;display<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers </span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">ProMotion technology</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-14">
                              <div role="presentation" class="stat" index="14">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <!----><span class="stat-value"><span style="letter-spacing:0px">15.40cm</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">(6.1″) Super Retina XDR&nbsp;display<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers </span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">ProMotion technology</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-15">
                              <div role="presentation" class="stat" index="15">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <!----><span class="stat-value"><span style="letter-spacing:0px">15.40cm</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">(6.1″) Super Retina XDR&nbsp;display<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers </span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-16">
                              <div role="presentation" class="stat" index="16">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <!----><span class="stat-value">13.76cm</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">(5.4″) Super Retina XDR&nbsp;display<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers </span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-17">
                              <div role="presentation" class="stat" index="17">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <!----><span class="stat-value">16.95cm</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">(6.7″) Super Retina XDR&nbsp;display<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers </span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-18">
                              <div role="presentation" class="stat" index="18">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <!----><span class="stat-value"><span style="letter-spacing:0px">15.40cm</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">(6.1″) Super Retina XDR&nbsp;display<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers </span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-19">
                              <div role="presentation" class="stat" index="19">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <!----><span class="stat-value"><span style="letter-spacing:0px">15.40cm</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">(6.1″) Super Retina XDR&nbsp;display<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers </span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-20">
                              <div role="presentation" class="stat" index="20">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <!----><span class="stat-value">13.76cm</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">(5.4″) Super Retina XDR&nbsp;display<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers </span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-21">
                              <div role="presentation" class="stat" index="21">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <!----><span class="stat-value">16.40cm</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">(6.5″) Super Retina XDR&nbsp;display<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers </span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-22">
                              <div role="presentation" class="stat" index="22">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <!----><span class="stat-value">14.86cm</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">(5.8″) Super Retina XDR&nbsp;display<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers </span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-23">
                              <div role="presentation" class="stat" index="23">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <!----><span class="stat-value"><span style="letter-spacing:0px">15.40cm</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">(6.1″) Liquid Retina HD&nbsp;display<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers </span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-24">
                              <div role="presentation" class="stat" index="24">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <!----><span class="stat-value">11.94cm</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">(4.7″) Retina HD&nbsp;display</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-25">
                              <div role="presentation" class="stat" index="25">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <!----><span class="stat-value">16.40cm</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">(6.5″) Super Retina HD&nbsp;display<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers </span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-26">
                              <div role="presentation" class="stat" index="26">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <!----><span class="stat-value">14.86cm</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">(5.8″) Super Retina HD&nbsp;display<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers </span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-27">
                              <div role="presentation" class="stat" index="27">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <!----><span class="stat-value"><span style="letter-spacing:0px">15.40cm</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">(6.1″) Liquid Retina HD&nbsp;display<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers </span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-28">
                              <div role="presentation" class="stat" index="28">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <!----><span class="stat-value">14.86cm</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">(5.8″) Super Retina HD&nbsp;display<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers </span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-29">
                              <div role="presentation" class="stat" index="29">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <!----><span class="stat-value">13.94cm</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">(5.5″) Retina HD&nbsp;display</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-30">
                              <div role="presentation" class="stat" index="30">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <!----><span class="stat-value">11.94cm</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">(4.7″) Retina HD&nbsp;display</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-31">
                              <div role="presentation" class="stat" index="31">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <!----><span class="stat-value">13.94cm</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Retina HD&nbsp;display</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-32">
                              <div role="presentation" class="stat" index="32">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <!----><span class="stat-value">11.94cm</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">(4.7″) Retina HD&nbsp;display</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-33">
                              <div role="presentation" class="stat" index="33">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <!----><span class="stat-value">13.94cm</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">(5.5″) Retina HD&nbsp;display</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-34">
                              <div role="presentation" class="stat" index="34">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <!----><span class="stat-value">11.94cm</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">(4.7″) Retina HD&nbsp;display</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-35">
                              <div role="presentation" class="stat" index="35">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <!----><span class="stat-value">13.94cm</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">(5.5″) Retina HD&nbsp;display</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-36">
                              <div role="presentation" class="stat" index="36">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <!----><span class="stat-value">11.94cm</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">(4.7″) Retina HD&nbsp;display</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-37">
                              <div role="presentation" class="stat" index="37">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <!----><span class="stat-value">10.16cm</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">(4″) Retina&nbsp;display</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!--END > CATEGORY > QUICK-LOOK > FEATURE > DISPLAY-->
                          
                          <!--BEGIN > CATEGORY > QUICK-LOOK > FEATURE > CHIP-->
                          <div role="row" data-column-group="" class="compare-row compare-template-preview-item-stat">
                            <div role="rowheader" aria-rowspan="0" class="compare-rowheader">
                              <div class="visuallyhidden">Chip</div>
                            </div>
                            <div role="cell" class="first-child compare-column product-0 compare-column-0">
                              <div role="presentation" class="stat" index="0">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper zDC7336 embed-image">
                                      <figure class="compare-image image-icon_chip_a18pro_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">A18&nbsp;Pro chip</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">6‑core GPU</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-1 compare-column-1">
                              <div role="presentation" class="stat" index="1">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper aBA6A30 embed-image">
                                      <figure class="compare-image image-icon_chip_a18pro_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">A18&nbsp;Pro chip</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">6‑core GPU</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-2 compare-column-2">
                              <div role="presentation" class="stat" index="2">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper f4CC6C9 embed-image">
                                      <figure class="compare-image image-icon_chip_a18_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">A18 chip</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">5‑core GPU</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-3 compare-column-3">
                              <div role="presentation" class="stat" index="3">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper oBABD7B embed-image">
                                      <figure class="compare-image image-icon_chip_a18_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">A18 chip</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">5‑core GPU</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-4 compare-column-4">
                              <div role="presentation" class="stat" index="4">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper m40B73D embed-image">
                                      <figure class="compare-image image-icon_chip_a15_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">A15&nbsp;Bionic chip</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">4‑core GPU</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-5">
                              <div role="presentation" class="stat" index="5">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper d8977A6 embed-image">
                                      <figure class="compare-image image-icon_chip_a17pro_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">A17&nbsp;Pro chip</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">6‑core GPU</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-6">
                              <div role="presentation" class="stat" index="6">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper iE3B574 embed-image">
                                      <figure class="compare-image image-icon_chip_a17pro_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">A17&nbsp;Pro chip</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">6‑core GPU</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-7">
                              <div role="presentation" class="stat" index="7">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper m18CD9B embed-image">
                                      <figure class="compare-image image-icon_chip_a16_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">A16&nbsp;Bionic chip</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">5‑core GPU</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-8">
                              <div role="presentation" class="stat" index="8">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper h555EC8 embed-image">
                                      <figure class="compare-image image-icon_chip_a16_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">A16&nbsp;Bionic chip</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">5‑core GPU</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-9">
                              <div role="presentation" class="stat" index="9">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper f5922AB embed-image">
                                      <figure class="compare-image image-icon_chip_a16_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">A16&nbsp;Bionic chip</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">5‑core GPU</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-10">
                              <div role="presentation" class="stat" index="10">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper wF43E6A embed-image">
                                      <figure class="compare-image image-icon_chip_a16_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">A16&nbsp;Bionic chip</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">5‑core GPU</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-11">
                              <div role="presentation" class="stat" index="11">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper g59347F embed-image">
                                      <figure class="compare-image image-icon_chip_a15_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">A15&nbsp;Bionic chip</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">5‑core GPU</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-12">
                              <div role="presentation" class="stat" index="12">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper n1D6848 embed-image">
                                      <figure class="compare-image image-icon_chip_a15_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">A15&nbsp;Bionic chip</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">5‑core GPU</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-13">
                              <div role="presentation" class="stat" index="13">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper g5ABB6F embed-image">
                                      <figure class="compare-image image-icon_chip_a15_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">A15&nbsp;Bionic chip</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">5‑core GPU</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-14">
                              <div role="presentation" class="stat" index="14">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper oB30A36 embed-image">
                                      <figure class="compare-image image-icon_chip_a15_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">A15&nbsp;Bionic chip</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">5‑core GPU</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-15">
                              <div role="presentation" class="stat" index="15">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper uF271FC embed-image">
                                      <figure class="compare-image image-icon_chip_a15_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">A15&nbsp;Bionic chip</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">4‑core GPU</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-16">
                              <div role="presentation" class="stat" index="16">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper k887B16 embed-image">
                                      <figure class="compare-image image-icon_chip_a15_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">A15&nbsp;Bionic chip</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">4‑core GPU</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-17">
                              <div role="presentation" class="stat" index="17">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper j8842ED embed-image">
                                      <figure class="compare-image image-icon_chip_a14_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">A14&nbsp;Bionic chip</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">4‑core GPU</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-18">
                              <div role="presentation" class="stat" index="18">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper lD9EC43 embed-image">
                                      <figure class="compare-image image-icon_chip_a14_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">A14&nbsp;Bionic chip</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">4‑core GPU</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-19">
                              <div role="presentation" class="stat" index="19">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper n8F5BFE embed-image">
                                      <figure class="compare-image image-icon_chip_a14_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">A14&nbsp;Bionic chip</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">4‑core GPU</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-20">
                              <div role="presentation" class="stat" index="20">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper i8BBF40 embed-image">
                                      <figure class="compare-image image-icon_chip_a14_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">A14&nbsp;Bionic chip</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">4‑core GPU</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-21">
                              <div role="presentation" class="stat" index="21">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper iCB4ED1 embed-image">
                                      <figure class="compare-image image-icon_chip_a13_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">A13&nbsp;Bionic chip</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">4‑core GPU</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-22">
                              <div role="presentation" class="stat" index="22">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper g02B405 embed-image">
                                      <figure class="compare-image image-icon_chip_a13_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">A13&nbsp;Bionic chip</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">4‑core GPU</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-23">
                              <div role="presentation" class="stat" index="23">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper c6C5E36 embed-image">
                                      <figure class="compare-image image-icon_chip_a13_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">A13&nbsp;Bionic chip</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">4‑core GPU</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-24">
                              <div role="presentation" class="stat" index="24">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper dC32F78 embed-image">
                                      <figure class="compare-image image-icon_chip_a13_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">A13&nbsp;Bionic chip</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">4‑core GPU</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-25">
                              <div role="presentation" class="stat" index="25">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper rE699E9 embed-image">
                                      <figure class="compare-image image-icon_chip_a12_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">A12&nbsp;Bionic chip</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">4‑core GPU</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-26">
                              <div role="presentation" class="stat" index="26">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper k67EF9C embed-image">
                                      <figure class="compare-image image-icon_chip_a12_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">A12&nbsp;Bionic chip</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">4‑core GPU</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-27">
                              <div role="presentation" class="stat" index="27">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper iA36AED embed-image">
                                      <figure class="compare-image image-icon_chip_a12_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">A12&nbsp;Bionic chip</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">4‑core GPU</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-28">
                              <div role="presentation" class="stat" index="28">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper l6E875F embed-image">
                                      <figure class="compare-image image-icon_chip_a11_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">A11&nbsp;Bionic chip</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">3‑core GPU</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-29">
                              <div role="presentation" class="stat" index="29">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper j5948ED embed-image">
                                      <figure class="compare-image image-icon_chip_a11_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">A11&nbsp;Bionic chip</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">3‑core GPU</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-30">
                              <div role="presentation" class="stat" index="30">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper f061362 embed-image">
                                      <figure class="compare-image image-icon_chip_a11_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">A11&nbsp;Bionic chip</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">3‑core GPU</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-31">
                              <div role="presentation" class="stat" index="31">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper r5F24B9 embed-image">
                                      <figure class="compare-image image-icon_chip_a10_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">A10&nbsp;Fusion chip</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-32">
                              <div role="presentation" class="stat" index="32">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper u6CC400 embed-image">
                                      <figure class="compare-image image-icon_chip_a10_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">A10&nbsp;Fusion chip</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-33">
                              <div role="presentation" class="stat" index="33">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper iD77548 embed-image">
                                      <figure class="compare-image image-icon_chip_a9_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">A9&nbsp;chip</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-34">
                              <div role="presentation" class="stat" index="34">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper c8FB19E embed-image">
                                      <figure class="compare-image image-icon_chip_a9_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">A9&nbsp;chip</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-35">
                              <div role="presentation" class="stat" index="35">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper f8A3C9E embed-image">
                                      <figure class="compare-image image-icon_chip_a8_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">A8&nbsp;chip</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-36">
                              <div role="presentation" class="stat" index="36">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper qA8A7B2 embed-image">
                                      <figure class="compare-image image-icon_chip_a8_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">A8&nbsp;chip</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-37">
                              <div role="presentation" class="stat" index="37">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper b18999D embed-image">
                                      <figure class="compare-image image-icon_chip_a9_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">A9&nbsp;chip</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!--END > CATEGORY > QUICK-LOOK > FEATURE > CHIP-->
                          <!--BEGIN > CATEGORY > QUICK-LOOK > FEATURE > APPLE-INTELLIGENCE-->
                          <div role="row" data-column-group="" class="compare-row compare-template-preview-item-stat">
                            <div role="rowheader" aria-rowspan="0" class="compare-rowheader">
                              <div class="visuallyhidden">Apple Intelligence</div>
                            </div>
                            <div role="cell" class="first-child compare-column product-0 compare-column-0">
                              <div role="presentation" class="stat" index="0">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper dE44B57 embed-image">
                                      <figure class="compare-image image-icon_apple_intelligence_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Built for Apple&nbsp;Intelligence<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-1 compare-column-1">
                              <div role="presentation" class="stat" index="1">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper y463797 embed-image">
                                      <figure class="compare-image image-icon_apple_intelligence_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Built for Apple&nbsp;Intelligence<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-2 compare-column-2">
                              <div role="presentation" class="stat" index="2">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper pC2E6A4 embed-image">
                                      <figure class="compare-image image-icon_apple_intelligence_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Built for Apple&nbsp;Intelligence<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-3 compare-column-3">
                              <div role="presentation" class="stat" index="3">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper v83EDC8 embed-image">
                                      <figure class="compare-image image-icon_apple_intelligence_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Built for Apple&nbsp;Intelligence<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-4 compare-column-4">
                              <div role="presentation" class="stat mdash-container copy" index="4">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-5">
                              <div role="presentation" class="stat" index="5">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper u6297C9 embed-image">
                                      <figure class="compare-image image-icon_apple_intelligence_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Built for Apple&nbsp;Intelligence<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-6">
                              <div role="presentation" class="stat" index="6">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper q7285C2 embed-image">
                                      <figure class="compare-image image-icon_apple_intelligence_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Built for Apple&nbsp;Intelligence<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-7">
                              <div role="presentation" class="stat mdash-container copy" index="7">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-8">
                              <div role="presentation" class="stat mdash-container copy" index="8">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-9">
                              <div role="presentation" class="stat mdash-container copy" index="9">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-10">
                              <div role="presentation" class="stat mdash-container copy" index="10">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-11">
                              <div role="presentation" class="stat mdash-container copy" index="11">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-12">
                              <div role="presentation" class="stat mdash-container copy" index="12">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-13">
                              <div role="presentation" class="stat mdash-container copy" index="13">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-14">
                              <div role="presentation" class="stat mdash-container copy" index="14">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-15">
                              <div role="presentation" class="stat mdash-container copy" index="15">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-16">
                              <div role="presentation" class="stat mdash-container copy" index="16">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-17">
                              <div role="presentation" class="stat mdash-container copy" index="17">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-18">
                              <div role="presentation" class="stat mdash-container copy" index="18">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-19">
                              <div role="presentation" class="stat mdash-container copy" index="19">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-20">
                              <div role="presentation" class="stat mdash-container copy" index="20">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-21">
                              <div role="presentation" class="stat mdash-container copy" index="21">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-22">
                              <div role="presentation" class="stat mdash-container copy" index="22">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-23">
                              <div role="presentation" class="stat mdash-container copy" index="23">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-24">
                              <div role="presentation" class="stat mdash-container copy" index="24">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-25">
                              <div role="presentation" class="stat mdash-container copy" index="25">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-26">
                              <div role="presentation" class="stat mdash-container copy" index="26">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-27">
                              <div role="presentation" class="stat mdash-container copy" index="27">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-28">
                              <div role="presentation" class="stat mdash-container copy" index="28">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-29">
                              <div role="presentation" class="stat mdash-container copy" index="29">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-30">
                              <div role="presentation" class="stat mdash-container copy" index="30">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-31">
                              <div role="presentation" class="stat mdash-container copy" index="31">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-32">
                              <div role="presentation" class="stat mdash-container copy" index="32">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-33">
                              <div role="presentation" class="stat mdash-container copy" index="33">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-34">
                              <div role="presentation" class="stat mdash-container copy" index="34">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-35">
                              <div role="presentation" class="stat mdash-container copy" index="35">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-36">
                              <div role="presentation" class="stat mdash-container copy" index="36">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-37">
                              <div role="presentation" class="stat mdash-container copy" index="37">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                          </div>
                          <!--END > CATEGORY > QUICK-LOOK > FEATURE > APPLE-INTELLIGENCE-->
                          <!--BEGIN > CATEGORY > QUICK-LOOK > FEATURE > CAMERA-CONTROL-->
                          <div role="row" data-column-group="" class="compare-row compare-template-preview-item-stat">
                            <div role="rowheader" aria-rowspan="0" class="compare-rowheader">
                              <div class="visuallyhidden">Camera Control</div>
                            </div>
                            <div role="cell" class="first-child compare-column product-0 compare-column-0">
                              <div role="presentation" class="stat" index="0">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper p1CB2BC embed-image">
                                      <figure class="compare-image image-icon_iphone_landscape_camera_button_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 83px;">
                                    <!----><span class="stat-caption copy"><p>Camera Control</p>
  <p>Easier way to capture</p>
  <p>Faster access to photo and video tools</p>
  </span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-1 compare-column-1">
                              <div role="presentation" class="stat" index="1">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper k213FFA embed-image">
                                      <figure class="compare-image image-icon_iphone_landscape_camera_button_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 83px;">
                                    <!----><span class="stat-caption copy"><p>Camera Control</p>
  <p>Easier way to capture</p>
  <p>Faster access to photo and video tools</p>
  </span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-2 compare-column-2">
                              <div role="presentation" class="stat" index="2">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper l9A2238 embed-image">
                                      <figure class="compare-image image-icon_iphone_landscape_camera_button_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 83px;">
                                    <!----><span class="stat-caption copy"><p>Camera Control</p>
  <p>Easier way to capture</p>
  <p>Faster access to photo and video tools</p>
  </span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-3 compare-column-3">
                              <div role="presentation" class="stat" index="3">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper fF2F8B2 embed-image">
                                      <figure class="compare-image image-icon_iphone_landscape_camera_button_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 83px;">
                                    <!----><span class="stat-caption copy"><p>Camera Control</p>
  <p>Easier way to capture</p>
  <p>Faster access to photo and video tools</p>
  </span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-4 compare-column-4">
                              <div role="presentation" class="stat mdash-container copy" index="4">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-5">
                              <div role="presentation" class="stat mdash-container copy" index="5">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-6">
                              <div role="presentation" class="stat mdash-container copy" index="6">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-7">
                              <div role="presentation" class="stat mdash-container copy" index="7">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-8">
                              <div role="presentation" class="stat mdash-container copy" index="8">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-9">
                              <div role="presentation" class="stat mdash-container copy" index="9">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-10">
                              <div role="presentation" class="stat mdash-container copy" index="10">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-11">
                              <div role="presentation" class="stat mdash-container copy" index="11">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-12">
                              <div role="presentation" class="stat mdash-container copy" index="12">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-13">
                              <div role="presentation" class="stat mdash-container copy" index="13">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-14">
                              <div role="presentation" class="stat mdash-container copy" index="14">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-15">
                              <div role="presentation" class="stat mdash-container copy" index="15">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-16">
                              <div role="presentation" class="stat mdash-container copy" index="16">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-17">
                              <div role="presentation" class="stat mdash-container copy" index="17">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-18">
                              <div role="presentation" class="stat mdash-container copy" index="18">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-19">
                              <div role="presentation" class="stat mdash-container copy" index="19">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-20">
                              <div role="presentation" class="stat mdash-container copy" index="20">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-21">
                              <div role="presentation" class="stat mdash-container copy" index="21">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-22">
                              <div role="presentation" class="stat mdash-container copy" index="22">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-23">
                              <div role="presentation" class="stat mdash-container copy" index="23">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-24">
                              <div role="presentation" class="stat mdash-container copy" index="24">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-25">
                              <div role="presentation" class="stat mdash-container copy" index="25">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-26">
                              <div role="presentation" class="stat mdash-container copy" index="26">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-27">
                              <div role="presentation" class="stat mdash-container copy" index="27">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-28">
                              <div role="presentation" class="stat mdash-container copy" index="28">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-29">
                              <div role="presentation" class="stat mdash-container copy" index="29">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-30">
                              <div role="presentation" class="stat mdash-container copy" index="30">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-31">
                              <div role="presentation" class="stat mdash-container copy" index="31">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-32">
                              <div role="presentation" class="stat mdash-container copy" index="32">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-33">
                              <div role="presentation" class="stat mdash-container copy" index="33">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-34">
                              <div role="presentation" class="stat mdash-container copy" index="34">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-35">
                              <div role="presentation" class="stat mdash-container copy" index="35">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-36">
                              <div role="presentation" class="stat mdash-container copy" index="36">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-37">
                              <div role="presentation" class="stat mdash-container copy" index="37">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                          </div>
                          <!--END > CATEGORY > QUICK-LOOK > FEATURE > CAMERA-CONTROL-->
                          <!--BEGIN > CATEGORY > QUICK-LOOK > FEATURE > CAMERA-->
                          <div role="row" data-column-group="" class="compare-row compare-template-preview-item-stat">
                            <div role="rowheader" aria-rowspan="0" class="compare-rowheader">
                              <div class="visuallyhidden">Camera</div>
                            </div>
                            <div role="cell" class="first-child compare-column product-0 compare-column-0">
                              <div role="presentation" class="stat" index="0">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper k373DDE embed-image">
                                      <figure class="compare-image image-icon_iphone16promax_camera_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">Pro camera system</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">48MP Fusion camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">5x Telephoto camera </span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">48MP Ultra Wide camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-1 compare-column-1">
                              <div role="presentation" class="stat" index="1">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper qD0D234 embed-image">
                                      <figure class="compare-image image-icon_iphone16pro_camera_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">Pro camera system</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">48MP Fusion camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">5x Telephoto camera </span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">48MP Ultra Wide camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-2 compare-column-2">
                              <div role="presentation" class="stat" index="2">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper l5B34F8 embed-image">
                                      <figure class="compare-image image-icon_iphone16plus_camera_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">Advanced dual‑camera&nbsp;system</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">48MP Fusion camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">2x Telephoto </span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">12MP Ultra Wide camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-3 compare-column-3">
                              <div role="presentation" class="stat" index="3">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper x05BB10 embed-image">
                                      <figure class="compare-image image-icon_iphone16plus_camera_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">Advanced dual‑camera&nbsp;system</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">48MP Fusion camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">2x Telephoto</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">12MP Ultra Wide camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-4 compare-column-4">
                              <div role="presentation" class="stat" index="4">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper zC08D8D embed-image">
                                      <figure class="compare-image image-icon_iphonese_gen3_camera_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">Single-camera system</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">12MP Main camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-5">
                              <div role="presentation" class="stat" index="5">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper p07695A embed-image">
                                      <figure class="compare-image image-icon_iphone15promax_camera_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">Pro camera system</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">48MP Main camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Telephoto camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Ultra Wide camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-6">
                              <div role="presentation" class="stat" index="6">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper z9FDDD3 embed-image">
                                      <figure class="compare-image image-icon_iphone15promax_camera_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">Pro camera system</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">48MP Main camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Telephoto camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Ultra Wide camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-7">
                              <div role="presentation" class="stat" index="7">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper s97439F embed-image">
                                      <figure class="compare-image image-icon_iphone15plus_camera_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">Advanced dual‑camera&nbsp;system</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">48MP Main camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Ultra Wide camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-8">
                              <div role="presentation" class="stat" index="8">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper hD5A9FE embed-image">
                                      <figure class="compare-image image-icon_iphone15plus_camera_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">Advanced dual‑camera&nbsp;system</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">48MP Main camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Ultra Wide camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-9">
                              <div role="presentation" class="stat" index="9">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper i63733C embed-image">
                                      <figure class="compare-image image-icon_iphone14promax_camera_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Pro camera system</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">48MP Main camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Telephoto camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Ultra Wide camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-10">
                              <div role="presentation" class="stat" index="10">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper eBD0022 embed-image">
                                      <figure class="compare-image image-icon_iphone14pro_camera_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">Pro camera system</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">48MP Main camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Telephoto camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Ultra Wide camera </span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-11">
                              <div role="presentation" class="stat" index="11">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper e620893 embed-image">
                                      <figure class="compare-image image-icon_iphone14plus_camera_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Dual-camera system</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">12MP Main camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Ultra Wide camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-12">
                              <div role="presentation" class="stat" index="12">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper p7E945D embed-image">
                                      <figure class="compare-image image-icon_iphone14_camera_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">Dual-camera system</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">12MP Main camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Ultra Wide camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-13">
                              <div role="presentation" class="stat" index="13">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper f302E07 embed-image">
                                      <figure class="compare-image image-icon_iphone13promax_camera_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Pro camera system</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">12MP Main camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Telephoto camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Ultra Wide camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-14">
                              <div role="presentation" class="stat" index="14">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper dF5F1ED embed-image">
                                      <figure class="compare-image image-icon_iphone13pro_camera_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">Pro camera system</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">12MP Main camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Telephoto camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Ultra Wide camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-15">
                              <div role="presentation" class="stat" index="15">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper aF863BF embed-image">
                                      <figure class="compare-image image-icon_iphone13_camera_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Dual-camera system</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">12MP Main camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Ultra Wide camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-16">
                              <div role="presentation" class="stat" index="16">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper s5CB429 embed-image">
                                      <figure class="compare-image image-icon_iphone13_camera_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Dual-camera system</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">12MP Main camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Ultra Wide camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-17">
                              <div role="presentation" class="stat" index="17">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper w7B4556 embed-image">
                                      <figure class="compare-image image-icon_iphone12promax_camera_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Pro camera system</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">12MP Main camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Telephoto camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Ultra Wide camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-18">
                              <div role="presentation" class="stat" index="18">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper c48CED1 embed-image">
                                      <figure class="compare-image image-icon_iphone12pro_camera_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Pro camera system</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">12MP Main camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Telephoto camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Ultra Wide camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-19">
                              <div role="presentation" class="stat" index="19">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper s1ED4D9 embed-image">
                                      <figure class="compare-image image-icon_iphone12_camera_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Dual-camera system</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">12MP Main camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Ultra Wide camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-20">
                              <div role="presentation" class="stat" index="20">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper sC17504 embed-image">
                                      <figure class="compare-image image-icon_iphone12_camera_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">Dual-camera system</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">12MP Main camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Ultra Wide camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-21">
                              <div role="presentation" class="stat" index="21">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper bEF24D8 embed-image">
                                      <figure class="compare-image image-icon_iphone11promax_camera_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Triple cameras</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">12MP Main camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Telephoto camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Ultra Wide camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-22">
                              <div role="presentation" class="stat" index="22">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper b07F9FD embed-image">
                                      <figure class="compare-image image-icon_iphone11pro_camera_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Triple cameras</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">12MP Main camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Telephoto camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Ultra Wide camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-23">
                              <div role="presentation" class="stat" index="23">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper e100E1F embed-image">
                                      <figure class="compare-image image-icon_iphone11_camera_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Dual cameras</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">12MP Main camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Ultra Wide camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-24">
                              <div role="presentation" class="stat" index="24">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper e35AA91 embed-image">
                                      <figure class="compare-image image-icon_iphonese_gen3_camera_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Single camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">12MP Main camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-25">
                              <div role="presentation" class="stat" index="25">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper k8C2D16 embed-image">
                                      <figure class="compare-image image-icon_iphonexs_camera_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Dual cameras</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">12MP Main camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Telephoto camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-26">
                              <div role="presentation" class="stat" index="26">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper x3A9814 embed-image">
                                      <figure class="compare-image image-icon_iphonexs_camera_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Dual cameras</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">12MP Main camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Telephoto camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-27">
                              <div role="presentation" class="stat" index="27">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper vBC56F5 embed-image">
                                      <figure class="compare-image image-icon_iphonexr_camera_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">Single camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">12MP Main camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-28">
                              <div role="presentation" class="stat" index="28">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper gF28FE8 embed-image">
                                      <figure class="compare-image image-icon_iphonexs_camera_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Dual cameras</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">12MP Main camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Telephoto camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-29">
                              <div role="presentation" class="stat" index="29">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper h73123E embed-image">
                                      <figure class="compare-image image-icon_iphone8plus_camera_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Dual cameras</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">12MP Main camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Telephoto camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-30">
                              <div role="presentation" class="stat" index="30">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper e80CF4E embed-image">
                                      <figure class="compare-image image-icon_iphonese_gen3_camera_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Single camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">12MP Main camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-31">
                              <div role="presentation" class="stat" index="31">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper y5819FC embed-image">
                                      <figure class="compare-image image-icon_iphone8plus_camera_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Dual cameras</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">12MP Main camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Telephoto camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-32">
                              <div role="presentation" class="stat" index="32">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper pF4E0EB embed-image">
                                      <figure class="compare-image image-icon_iphonese_gen3_camera_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Single camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">12MP Main camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-33">
                              <div role="presentation" class="stat" index="33">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper sC4E84C embed-image">
                                      <figure class="compare-image image-icon_iphone6splus_camera_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Single camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">12MP Main camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-34">
                              <div role="presentation" class="stat" index="34">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper dEC22E7 embed-image">
                                      <figure class="compare-image image-icon_iphone6s_camera_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Single camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">12MP Main camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-35">
                              <div role="presentation" class="stat" index="35">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper j231063 embed-image">
                                      <figure class="compare-image image-icon_iphone6splus_camera_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">Single camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">8MP Main camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-36">
                              <div role="presentation" class="stat" index="36">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper oB05A2A embed-image">
                                      <figure class="compare-image image-icon_iphone6splus_camera_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Single camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">8MP Main camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-37">
                              <div role="presentation" class="stat" index="37">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper z2426A1 embed-image">
                                      <figure class="compare-image image-icon_iphonese_gen1_camera_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">Single camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">12MP Main camera</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!--END > CATEGORY > QUICK-LOOK > FEATURE > CAMERA-->
                          <!--BEGIN > CATEGORY > QUICK-LOOK > FEATURE > SAFETY-->
                          <div role="row" data-column-group="" class="compare-row compare-template-preview-item-stat">
                            <div role="rowheader" aria-rowspan="0" class="compare-rowheader">
                              <div class="visuallyhidden">Safety</div>
                            </div>
                            <div role="cell" class="first-child compare-column product-0 compare-column-0">
                              <div role="presentation" class="stat" index="0">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper p9B47C7 embed-image">
                                      <figure class="compare-image image-icon_sos_circle_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Emergency SOS</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Crash Detection<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-1 compare-column-1">
                              <div role="presentation" class="stat" index="1">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper w6020EB embed-image">
                                      <figure class="compare-image image-icon_sos_circle_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Emergency SOS</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Crash Detection<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-2 compare-column-2">
                              <div role="presentation" class="stat" index="2">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper g5AE0B2 embed-image">
                                      <figure class="compare-image image-icon_sos_circle_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Emergency SOS</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Crash Detection<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-3 compare-column-3">
                              <div role="presentation" class="stat" index="3">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper mB42C76 embed-image">
                                      <figure class="compare-image image-icon_sos_circle_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Emergency SOS</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Crash Detection<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-4 compare-column-4">
                              <div role="presentation" class="stat" index="4">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper eCEA889 embed-image">
                                      <figure class="compare-image image-icon_sos_circle_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Emergency SOS</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-5">
                              <div role="presentation" class="stat" index="5">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper o903154 embed-image">
                                      <figure class="compare-image image-icon_sos_circle_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Emergency SOS</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Crash Detection<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-6">
                              <div role="presentation" class="stat" index="6">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper p25ADC2 embed-image">
                                      <figure class="compare-image image-icon_sos_circle_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Emergency SOS</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Crash Detection<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-7">
                              <div role="presentation" class="stat" index="7">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper nE88DE2 embed-image">
                                      <figure class="compare-image image-icon_sos_circle_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Emergency SOS</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Crash Detection<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-8">
                              <div role="presentation" class="stat" index="8">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper zED69AF embed-image">
                                      <figure class="compare-image image-icon_sos_circle_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Emergency SOS</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Crash Detection<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-9">
                              <div role="presentation" class="stat" index="9">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper lB5DEF2 embed-image">
                                      <figure class="compare-image image-icon_sos_circle_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Emergency SOS</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Crash Detection<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-10">
                              <div role="presentation" class="stat" index="10">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper a5F9581 embed-image">
                                      <figure class="compare-image image-icon_sos_circle_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Emergency SOS</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Crash Detection<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-11">
                              <div role="presentation" class="stat" index="11">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper tB90EB9 embed-image">
                                      <figure class="compare-image image-icon_sos_circle_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Emergency SOS</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Crash Detection<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-12">
                              <div role="presentation" class="stat" index="12">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper l2D0719 embed-image">
                                      <figure class="compare-image image-icon_sos_circle_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Emergency SOS</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Crash Detection<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-13">
                              <div role="presentation" class="stat" index="13">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper m774690 embed-image">
                                      <figure class="compare-image image-icon_sos_circle_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Emergency SOS</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-14">
                              <div role="presentation" class="stat" index="14">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper rFA4103 embed-image">
                                      <figure class="compare-image image-icon_sos_circle_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Emergency SOS</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-15">
                              <div role="presentation" class="stat" index="15">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper y830A71 embed-image">
                                      <figure class="compare-image image-icon_sos_circle_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Emergency SOS</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-16">
                              <div role="presentation" class="stat" index="16">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper w181E92 embed-image">
                                      <figure class="compare-image image-icon_sos_circle_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Emergency SOS</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-17">
                              <div role="presentation" class="stat" index="17">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper t697E57 embed-image">
                                      <figure class="compare-image image-icon_sos_circle_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Emergency SOS</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-18">
                              <div role="presentation" class="stat" index="18">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper r80EFD8 embed-image">
                                      <figure class="compare-image image-icon_sos_circle_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Emergency SOS</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-19">
                              <div role="presentation" class="stat" index="19">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper iD579A5 embed-image">
                                      <figure class="compare-image image-icon_sos_circle_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Emergency SOS</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-20">
                              <div role="presentation" class="stat" index="20">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper aBAE2E5 embed-image">
                                      <figure class="compare-image image-icon_sos_circle_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Emergency SOS</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-21">
                              <div role="presentation" class="stat" index="21">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper i79BA39 embed-image">
                                      <figure class="compare-image image-icon_sos_circle_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Emergency SOS</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-22">
                              <div role="presentation" class="stat" index="22">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper g3835F4 embed-image">
                                      <figure class="compare-image image-icon_sos_circle_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Emergency SOS</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-23">
                              <div role="presentation" class="stat" index="23">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper lA73683 embed-image">
                                      <figure class="compare-image image-icon_sos_circle_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Emergency SOS</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-24">
                              <div role="presentation" class="stat" index="24">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper a344E6D embed-image">
                                      <figure class="compare-image image-icon_sos_circle_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Emergency SOS</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-25">
                              <div role="presentation" class="stat" index="25">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper vE729C6 embed-image">
                                      <figure class="compare-image image-icon_sos_circle_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Emergency SOS</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-26">
                              <div role="presentation" class="stat" index="26">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper rB1584D embed-image">
                                      <figure class="compare-image image-icon_sos_circle_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Emergency SOS</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-27">
                              <div role="presentation" class="stat" index="27">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper p041602 embed-image">
                                      <figure class="compare-image image-icon_sos_circle_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Emergency SOS</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-28">
                              <div role="presentation" class="stat" index="28">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper c5C7D7C embed-image">
                                      <figure class="compare-image image-icon_sos_circle_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Emergency SOS</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-29">
                              <div role="presentation" class="stat" index="29">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper u653024 embed-image">
                                      <figure class="compare-image image-icon_sos_circle_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Emergency SOS</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-30">
                              <div role="presentation" class="stat" index="30">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper uFF6849 embed-image">
                                      <figure class="compare-image image-icon_sos_circle_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Emergency SOS</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-31">
                              <div role="presentation" class="stat" index="31">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper n6893D2 embed-image">
                                      <figure class="compare-image image-icon_sos_circle_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Emergency SOS</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-32">
                              <div role="presentation" class="stat" index="32">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper h247877 embed-image">
                                      <figure class="compare-image image-icon_sos_circle_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Emergency SOS</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-33">
                              <div role="presentation" class="stat" index="33">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper fEA77AC embed-image">
                                      <figure class="compare-image image-icon_sos_circle_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Emergency SOS</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-34">
                              <div role="presentation" class="stat" index="34">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper b2B97A6 embed-image">
                                      <figure class="compare-image image-icon_sos_circle_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Emergency SOS</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-35">
                              <div role="presentation" class="stat" index="35">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper nA51D64 embed-image">
                                      <figure class="compare-image image-icon_sos_circle_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Emergency SOS</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-36">
                              <div role="presentation" class="stat" index="36">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper i66D6EE embed-image">
                                      <figure class="compare-image image-icon_sos_circle_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Emergency SOS</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-37">
                              <div role="presentation" class="stat" index="37">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper wA90B50 embed-image">
                                      <figure class="compare-image image-icon_sos_circle_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Emergency SOS</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!---->
                                    <!---->
                                    <!---->
                                    <div><span aria-hidden="true" class="mdash stat-caption copy">—</span><span class="visuallyhidden">Not Applicable</span></div>
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!--END > CATEGORY > QUICK-LOOK > FEATURE > SAFETY-->
                          <!--BEGIN > CATEGORY > QUICK-LOOK > FEATURE > BATTERY-->
                          <div role="row" data-column-group="" class="compare-row compare-template-preview-item-stat">
                            <div role="rowheader" aria-rowspan="0" class="compare-rowheader">
                              <div class="visuallyhidden">Battery</div>
                            </div>
                            <div role="cell" class="first-child compare-column product-0 compare-column-0">
                              <div role="presentation" class="stat" index="0">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper nCF8C6D embed-image">
                                      <figure class="compare-image image-icon_battery_100percent_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">Up to 33 hours video&nbsp;playback<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-1 compare-column-1">
                              <div role="presentation" class="stat" index="1">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper z6E7009 embed-image">
                                      <figure class="compare-image image-icon_battery_100percent_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">Up to 27 hours video&nbsp;playback<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-2 compare-column-2">
                              <div role="presentation" class="stat" index="2">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper bC3D1B9 embed-image">
                                      <figure class="compare-image image-icon_battery_100percent_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">Up to 27 hours video&nbsp;playback<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-3 compare-column-3">
                              <div role="presentation" class="stat" index="3">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper o56E224 embed-image">
                                      <figure class="compare-image image-icon_battery_100percent_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">Up to 22 hours video&nbsp;playback<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-4 compare-column-4">
                              <div role="presentation" class="stat" index="4">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper rADAE6A embed-image">
                                      <figure class="compare-image image-icon_battery_100percent_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">Up to 15 hours video&nbsp;playback<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-5">
                              <div role="presentation" class="stat" index="5">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper fFF6251 embed-image">
                                      <figure class="compare-image image-icon_battery_100percent_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">Up to 29 hours video&nbsp;playback<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-6">
                              <div role="presentation" class="stat" index="6">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper tDAC50C embed-image">
                                      <figure class="compare-image image-icon_battery_100percent_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">Up to 23 hours video&nbsp;playback<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-7">
                              <div role="presentation" class="stat" index="7">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper w487B3C embed-image">
                                      <figure class="compare-image image-icon_battery_100percent_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">Up to 26 hours video&nbsp;playback<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-8">
                              <div role="presentation" class="stat" index="8">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper c82C3B5 embed-image">
                                      <figure class="compare-image image-icon_battery_100percent_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">Up to 20 hours video&nbsp;playback<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-9">
                              <div role="presentation" class="stat" index="9">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper e032D4D embed-image">
                                      <figure class="compare-image image-icon_battery_100percent_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Up to 29 hours video&nbsp;playback<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-10">
                              <div role="presentation" class="stat" index="10">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper aF753AE embed-image">
                                      <figure class="compare-image image-icon_battery_100percent_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">Up to 23 hours video&nbsp;playback<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-11">
                              <div role="presentation" class="stat" index="11">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper cF99D0B embed-image">
                                      <figure class="compare-image image-icon_battery_100percent_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Up to 26 hours video&nbsp;playback<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-12">
                              <div role="presentation" class="stat" index="12">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper p260B90 embed-image">
                                      <figure class="compare-image image-icon_battery_100percent_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">Up to 20 hours video&nbsp;playback<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-13">
                              <div role="presentation" class="stat" index="13">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper uFFBFC4 embed-image">
                                      <figure class="compare-image image-icon_battery_100percent_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Up to 28 hours video&nbsp;playback<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-14">
                              <div role="presentation" class="stat" index="14">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper a156FC0 embed-image">
                                      <figure class="compare-image image-icon_battery_100percent_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">Up to 22 hours video&nbsp;playback<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-15">
                              <div role="presentation" class="stat" index="15">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper h20BD29 embed-image">
                                      <figure class="compare-image image-icon_battery_100percent_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Up to 19 hours video&nbsp;playback<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-16">
                              <div role="presentation" class="stat" index="16">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper o1512A4 embed-image">
                                      <figure class="compare-image image-icon_battery_100percent_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Up to 17 hours video&nbsp;playback<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-17">
                              <div role="presentation" class="stat" index="17">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper h6AD210 embed-image">
                                      <figure class="compare-image image-icon_battery_100percent_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Up to 20 hours video&nbsp;playback<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-18">
                              <div role="presentation" class="stat" index="18">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper u6D47FB embed-image">
                                      <figure class="compare-image image-icon_battery_100percent_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Up to 17 hours video&nbsp;playback<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-19">
                              <div role="presentation" class="stat" index="19">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper p9A050F embed-image">
                                      <figure class="compare-image image-icon_battery_100percent_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Up to 17 hours video&nbsp;playback<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-20">
                              <div role="presentation" class="stat" index="20">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper m3D0D6C embed-image">
                                      <figure class="compare-image image-icon_battery_100percent_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">Up to 15 hours video&nbsp;playback<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-21">
                              <div role="presentation" class="stat" index="21">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper t9E9818 embed-image">
                                      <figure class="compare-image image-icon_battery_100percent_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Up to 20 hours video&nbsp;playback<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-22">
                              <div role="presentation" class="stat" index="22">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper e95A3B6 embed-image">
                                      <figure class="compare-image image-icon_battery_100percent_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Up to 18 hours video&nbsp;playback<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-23">
                              <div role="presentation" class="stat" index="23">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper q7A7A78 embed-image">
                                      <figure class="compare-image image-icon_battery_100percent_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Up to 17 hours video&nbsp;playback<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-24">
                              <div role="presentation" class="stat" index="24">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper y09CF8A embed-image">
                                      <figure class="compare-image image-icon_battery_100percent_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Up to 13 hours video&nbsp;playback<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-25">
                              <div role="presentation" class="stat" index="25">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper s584CA7 embed-image">
                                      <figure class="compare-image image-icon_battery_100percent_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Up to 15 hours video&nbsp;playback<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-26">
                              <div role="presentation" class="stat" index="26">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper yFC943C embed-image">
                                      <figure class="compare-image image-icon_battery_100percent_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Up to 14 hours video&nbsp;playback<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-27">
                              <div role="presentation" class="stat" index="27">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper y23B076 embed-image">
                                      <figure class="compare-image image-icon_battery_100percent_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">Up to 16 hours video&nbsp;playback<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-28">
                              <div role="presentation" class="stat" index="28">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper o9D1F5A embed-image">
                                      <figure class="compare-image image-icon_battery_100percent_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Up to 13 hours video&nbsp;playback<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-29">
                              <div role="presentation" class="stat" index="29">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper y7E40C0 embed-image">
                                      <figure class="compare-image image-icon_battery_100percent_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Up to 14 hours video&nbsp;playback<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-30">
                              <div role="presentation" class="stat" index="30">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper b21E66B embed-image">
                                      <figure class="compare-image image-icon_battery_100percent_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Up to 13 hours video&nbsp;playback<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-31">
                              <div role="presentation" class="stat" index="31">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper j29F0E7 embed-image">
                                      <figure class="compare-image image-icon_battery_100percent_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Up to 14 hours video&nbsp;playback<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-32">
                              <div role="presentation" class="stat" index="32">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper rC6CD67 embed-image">
                                      <figure class="compare-image image-icon_battery_100percent_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Up to 13 hours video&nbsp;playback<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-33">
                              <div role="presentation" class="stat" index="33">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper sD32941 embed-image">
                                      <figure class="compare-image image-icon_battery_100percent_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Up to 14 hours video&nbsp;playback<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-34">
                              <div role="presentation" class="stat" index="34">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper i3353AD embed-image">
                                      <figure class="compare-image image-icon_battery_100percent_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Up to 11 hours video&nbsp;playback<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-35">
                              <div role="presentation" class="stat" index="35">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper iE986C4 embed-image">
                                      <figure class="compare-image image-icon_battery_100percent_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">Up to 14 hours video&nbsp;playback<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-36">
                              <div role="presentation" class="stat" index="36">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper fADCEEC embed-image">
                                      <figure class="compare-image image-icon_battery_100percent_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Up to 11 hours video&nbsp;playback<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-37">
                              <div role="presentation" class="stat" index="37">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper nFCCB5D embed-image">
                                      <figure class="compare-image image-icon_battery_100percent_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">Up to 13 hours video&nbsp;playback<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!--END > CATEGORY > QUICK-LOOK > FEATURE > BATTERY-->
                          <!--BEGIN > CATEGORY > QUICK-LOOK > FEATURE > CONNECTIVITY-->
                          <div role="row" data-column-group="" class="compare-row compare-template-preview-item-stat">
                            <div role="rowheader" aria-rowspan="0" class="compare-rowheader">
                              <div class="visuallyhidden">Connectivity</div>
                            </div>
                            <div role="cell" class="first-child compare-column product-0 compare-column-0">
                              <div role="presentation" class="stat" index="0">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper g56492A embed-image">
                                      <figure class="compare-image image-icon_port_usb_c_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">USB-C</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Supports USB&nbsp;3</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-1 compare-column-1">
                              <div role="presentation" class="stat" index="1">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper j86B026 embed-image">
                                      <figure class="compare-image image-icon_port_usb_c_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">USB-C</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Supports USB&nbsp;3</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-2 compare-column-2">
                              <div role="presentation" class="stat" index="2">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper fFC110A embed-image">
                                      <figure class="compare-image image-icon_port_usb_c_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">USB-C</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Supports USB&nbsp;2</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-3 compare-column-3">
                              <div role="presentation" class="stat" index="3">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper pE60AAA embed-image">
                                      <figure class="compare-image image-icon_port_usb_c_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">USB-C</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Supports USB&nbsp;2</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-4 compare-column-4">
                              <div role="presentation" class="stat" index="4">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper l6F784B embed-image">
                                      <figure class="compare-image image-icon_port_lightning_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Lightning</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Supports USB&nbsp;2</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-5">
                              <div role="presentation" class="stat" index="5">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper x291F9B embed-image">
                                      <figure class="compare-image image-icon_port_usb_c_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">USB-C</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Supports USB&nbsp;3</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-6">
                              <div role="presentation" class="stat" index="6">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper wEF7D52 embed-image">
                                      <figure class="compare-image image-icon_port_usb_c_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">USB-C</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Supports USB&nbsp;3</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-7">
                              <div role="presentation" class="stat" index="7">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper l3F5AFE embed-image">
                                      <figure class="compare-image image-icon_port_usb_c_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">USB-C</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Supports USB&nbsp;2</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-8">
                              <div role="presentation" class="stat" index="8">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper vB0C43A embed-image">
                                      <figure class="compare-image image-icon_port_usb_c_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">USB-C</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Supports USB&nbsp;2</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-9">
                              <div role="presentation" class="stat" index="9">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper yE5AD02 embed-image">
                                      <figure class="compare-image image-icon_port_lightning_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Lightning</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Supports USB&nbsp;2</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-10">
                              <div role="presentation" class="stat" index="10">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper qC35AC3 embed-image">
                                      <figure class="compare-image image-icon_port_lightning_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Lightning</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Supports USB&nbsp;2</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-11">
                              <div role="presentation" class="stat" index="11">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper r564C7B embed-image">
                                      <figure class="compare-image image-icon_port_lightning_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Lightning</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Supports USB&nbsp;2</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-12">
                              <div role="presentation" class="stat" index="12">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper h5FA937 embed-image">
                                      <figure class="compare-image image-icon_port_lightning_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Lightning</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Supports USB&nbsp;2</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-13">
                              <div role="presentation" class="stat" index="13">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper aD0C72C embed-image">
                                      <figure class="compare-image image-icon_port_lightning_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Lightning</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Supports USB&nbsp;2</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-14">
                              <div role="presentation" class="stat" index="14">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper t90560D embed-image">
                                      <figure class="compare-image image-icon_port_lightning_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Lightning</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Supports USB&nbsp;2</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-15">
                              <div role="presentation" class="stat" index="15">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper w07C20C embed-image">
                                      <figure class="compare-image image-icon_port_lightning_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Lightning</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Supports USB&nbsp;2</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-16">
                              <div role="presentation" class="stat" index="16">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper oDBF0A5 embed-image">
                                      <figure class="compare-image image-icon_port_lightning_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Lightning</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Supports USB&nbsp;2</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-17">
                              <div role="presentation" class="stat" index="17">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper mEAAFE9 embed-image">
                                      <figure class="compare-image image-icon_port_lightning_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Lightning</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Supports USB&nbsp;2</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-18">
                              <div role="presentation" class="stat" index="18">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper q8CD21D embed-image">
                                      <figure class="compare-image image-icon_port_lightning_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Lightning</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Supports USB&nbsp;2</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-19">
                              <div role="presentation" class="stat" index="19">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper lE413E5 embed-image">
                                      <figure class="compare-image image-icon_port_lightning_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Lightning</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Supports USB&nbsp;2</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-20">
                              <div role="presentation" class="stat" index="20">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper g99D948 embed-image">
                                      <figure class="compare-image image-icon_port_lightning_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Lightning</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Supports USB&nbsp;2</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-21">
                              <div role="presentation" class="stat" index="21">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper eC74CB8 embed-image">
                                      <figure class="compare-image image-icon_port_lightning_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Lightning</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Supports USB&nbsp;2</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-22">
                              <div role="presentation" class="stat" index="22">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper vAB520F embed-image">
                                      <figure class="compare-image image-icon_port_lightning_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Lightning</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Supports USB&nbsp;2</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-23">
                              <div role="presentation" class="stat" index="23">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper w3F368D embed-image">
                                      <figure class="compare-image image-icon_port_lightning_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Lightning</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Supports USB&nbsp;2</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-24">
                              <div role="presentation" class="stat" index="24">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper d2F3156 embed-image">
                                      <figure class="compare-image image-icon_port_lightning_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Lightning</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Supports USB&nbsp;2</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-25">
                              <div role="presentation" class="stat" index="25">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper oCE1C86 embed-image">
                                      <figure class="compare-image image-icon_port_lightning_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Lightning</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Supports USB&nbsp;2</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-26">
                              <div role="presentation" class="stat" index="26">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper w87E55E embed-image">
                                      <figure class="compare-image image-icon_port_lightning_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Lightning</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Supports USB&nbsp;2</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-27">
                              <div role="presentation" class="stat" index="27">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper k2513EE embed-image">
                                      <figure class="compare-image image-icon_port_lightning_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Lightning</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Supports USB&nbsp;2</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-28">
                              <div role="presentation" class="stat" index="28">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper tB2E9B9 embed-image">
                                      <figure class="compare-image image-icon_port_lightning_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Lightning</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Supports USB&nbsp;2</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-29">
                              <div role="presentation" class="stat" index="29">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper qA2C4E7 embed-image">
                                      <figure class="compare-image image-icon_port_lightning_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Lightning</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Supports USB&nbsp;2</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-30">
                              <div role="presentation" class="stat" index="30">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper r3858A5 embed-image">
                                      <figure class="compare-image image-icon_port_lightning_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Lightning</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Supports USB&nbsp;2</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-31">
                              <div role="presentation" class="stat" index="31">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper j6A1098 embed-image">
                                      <figure class="compare-image image-icon_port_lightning_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Lightning</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Supports USB&nbsp;2</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-32">
                              <div role="presentation" class="stat" index="32">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper t7BEFC0 embed-image">
                                      <figure class="compare-image image-icon_port_lightning_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Lightning</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Supports USB&nbsp;2</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-33">
                              <div role="presentation" class="stat" index="33">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper w001CC6 embed-image">
                                      <figure class="compare-image image-icon_port_lightning_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Lightning</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Supports USB&nbsp;2</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-34">
                              <div role="presentation" class="stat" index="34">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper d3B58B2 embed-image">
                                      <figure class="compare-image image-icon_port_lightning_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Lightning</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Supports USB&nbsp;2</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-35">
                              <div role="presentation" class="stat" index="35">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper jC14F55 embed-image">
                                      <figure class="compare-image image-icon_port_lightning_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Lightning</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Supports USB&nbsp;2</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-36">
                              <div role="presentation" class="stat" index="36">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper eE86546 embed-image">
                                      <figure class="compare-image image-icon_port_lightning_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Lightning</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Supports USB&nbsp;2</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-37">
                              <div role="presentation" class="stat" index="37">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper s9EDB54 embed-image">
                                      <figure class="compare-image image-icon_port_lightning_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Lightning</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Supports USB&nbsp;2</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!--END > CATEGORY > QUICK-LOOK > FEATURE > CONNECTIVITY-->
                          <!--BEGIN > CATEGORY > QUICK-LOOK > FEATURE > FACE-ID-TOUCH-ID-->
                          <div role="row" data-column-group="" class="compare-row compare-template-preview-item-stat">
                            <div role="rowheader" aria-rowspan="0" class="compare-rowheader">
                              <div class="visuallyhidden">Face ID / Touch ID</div>
                            </div>
                            <div role="cell" class="first-child compare-column product-0 compare-column-0">
                              <div role="presentation" class="stat" index="0">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper v89F890 embed-image">
                                      <figure class="compare-image image-icon_faceid_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Face&nbsp;ID</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-1 compare-column-1">
                              <div role="presentation" class="stat" index="1">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper fABF7BB embed-image">
                                      <figure class="compare-image image-icon_faceid_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Face&nbsp;ID</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-2 compare-column-2">
                              <div role="presentation" class="stat" index="2">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper e07D0AF embed-image">
                                      <figure class="compare-image image-icon_faceid_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Face&nbsp;ID</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-3 compare-column-3">
                              <div role="presentation" class="stat" index="3">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper z0A1E70 embed-image">
                                      <figure class="compare-image image-icon_faceid_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Face&nbsp;ID</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-4 compare-column-4">
                              <div role="presentation" class="stat" index="4">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper z8413C0 embed-image">
                                      <figure class="compare-image image-icon_touchid_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Touch&nbsp;ID</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-5">
                              <div role="presentation" class="stat" index="5">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper a49CBB7 embed-image">
                                      <figure class="compare-image image-icon_faceid_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Face&nbsp;ID</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-6">
                              <div role="presentation" class="stat" index="6">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper h690D4B embed-image">
                                      <figure class="compare-image image-icon_faceid_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Face&nbsp;ID</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-7">
                              <div role="presentation" class="stat" index="7">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper d7060A2 embed-image">
                                      <figure class="compare-image image-icon_faceid_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Face&nbsp;ID</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-8">
                              <div role="presentation" class="stat" index="8">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper j4D1643 embed-image">
                                      <figure class="compare-image image-icon_faceid_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Face&nbsp;ID</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-9">
                              <div role="presentation" class="stat" index="9">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper jD3862F embed-image">
                                      <figure class="compare-image image-icon_faceid_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Face&nbsp;ID</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-10">
                              <div role="presentation" class="stat" index="10">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper a10855F embed-image">
                                      <figure class="compare-image image-icon_faceid_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Face&nbsp;ID</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-11">
                              <div role="presentation" class="stat" index="11">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper r4D5119 embed-image">
                                      <figure class="compare-image image-icon_faceid_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Face&nbsp;ID</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-12">
                              <div role="presentation" class="stat" index="12">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper w8CB903 embed-image">
                                      <figure class="compare-image image-icon_faceid_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Face&nbsp;ID</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-13">
                              <div role="presentation" class="stat" index="13">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper b9BBC0B embed-image">
                                      <figure class="compare-image image-icon_faceid_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Face&nbsp;ID</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-14">
                              <div role="presentation" class="stat" index="14">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper b1A3ED2 embed-image">
                                      <figure class="compare-image image-icon_faceid_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Face&nbsp;ID</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-15">
                              <div role="presentation" class="stat" index="15">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper c45DB54 embed-image">
                                      <figure class="compare-image image-icon_faceid_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Face&nbsp;ID</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-16">
                              <div role="presentation" class="stat" index="16">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper z766BF9 embed-image">
                                      <figure class="compare-image image-icon_faceid_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Face&nbsp;ID</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-17">
                              <div role="presentation" class="stat" index="17">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper r41517D embed-image">
                                      <figure class="compare-image image-icon_faceid_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Face&nbsp;ID</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-18">
                              <div role="presentation" class="stat" index="18">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper bA0B1CB embed-image">
                                      <figure class="compare-image image-icon_faceid_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Face&nbsp;ID</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-19">
                              <div role="presentation" class="stat" index="19">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper t9987EB embed-image">
                                      <figure class="compare-image image-icon_faceid_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Face&nbsp;ID</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-20">
                              <div role="presentation" class="stat" index="20">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper j20F829 embed-image">
                                      <figure class="compare-image image-icon_faceid_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Face&nbsp;ID</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-21">
                              <div role="presentation" class="stat" index="21">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper p25200F embed-image">
                                      <figure class="compare-image image-icon_faceid_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Face&nbsp;ID</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-22">
                              <div role="presentation" class="stat" index="22">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper h7A96AC embed-image">
                                      <figure class="compare-image image-icon_faceid_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Face&nbsp;ID</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-23">
                              <div role="presentation" class="stat" index="23">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper l7C827C embed-image">
                                      <figure class="compare-image image-icon_faceid_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Face&nbsp;ID</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-24">
                              <div role="presentation" class="stat" index="24">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper n1D685B embed-image">
                                      <figure class="compare-image image-icon_touchid_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Touch&nbsp;ID</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-25">
                              <div role="presentation" class="stat" index="25">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper i347512 embed-image">
                                      <figure class="compare-image image-icon_faceid_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Face&nbsp;ID</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-26">
                              <div role="presentation" class="stat" index="26">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper g33EE55 embed-image">
                                      <figure class="compare-image image-icon_faceid_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Face&nbsp;ID</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-27">
                              <div role="presentation" class="stat" index="27">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper f4B86E9 embed-image">
                                      <figure class="compare-image image-icon_faceid_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Face&nbsp;ID</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-28">
                              <div role="presentation" class="stat" index="28">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper c29503B embed-image">
                                      <figure class="compare-image image-icon_faceid_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Face&nbsp;ID</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-29">
                              <div role="presentation" class="stat" index="29">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper qC92A95 embed-image">
                                      <figure class="compare-image image-icon_touchid_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Touch&nbsp;ID</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-30">
                              <div role="presentation" class="stat" index="30">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper qC38EF4 embed-image">
                                      <figure class="compare-image image-icon_touchid_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Touch&nbsp;ID</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-31">
                              <div role="presentation" class="stat" index="31">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper t519A36 embed-image">
                                      <figure class="compare-image image-icon_touchid_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Touch&nbsp;ID</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-32">
                              <div role="presentation" class="stat" index="32">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper cEE582E embed-image">
                                      <figure class="compare-image image-icon_touchid_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Touch&nbsp;ID</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-33">
                              <div role="presentation" class="stat" index="33">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper mD476AE embed-image">
                                      <figure class="compare-image image-icon_touchid_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Touch&nbsp;ID</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-34">
                              <div role="presentation" class="stat" index="34">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper wFAD36E embed-image">
                                      <figure class="compare-image image-icon_touchid_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Touch&nbsp;ID</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-35">
                              <div role="presentation" class="stat" index="35">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper uD72B42 embed-image">
                                      <figure class="compare-image image-icon_touchid_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Touch&nbsp;ID</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-36">
                              <div role="presentation" class="stat" index="36">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper gB2CC0C embed-image">
                                      <figure class="compare-image image-icon_touchid_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Touch&nbsp;ID</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-37">
                              <div role="presentation" class="stat" index="37">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper nCB68B0 embed-image">
                                      <figure class="compare-image image-icon_touchid_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Touch&nbsp;ID</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!--END > CATEGORY > QUICK-LOOK > FEATURE > FACE-ID-TOUCH-ID-->
                          <!--BEGIN > CATEGORY > QUICK-LOOK > FEATURE > CELLULAR-->
                          <div role="row" data-column-group="" class="compare-row compare-template-preview-item-stat">
                            <div role="rowheader" aria-rowspan="0" class="compare-rowheader">
                              <div class="visuallyhidden">Cellular</div>
                            </div>
                            <div role="cell" class="first-child compare-column product-0 compare-column-0">
                              <div role="presentation" class="stat" index="0">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper b27E2BF embed-image">
                                      <figure class="compare-image image-icon_5g_radiowaves_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Superfast 5G cellular<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-1 compare-column-1">
                              <div role="presentation" class="stat" index="1">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper t71EF8F embed-image">
                                      <figure class="compare-image image-icon_5g_radiowaves_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Superfast 5G cellular<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-2 compare-column-2">
                              <div role="presentation" class="stat" index="2">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper h04F02A embed-image">
                                      <figure class="compare-image image-icon_5g_radiowaves_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Superfast 5G cellular<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-3 compare-column-3">
                              <div role="presentation" class="stat" index="3">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper a8BF343 embed-image">
                                      <figure class="compare-image image-icon_5g_radiowaves_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Superfast 5G cellular<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-4 compare-column-4">
                              <div role="presentation" class="stat" index="4">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper bEBD8A7 embed-image">
                                      <figure class="compare-image image-icon_5g_radiowaves_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">5G cellular<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers </span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-5">
                              <div role="presentation" class="stat" index="5">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper zAA1F1A embed-image">
                                      <figure class="compare-image image-icon_5g_radiowaves_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Superfast 5G cellular<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-6">
                              <div role="presentation" class="stat" index="6">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper pC9E226 embed-image">
                                      <figure class="compare-image image-icon_5g_radiowaves_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Superfast 5G cellular<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-7">
                              <div role="presentation" class="stat" index="7">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper q14DDA6 embed-image">
                                      <figure class="compare-image image-icon_5g_radiowaves_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Superfast 5G cellular<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-8">
                              <div role="presentation" class="stat" index="8">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper a7F6454 embed-image">
                                      <figure class="compare-image image-icon_5g_radiowaves_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Superfast 5G cellular<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-9">
                              <div role="presentation" class="stat" index="9">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper k463FA3 embed-image">
                                      <figure class="compare-image image-icon_5g_radiowaves_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Superfast 5G cellular<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-10">
                              <div role="presentation" class="stat" index="10">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper bF1110C embed-image">
                                      <figure class="compare-image image-icon_5g_radiowaves_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Superfast 5G cellular<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-11">
                              <div role="presentation" class="stat" index="11">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper tEFEF5D embed-image">
                                      <figure class="compare-image image-icon_5g_radiowaves_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Superfast 5G cellular<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-12">
                              <div role="presentation" class="stat" index="12">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper dFE3E0B embed-image">
                                      <figure class="compare-image image-icon_5g_radiowaves_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Superfast 5G cellular<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-13">
                              <div role="presentation" class="stat" index="13">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper a3B65D6 embed-image">
                                      <figure class="compare-image image-icon_5g_radiowaves_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Superfast 5G cellular<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-14">
                              <div role="presentation" class="stat" index="14">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper b453AA0 embed-image">
                                      <figure class="compare-image image-icon_5g_radiowaves_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Superfast 5G cellular<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-15">
                              <div role="presentation" class="stat" index="15">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper b2E4D8E embed-image">
                                      <figure class="compare-image image-icon_5g_radiowaves_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Superfast 5G cellular<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-16">
                              <div role="presentation" class="stat" index="16">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper l6E6706 embed-image">
                                      <figure class="compare-image image-icon_5g_radiowaves_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Superfast 5G cellular<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-17">
                              <div role="presentation" class="stat" index="17">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper wC480E4 embed-image">
                                      <figure class="compare-image image-icon_5g_radiowaves_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Superfast 5G cellular<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-18">
                              <div role="presentation" class="stat" index="18">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper p4C723F embed-image">
                                      <figure class="compare-image image-icon_5g_radiowaves_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Superfast 5G cellular<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-19">
                              <div role="presentation" class="stat" index="19">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper pBFFB0E embed-image">
                                      <figure class="compare-image image-icon_5g_radiowaves_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Superfast 5G cellular<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-20">
                              <div role="presentation" class="stat" index="20">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper yB89169 embed-image">
                                      <figure class="compare-image image-icon_5g_radiowaves_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Superfast 5G cellular<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-21">
                              <div role="presentation" class="stat" index="21">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper z8FC2FF embed-image">
                                      <figure class="compare-image image-icon_4g_radiowaves_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">4G LTE cellular<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-22">
                              <div role="presentation" class="stat" index="22">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper uB503E9 embed-image">
                                      <figure class="compare-image image-icon_4g_radiowaves_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">4G LTE cellular<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-23">
                              <div role="presentation" class="stat" index="23">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper sFB6C5A embed-image">
                                      <figure class="compare-image image-icon_4g_radiowaves_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">4G LTE cellular<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-24">
                              <div role="presentation" class="stat" index="24">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper t8FF390 embed-image">
                                      <figure class="compare-image image-icon_4g_radiowaves_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">4G LTE cellular<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-25">
                              <div role="presentation" class="stat" index="25">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper eC5163D embed-image">
                                      <figure class="compare-image image-icon_4g_radiowaves_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">4G LTE cellular<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-26">
                              <div role="presentation" class="stat" index="26">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper yD72DE9 embed-image">
                                      <figure class="compare-image image-icon_4g_radiowaves_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">4G LTE cellular<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-27">
                              <div role="presentation" class="stat" index="27">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper o15E31E embed-image">
                                      <figure class="compare-image image-icon_4g_radiowaves_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">4G LTE cellular<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-28">
                              <div role="presentation" class="stat" index="28">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper zBC7C5E embed-image">
                                      <figure class="compare-image image-icon_4g_radiowaves_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">4G LTE cellular<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-29">
                              <div role="presentation" class="stat" index="29">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper lF6DF4B embed-image">
                                      <figure class="compare-image image-icon_4g_radiowaves_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">4G LTE cellular<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-30">
                              <div role="presentation" class="stat" index="30">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper sE3AD1F embed-image">
                                      <figure class="compare-image image-icon_4g_radiowaves_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">4G LTE cellular<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-31">
                              <div role="presentation" class="stat" index="31">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper a1A03A9 embed-image">
                                      <figure class="compare-image image-icon_4g_radiowaves_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">4G LTE cellular<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-32">
                              <div role="presentation" class="stat" index="32">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper g7DF1D6 embed-image">
                                      <figure class="compare-image image-icon_4g_radiowaves_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">4G LTE cellular<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-33">
                              <div role="presentation" class="stat" index="33">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper oD8BDE9 embed-image">
                                      <figure class="compare-image image-icon_4g_radiowaves_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">4G LTE cellular<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-34">
                              <div role="presentation" class="stat" index="34">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper m55CA94 embed-image">
                                      <figure class="compare-image image-icon_4g_radiowaves_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">4G LTE cellular<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-35">
                              <div role="presentation" class="stat" index="35">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper gA10CA0 embed-image">
                                      <figure class="compare-image image-icon_4g_radiowaves_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">4G LTE cellular<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-36">
                              <div role="presentation" class="stat" index="36">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper wAC00C5 embed-image">
                                      <figure class="compare-image image-icon_4g_radiowaves_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">4G LTE cellular<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-37">
                              <div role="presentation" class="stat" index="37">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper s618A69 embed-image">
                                      <figure class="compare-image image-icon_4g_radiowaves_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">4G LTE cellular<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;"> Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!--END > CATEGORY > QUICK-LOOK > FEATURE > CELLULAR-->
                        </div>
                        <!--END > CATEGORY > QUICK-LOOK-->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--END > FLEX | COMPARE-->
        <!--BEGIN > FLEX | MAKE A DIFFERENCE (IPHONE ONLY)-->
        <div class="section tCE9BB9">
          <div class="section-content">
            <div class="row large-display-bleed medium-display-bleed small-display-bleed y0DF2E8">
              <!---->
              <div class="column large-12 t8B7417">
                <div>
                  <!---->
                </div>
                <h2 class="copy fE1E3E7 channel-custom-font-custom-40-headline-flex" style="--focus-color: rgba(0, 125, 250, 0.6);">Designed to make a difference.</h2>
              </div>
            </div>
            <div class="row large-display-bleed medium-display-bleed small-display-bleed z1A0325">
              <!---->
              <div class="column large-6 small-12 v44CF36">
                <div>
                  <!---->
                </div>
                <div class="bento-box kF65249">
                  <div class="bentobox-item v58A8F6">
                    <!---->
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed a013A74">
                      <!---->
                      <div class="column large-12 b18A020">
                        <div>
                          <!---->
                        </div>
                        <div>
                          <picture aria-hidden="true" class="picture">
                            <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 32px" srcset="assets/images/iPhone16images/flex_icon_apple_logo_lock_elevated_large.png?600029cab910 32w,assets/images/iPhone16images/flex_icon_apple_logo_lock_elevated_large_2x.png?600029f7c580 64w" type="image/png">
                            <source media="(min-width: 735px)" sizes="(min-width: 735px) 32px" srcset="assets/images/iPhone16images/flex_icon_apple_logo_lock_elevated_medium_2x.png?600061c05810 64w,assets/images/iPhone16images/flex_icon_apple_logo_lock_elevated_medium.png?600061c16050 32w" type="image/png"><img sizes="32px" srcset="assets/images/iPhone16images/flex_icon_apple_logo_lock_elevated_small.png?600061c7f230 32w,assets/images/iPhone16images/flex_icon_apple_logo_lock_elevated_small_2x.png?600061c20420 64w" src="assets/images/iPhone16images/flex_icon_apple_logo_lock_elevated_small.png?600061c7f230" alt="" class="image c46CD57"></picture>
                        </div>
                      </div>
                      <div class="column large-12 j6C8F63">
                        <div>
                          <!---->
                        </div>
                        <h3 class="copy xD610F4 channel-custom-font-custom-24-eyebrow" style="--focus-color: rgba(0, 125, 250, 0.6);">Privacy. That’s iPhone.</h3>
                        <p class="copy helvetica-neue iB05D47 channel-custom-font-custom-17-body-reduced" style="--focus-color: rgba(0, 125, 250, 0.6);">From the Passwords app to Private Browsing on Safari to the Health app, iPhone helps keep you in control of what you share.</p>
                      </div>
                      <div class="column large-12 u5C8722">
                        <div>
                          <!---->
                        </div>
                        <div>
                          <picture class="picture">
                            <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 236px" srcset="assets/images/iPhone16images/flex_privacy_large.png?600061c7dfa0 236w,assets/images/iPhone16images/flex_privacy_large_2x.png?600061c01340 472w" type="image/png">
                            <source media="(min-width: 735px)" sizes="(min-width: 735px) 178px" srcset="assets/images/iPhone16images/flex_privacy_medium.png?600061c01b80 178w,assets/images/iPhone16images/flex_privacy_medium_2x.png?600061c01130 356w" type="image/png"><img sizes="198px" srcset="assets/images/iPhone16images/flex_privacy_small_2x.png?600061c01290 396w,assets/images/iPhone16images/flex_privacy_small.png?600061c7dc30 198w" src="assets/images/iPhone16images/flex_privacy_small_2x.png?600061c01290" alt="" class="image double-invert y792481"></picture>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="column large-6 small-12 tE62C1E">
                <div>
                  <!---->
                </div>
                <div class="bento-box n296C18">
                  <div class="bentobox-item l31FCC5">
                    <!---->
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed vAB2234">
                      <!---->
                      <div class="column large-12 dCF28D6">
                        <div>
                          <!---->
                        </div>
                        <div>
                          <picture aria-hidden="true" class="picture">
                            <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 31px" srcset="assets/images/iPhone16images/flex_icon_apple_logo_elevated_large.png?600061c7d1e0 31w,assets/images/iPhone16images/flex_icon_apple_logo_elevated_large_2x.png?600029f73a70 62w" type="image/png">
                            <source media="(min-width: 735px)" sizes="(min-width: 735px) 31px" srcset="assets/images/iPhone16images/flex_icon_apple_logo_elevated_medium.png?600061c15600 31w,assets/images/iPhone16images/flex_icon_apple_logo_elevated_medium_2x.png?600029f7def0 62w" type="image/png"><img sizes="31px" srcset="assets/images/iPhone16images/flex_icon_apple_logo_elevated_small.png?600061c7d130 31w,assets/images/iPhone16images/flex_icon_apple_logo_elevated_small_2x.png?600061c14000 62w" src="assets/images/iPhone16images/flex_icon_apple_logo_elevated_small.png?600061c7d130" alt="" class="image nAD9407"></picture>
                        </div>
                      </div>
                      <div class="column large-12 b17F598">
                        <div>
                          <!---->
                        </div>
                        <h3 class="copy e0AB7F0 channel-custom-font-custom-24-eyebrow" style="--focus-color: rgba(0, 125, 250, 0.6);">More recycled materials? Naturally.</h3>
                        <p class="copy helvetica-neue t662DB6 channel-custom-font-custom-17-body-reduced" style="--focus-color: rgba(0, 125, 250, 0.6);">Apple is significantly expanding the use of key recycled metals in iPhone batteries, magnets and circuit boards. And iPhone packaging is 100% fibre based, with no plastic wrap in or around the&nbsp;box.</p>
                      </div>
                      <div class="column large-12 s074652">
                        <div>
                          <!---->
                        </div>
                        <div>
                          <picture class="picture">
                            <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 134px" srcset="assets/images/iPhone16images/flex_icon_environment_large.png?600061c7c4d0 134w,assets/images/iPhone16images/flex_icon_environment_large_2x.png?600029f7f4f0 268w" type="image/png">
                            <source media="(min-width: 735px)" sizes="(min-width: 735px) 96px" srcset="assets/images/iPhone16images/flex_icon_environment_medium_2x.png?600029f7bf40 192w,assets/images/iPhone16images/flex_icon_environment_medium.png?600061c140b0 96w" type="image/png"><img sizes="124px" srcset="assets/images/iPhone16images/flex_icon_environment_small_2x.png?600029f49e40 248w,assets/images/iPhone16images/flex_icon_environment_small.png?600061c7cfd0 124w" src="assets/images/iPhone16images/flex_icon_environment_small_2x.png?600029f49e40" alt="" class="image v22E062"></picture>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--END > FLEX | MAKE A DIFFERENCE (IPHONE ONLY)-->
        <!--BEGIN > FLEX | UPGRADE (IPHONE ONLY)-->
        <div class="section f5B1D49">
          <div class="section-content">
            <div class="row large-display-bleed medium-display-bleed small-display-bleed k28028B">
              <!---->
              <div class="column large-12 v9DD8FE">
                <div>
                  <!---->
                </div>
                <h2 class="copy vD3F8F9 channel-custom-font-custom-40-headline-flex" style="--focus-color: rgba(0, 125, 250, 0.6);">Easy to upgrade. Simple to switch.</h2>
              </div>
            </div>
            <div class="row large-display-bleed medium-display-bleed small-display-bleed hE18928">
              <!---->
              <div class="column large-6 small-12 i1AC1A8">
                <div>
                  <!---->
                </div>
                <div class="bento-box m16A40D">
                  <div class="bentobox-item mCFEB3C">
                    <!---->
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed y6F9E12">
                      <!---->
                      <div class="column large-12 f9D1CFF">
                        <div>
                          <!---->
                        </div>
                        <div>
                          <picture aria-hidden="true" class="picture">
                            <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 34px" srcset="assets/images/iPhone16images/flex_icon_iphone_and_iphone_elevated_large_2x.png?600061c07de0 68w,assets/images/iPhone16images/flex_icon_iphone_and_iphone_elevated_large.png?600031c4b910 34w" type="image/png">
                            <source media="(min-width: 735px)" sizes="(min-width: 735px) 34px" srcset="assets/images/iPhone16images/flex_icon_iphone_and_iphone_elevated_medium.png?600061cc74f0 34w,assets/images/iPhone16images/flex_icon_iphone_and_iphone_elevated_medium_2x.png?600061c06aa0 68w" type="image/png"><img sizes="34px" srcset="assets/images/iPhone16images/flex_icon_iphone_and_iphone_elevated_small_2x.png?600061c05b80 68w,assets/images/iPhone16images/flex_icon_iphone_and_iphone_elevated_small.png?600061c7f7b0 34w" src="assets/images/iPhone16images/flex_icon_iphone_and_iphone_elevated_small_2x.png?600061c05b80" alt="" class="image cDD6B20"></picture>
                        </div>
                      </div>
                      <div class="column large-12 m791C2C">
                        <div>
                          <!---->
                        </div>
                        <h3 class="copy q98FB3B channel-custom-font-custom-24-eyebrow" style="--focus-color: rgba(0, 125, 250, 0.6);">Upgrading from another iPhone?</h3>
                        <p class="copy helvetica-neue hEE423A channel-custom-font-custom-17-body-reduced" style="--focus-color: rgba(0, 125, 250, 0.6);">Just put your old iPhone next to your new one, and with a few taps you can transfer your data automatically.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="column large-6 small-12 uEF7332">
                <div>
                  <!---->
                </div>
                <div class="bento-box q4F707A">
                  <div class="bentobox-item xA34E06">
                    <!---->
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed l8A92F4">
                      <!---->
                      <div class="column large-12 n89564E">
                        <div>
                          <!---->
                        </div>
                        <div>
                          <picture aria-hidden="true" class="picture">
                            <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 72px" srcset="assets/images/iPhone16images/flex_ios_large.png?600061c7e7e0 72w,assets/images/iPhone16images/flex_ios_large_2x.png?600061c20dc0 144w" type="image/png">
                            <source media="(min-width: 735px)" sizes="(min-width: 735px) 49px" srcset="assets/images/iPhone16images/flex_ios_medium.png?600061c07020 49w,assets/images/iPhone16images/flex_ios_medium_2x.png?600061c07230 98w" type="image/png"><img sizes="49px" srcset="assets/images/iPhone16images/flex_ios_small.png?600029ca7860 49w,assets/images/iPhone16images/flex_ios_small_2x.png?600061c056b0 98w" src="assets/images/iPhone16images/flex_ios_small.png?600029ca7860" alt="" class="image uF7F325"></picture>
                        </div>
                      </div>
                      <div class="column large-12 m53E6B7">
                        <div>
                          <!---->
                        </div>
                        <h3 class="copy y3E6BC4 channel-custom-font-custom-24-eyebrow" style="--focus-color: rgba(0, 125, 250, 0.6);">Switching from an Android phone?</h3>
                        <p class="copy helvetica-neue n088835 channel-custom-font-custom-17-body-reduced" style="--focus-color: rgba(0, 125, 250, 0.6);">When you buy a new iPhone, the Move to iOS app makes it easy to transfer your photos, contacts and more.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--END > FLEX | UPGRADE (IPHONE ONLY)-->
        <!--BEGIN > FLEX | ACCESSORIES-->
        <div class="section theme-light j62BF3C">
          <div class="section-content">
            <div class="row large-display-bleed medium-display-bleed small-display-bleed b2646A7">
              <!---->
              <div class="column large-12 aCCF308">
                <div>
                  <!---->
                </div>
                <h2 class="copy j480BED channel-custom-font-custom-40-headline-reduced" style="--focus-color: rgba(0, 125, 250, 0.6);">Even more to love.</h2>
              </div>
            </div>
            <div class="row large-display-bleed medium-display-bleed small-display-bleed g7AAC7F">
              <!---->
              <div class="column large-12 fB9DCFC">
                <div>
                  <!---->
                </div>
                <div class="bento-box lEBC721">
                  <div class="bentobox-item v0A4159">
                    <!---->
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed nA98793">
                      <!---->
                      <div class="column large-6 medium-6 small-12 p55DB2B">
                        <div>
                          <!---->
                        </div>
                        <h3 class="copy n099CFB channel-custom-font-Custom-21-flex-eyebrow" style="--focus-color: rgba(0, 125, 250, 0.6);">MagSafe accessories</h3>
                        <p class="copy n402AA3 channel-custom-font-Custom-40-flex-headline" style="--focus-color: rgba(0, 125, 250, 0.6);">Snap on a magnetic case, wallet or both.</p>
                        <p class="copy helvetica-neue tE894C7 channel-custom-font-custom-17-body-reduced-flex" style="--focus-color: rgba(0, 125, 250, 0.6);">A colourful ecosystem of accessories for effortless attachment and faster wireless charging. With endless ways to combine, there is a mix to match any style.<span aria-hidden="true" style="top: -0.35em; position: relative; font-size: .6em; vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></p>
                        <div class="row large-display-bleed medium-display-bleed small-display-bleed d9E2DA7">
                          <!---->
                          <div class="column large-12 x6943CD">
                            <div>
                              <!---->
                            </div><a href="#" class="link-wrapper link-standalone pC1833C" style="--focus-color: rgba(0, 125, 250, 0.6);"><span class="q059ECE icon icon-chevronright icon-after channel-custom-font-custom-17-links"><span>Learn more about MagSafe accessories</span></span></a>
                          </div>
                        </div>
                      </div>
                      <div class="column large-6 medium-6 small-12 y0698D3">
                        <div>
                          <!---->
                        </div>
                        <div>
                          <picture class="picture">
                            <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 423px" srcset="assets/images/iPhone16images/flex_magsafe_large_2x.png?600029f489a0 846w,assets/images/iPhone16images/flex_magsafe_large.png?600061c7e100 423w" type="image/png">
                            <source media="(min-width: 735px)" sizes="(min-width: 735px) 292px" srcset="assets/images/iPhone16images/flex_magsafe_medium_2x.png?600061c05fa0 584w,assets/images/iPhone16images/flex_magsafe_medium.png?600061c06310 292w" type="image/png"><img sizes="238px" srcset="assets/images/iPhone16images/flex_magsafe_small_2x.png?600061c06520 476w,assets/images/iPhone16images/flex_magsafe_small.png?600061c7f180 238w" src="assets/images/iPhone16images/flex_magsafe_small_2x.png?600061c06520" alt="Three iPhone 16 Pro devices, back exterior, with MagSafe accessories attached: iPhone FineWoven MagSafe Wallet, MagSafe Charger, and iPhone Silicone Case with MagSafe" class="image double-invert x39A9C8"></picture>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--END > FLEX | ACCESSORIES-->
        <!--BEGIN > FLEX | APPLECARE+-->
        <div class="section theme-light m8FF7F9">
          <div class="section-content">
            <div class="row large-display-bleed medium-display-bleed small-display-bleed x4EA550">
              <!---->
              <div class="column large-12 bE2C3B2">
                <div>
                  <!---->
                </div>
                <div class="bento-box q0734F1">
                  <div class="bentobox-item iDB785D">
                    <!---->
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed k67DDCB">
                      <!---->
                      <div class="column large-6 medium-7 small-12 p34484F">
                        <div>
                          <!---->
                        </div>
                        <h3 class="copy e44C84F channel-custom-font-Custom-21-flex-eyebrow" style="--focus-color: rgba(0, 125, 250, 0.6);">AppleCare+</h3>
                        <p class="copy tEDD50F channel-custom-font-Custom-40-flex-headline" style="--focus-color: rgba(0, 125, 250, 0.6);">Expert support, extended coverage.</p>
                        <div class="row m87563C">
                          <!---->
                          <div class="column large-12 iA8856B">
                            <div>
                              <!---->
                            </div>
                            <ul role="list" aria-label="Apple Care plus support and coverage with iPhone 16 Pro" class="list vCC086C">
                              <li role="listitem" class="list-item o1E1F09">
                                <div class="row aFA3C7D">
                                  <!---->
                                  <div class="column large-0 a78F83E">
                                    <div>
                                      <!---->
                                    </div>
                                    <div>
                                      <picture aria-hidden="true" class="picture">
                                        <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 15px" srcset="assets/images/iPhone16images/check_d0112b_34_R_large_2x.png?600029ca3bd0 30w,assets/images/iPhone16images/check_d0112b_34_R_large.png?600061c7da20 15w" type="image/png">
                                        <source media="(min-width: 735px)" sizes="(min-width: 735px) 15px" srcset="assets/images/iPhone16images/check_d0112b_34_R_medium.png?600061c023c0 15w,assets/images/iPhone16images/check_d0112b_34_R_medium_2x.png?600061c7de40 30w" type="image/png"><img sizes="15px" srcset="assets/images/iPhone16images/check_d0112b_34_R_small_2x.png?600061c7dd90 30w,assets/images/iPhone16images/check_d0112b_34_R_small.png?600061c7d970 15w" src="assets/images/iPhone16images/check_d0112b_34_R_small_2x.png?600061c7dd90" alt="" class="image lA21469"></picture>
                                    </div>
                                  </div>
                                  <div class="column large-11 vED84EA">
                                    <div>
                                      <!---->
                                    </div>
                                    <p class="copy helvetica-neue lF7B187 channel-custom-font-custom-17-body-reduced-flex" style="--focus-color: rgba(0, 125, 250, 0.6);">Apple-certified service</p>
                                  </div>
                                </div>
                              </li>
                              <li role="listitem" class="list-item g6C493A">
                                <div class="row f350818">
                                  <!---->
                                  <div class="column large-0 dDAB812">
                                    <div>
                                      <!---->
                                    </div>
                                    <div>
                                      <picture aria-hidden="true" class="picture">
                                        <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 15px" srcset="assets/images/iPhone16images/check_d0112b_34_R_large_2x.png?600029ca3bd0 30w,assets/images/iPhone16images/check_d0112b_34_R_large.png?600061c7da20 15w" type="image/png">
                                        <source media="(min-width: 735px)" sizes="(min-width: 735px) 15px" srcset="assets/images/iPhone16images/check_d0112b_34_R_medium.png?600061c023c0 15w,assets/images/iPhone16images/check_d0112b_34_R_medium_2x.png?600061c7de40 30w" type="image/png"><img sizes="15px" srcset="assets/images/iPhone16images/check_d0112b_34_R_small_2x.png?600061c7dd90 30w,assets/images/iPhone16images/check_d0112b_34_R_small.png?600061c7d970 15w" src="assets/images/iPhone16images/check_d0112b_34_R_small_2x.png?600061c7dd90" alt="" class="image j0A17B1"></picture>
                                    </div>
                                  </div>
                                  <div class="column large-11 gC3013D">
                                    <div>
                                      <!---->
                                    </div>
                                    <p class="copy helvetica-neue t513C0B channel-custom-font-custom-17-body-reduced-flex" style="--focus-color: rgba(0, 125, 250, 0.6);">Priority access to technical support</p>
                                  </div>
                                </div>
                              </li>
                              <li role="listitem" class="list-item b86BCD0">
                                <div class="row b4009D3">
                                  <!---->
                                  <div class="column large-0 gFF8EE7">
                                    <div>
                                      <!---->
                                    </div>
                                    <div>
                                      <picture aria-hidden="true" class="picture">
                                        <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 15px" srcset="assets/images/iPhone16images/check_d0112b_34_R_large_2x.png?600029ca3bd0 30w,assets/images/iPhone16images/check_d0112b_34_R_large.png?600061c7da20 15w" type="image/png">
                                        <source media="(min-width: 735px)" sizes="(min-width: 735px) 15px" srcset="assets/images/iPhone16images/check_d0112b_34_R_medium.png?600061c023c0 15w,assets/images/iPhone16images/check_d0112b_34_R_medium_2x.png?600061c7de40 30w" type="image/png"><img sizes="15px" srcset="assets/images/iPhone16images/check_d0112b_34_R_small_2x.png?600061c7dd90 30w,assets/images/iPhone16images/check_d0112b_34_R_small.png?600061c7d970 15w" src="assets/images/iPhone16images/check_d0112b_34_R_small_2x.png?600061c7dd90" alt="" class="image eCC64BC"></picture>
                                    </div>
                                  </div>
                                  <div class="column large-11 a20E9BD">
                                    <div>
                                      <!---->
                                    </div>
                                    <p class="copy helvetica-neue s489AAA channel-custom-font-custom-17-body-reduced-flex" style="--focus-color: rgba(0, 125, 250, 0.6);">Accidental damage protection</p>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="row large-display-bleed medium-display-bleed small-display-bleed qEEE9E6">
                          <!---->
                          <div class="column large-12 q3CF8B0">
                            <div>
                              <!---->
                            </div><a href="#" class="link-wrapper link-standalone w63597B" style="--focus-color: rgba(0, 125, 250, 0.6);"><span class="j44FD88 icon icon-chevronright icon-after channel-custom-font-custom-17-links"><span>Learn more about AppleCare+ for iPhone</span></span></a>
                          </div>
                        </div>
                      </div>
                      <div class="column large-6 medium-5 small-12 w607453">
                        <div>
                          <!---->
                        </div>
                        <div>
                          <picture class="picture">
                            <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 276px" srcset="assets/images/iPhone16images/flex_applecare_large_2x.png?600061c179c0 552w,assets/images/iPhone16images/flex_applecare_large.png?600061c7c420 276w" type="image/png">
                            <source media="(min-width: 735px)" sizes="(min-width: 735px) 206px" srcset="assets/images/iPhone16images/flex_applecare_medium_2x.png?600061c23b20 412w,assets/images/iPhone16images/flex_applecare_medium.png?600061c213f0 206w" type="image/png"><img sizes="169px" srcset="assets/images/iPhone16images/flex_applecare_small.png?600061c7d6b0 169w,assets/images/iPhone16images/flex_applecare_small_2x.png?600061c17440 338w" src="assets/images/iPhone16images/flex_applecare_small.png?600061c7d6b0" alt="" class="image double-invert rAA7321"></picture>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--END > FLEX | APPLECARE+-->
        <!--BEGIN > LEGAL-->
        <div class="section e9DA4B1">
          <div class="section-content">
            <div class="row large-display-bleed medium-display-bleed u892C6B">
              <!---->
              <aside aria-labelledby="comp" role="complimentary" class="column large-12 medium-12 v25EAC1">
                <div>
                  <!---->
                </div>
                <div class="row large-display-bleed medium-display-bleed small-display-bleed tF70703">
                  <!---->
                  <div class="column large-12 qDE861B">
                    <div>
                      <!---->
                    </div>
                    <h2 id="comp" class="copy helvetica-neue h2730B5 channel-custom-font-custom-12-sosumi" style="--focus-color: rgba(0, 125, 250, 0.6);"><span id="footnote-diamond-1" aria-hidden="true">◊</span>Legal Disclaimers</h2>
                  </div>
                </div>
                <ul role="list" class="list kF05A0E">
                  <li role="listitem" class="list-item e7C7012">
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed l8BB135">
                      <!---->
                      <div class="column large-12 f8B5651">
                        <div>
                          <!---->
                        </div>
                        <p class="copy helvetica-neue c912E39 channel-custom-font-custom-12-sosumi" style="--focus-color: rgba(0, 125, 250, 0.6);"><span style="font-weight: 500;">Apple&nbsp;Intelligence:</span> Apple&nbsp;Intelligence will be available in beta on all iPhone&nbsp;16 models, iPhone&nbsp;15&nbsp;Pro and&nbsp;iPhone 15 Pro Max, with Siri and device language set to US English, as an iOS 18 update in late 2024. Some features and support for additional languages, including Indian English, French, Japanese and Spanish, will be coming over the course of the&nbsp;next&nbsp;year.</p>
                      </div>
                    </div>
                  </li>
                  <li role="listitem" class="list-item g1101C8">
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed x5596B1">
                      <!---->
                      <div class="column large-12 lDB09C7">
                        <div>
                          <!---->
                        </div>
                        <p class="copy helvetica-neue d45BA59 channel-custom-font-custom-12-sosumi" style="--focus-color: rgba(0, 125, 250, 0.6);"><span style="font-weight: 500;">Thinnest Borders:</span> Compared to the previous generation.</p>
                      </div>
                    </div>
                  </li>
                  <li role="listitem" class="list-item aBF5302">
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed j34C409">
                      <!---->
                      <div class="column large-12 wC4D852">
                        <div>
                          <!---->
                        </div>
                        <p class="copy helvetica-neue uE739B0 channel-custom-font-custom-12-sosumi" style="--focus-color: rgba(0, 125, 250, 0.6);"><span style="font-weight: 500;">Display Size:</span> The display has rounded corners that follow a beautiful curved design, and these corners are within a standard rectangle. When measured as a standard rectangular shape, the screen is 15.54&nbsp;cm / 6.12″ (iPhone&nbsp;16), 17.00&nbsp;cm / 6.69″ (iPhone&nbsp;16&nbsp;Plus), 15.93&nbsp;cm / 6.27″ (iPhone&nbsp;16&nbsp;Pro) or 17.43&nbsp;cm / 6.86″ (iPhone&nbsp;16&nbsp;Pro&nbsp;Max) diagonally. Actual viewable area is&nbsp;less.</p>
                      </div>
                    </div>
                  </li>
                  <li role="listitem" class="list-item hD095BB">
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed gF2BC28">
                      <!---->
                      <div class="column large-12 u15E06E">
                        <div>
                          <!---->
                        </div>
                        <p class="copy helvetica-neue jA6ABE2 channel-custom-font-custom-12-sosumi" style="--focus-color: rgba(0, 125, 250, 0.6);"><span style="font-weight: 500;">Power and Battery:</span> Battery life varies by use and configuration. See <a href="https://www.apple.com/in/batteries" class="footer-link"><span style="color: #424245;  white-space: nowrap;">apple.com/in/batteries</span></a> for more information.</p>
                      </div>
                    </div>
                  </li>
                  <li role="listitem" class="list-item rF2D7BD">
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed nD5B41A">
                      <!---->
                      <div class="column large-12 v992B7A">
                        <div>
                          <!---->
                        </div>
                        <p class="copy helvetica-neue y840178 channel-custom-font-custom-12-sosumi" style="--focus-color: rgba(0, 125, 250, 0.6);"><span style="font-weight: 500;">(PRODUCT)RED:</span> A portion of the proceeds from every (PRODUCT)RED purchase goes to the Global Fund to fight AIDS and to help fund critical health programmes that save lives. See <a href="https://apple.com/in/product-red" class="footer-link"><span style="color: #424245;  white-space: nowrap;">apple.com/in/product-red</span></a> for more information.</p>
                      </div>
                    </div>
                  </li>
                  <li role="listitem" class="list-item cE708E9">
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed i6CAA4B">
                      <!---->
                      <div class="column large-12 aC4634F">
                        <div>
                          <!---->
                        </div>
                        <p class="copy helvetica-neue v611FB1 channel-custom-font-custom-12-sosumi" style="--focus-color: rgba(0, 125, 250, 0.6);"><span style="font-weight: 500;">Crash Detection:</span> iPhone&nbsp;16 models can detect a severe car crash and call for help. Requires a cellular connection or Wi-Fi calling.</p>
                      </div>
                    </div>
                  </li>
                  <li role="listitem" class="list-item f573649">
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed n36555E">
                      <!---->
                      <div class="column large-12 t38AF61">
                        <div>
                          <!---->
                        </div>
                        <p class="copy helvetica-neue i848512 channel-custom-font-custom-12-sosumi" style="--focus-color: rgba(0, 125, 250, 0.6);"><span style="font-weight: 500;">Cellular and Wireless:</span> Data plan is required. 5G is available in selected markets and through selected carriers. Speeds vary based on site conditions and carrier. For details on 5G support, contact your carrier and see <a href="https://apple.com/in/iphone/cellular" class="footer-link"><span style="color: #424245;  white-space: nowrap;">apple.com/in/iphone/cellular</span></a>.</p>
                      </div>
                    </div>
                  </li>
                  <li role="listitem" class="list-item aD63CDA">
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed d59A502">
                      <!---->
                      <div class="column large-12 kB14FFA">
                        <div>
                          <!---->
                        </div>
                        <p class="copy helvetica-neue e1F402B channel-custom-font-custom-12-sosumi" style="--focus-color: rgba(0, 125, 250, 0.6);"><span style="font-weight: 500;">MagSafe Accessories:</span> Colours are for illustrative purposes only. MagSafe accessories are sold separately. </p>
                      </div>
                    </div>
                  </li>
                  <li role="listitem" class="list-item q20790D">
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed a04B1DD">
                      <!---->
                      <div class="column large-12 u791A2B">
                        <div>
                          <!---->
                        </div>
                        <p class="copy helvetica-neue o97A475 channel-custom-font-custom-12-sosumi" style="--focus-color: rgba(0, 125, 250, 0.6);"><span style="font-weight: 500;">Apple&nbsp;TV+:</span> Apple&nbsp;TV+ requires a subscription.</p>
                      </div>
                    </div>
                  </li>
                  <li role="listitem" class="list-item w466F2B">
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed h2F2BC7">
                      <!---->
                      <div class="column large-12 s1DF33B">
                        <div>
                          <!---->
                        </div>
                        <p class="copy helvetica-neue qA93E77 channel-custom-font-custom-12-sosumi" style="--focus-color: rgba(0, 125, 250, 0.6);"><span style="font-weight: 500;">Feature Availability:</span> Some features may not be available for all countries or all regions.</p>
                      </div>
                    </div>
                  </li>
                </ul>
              </aside>
            </div>
          </div>
        </div>
        <!--END > LEGAL-->
      </div>

</section>

 <!--BEGIN > SCRIPTS:BASE -->
 <script type="text/javascript">"use strict";const reorderDOM={selectorEls:null,headerEl:null,capturedEls:null,capturedElsQuery:null,clonedEls:[],cOrder:null,cMax:null,useStatic:null,selectorElsQuery:null,staticEl:null,staticElQuery:null,addListeners(){window.addEventListener("channel:reorder-dom",e=>{if(this.useStatic=e.detail.useStatic,this.cOrder=e.detail.order,this.cMax=e.detail.max,this.updateElements(),void 0!==e.detail.selectorIndex){document.querySelectorAll(this.selectorElsQuery).item(e.detail.selectorIndex).focus()}})},updateElements(){!this.useStatic&&this.updateSelectors(),!this.useStatic&&this.updateHeadersAX(),!this.useStatic&&this.updateRows(),this.useStatic&&this.updateStatic(),this.getStatSubCopyHeight()},arrayFromNodeList(e){const t=[];return e.forEach(e=>{t.push(e)}),t},updateStatic(){this.clonedEls.forEach((e,t)=>{const i=this.capturedEls[t],r=e.cloneNode(!0),n=r.querySelector("[role=rowheader]"),s=r.querySelector("[id=hidden-columnheader]");let o=[];this.cOrder.forEach((e,t)=>{const i=`[index="${e}"]`,n=r.querySelector(i).parentElement;o.push(n)}),o.reverse().forEach((e,t)=>{e.setAttribute("added",!0),r.prepend(e)});for(let e=0;e<r.children.length;e++){const t=r.children[e];"rowheader"!==t.getAttribute("role")&&"hidden-columnheader"!==t.getAttribute("id")&&(t.style.order="unset",this.toggleVisibility(t,e<this.cMax))}s&&r.prepend(s),r.prepend(n),r.setAttribute("added",!0),i.innerHTML=r.innerHTML})},updateHeadersAX(){let e=`<div role="columnheader">${getComputedStyle(document.querySelector(".channel-compare")).getPropertyValue("--column-header-empty-cell")}</div>`;document.querySelectorAll(this.selectorElsQuery).forEach((t,i)=>{const r=t.querySelector("[selected=true]").innerText.trim();"flex"===t.parentElement.parentElement.style.display&&(e+=`<div role="columnheader">${r}</div>`)}),this.headerEl.innerHTML=e},updateSelectors(){document.querySelectorAll(this.selectorElsQuery).forEach((e,t)=>{e.replaceWith(this.selectorEls[t])}),this.cOrder.forEach((e,t)=>{const i=this.selectorEls[t];let r=0;for(let t=0;t<i.options.length;t++){const n=i.options[t],s=Number(n.value)===e;s&&(r=t),n.removeAttribute("selected"),n.setAttribute("selected",s),n.removeAttribute("aria-selected"),n.setAttribute("aria-selected",s)}i.selectedIndex=r});for(var e=0;e<this.selectorEls.length;e++){const t=this.selectorEls[e],i=e<this.cMax;this.toggleVisibility(t.parentElement.parentElement,i)}},updateRows(){this.clonedEls.forEach((e,t)=>{const i=this.capturedEls[t],r=e.cloneNode(!0),n=r.querySelector("[role=rowheader]"),s=[];this.cOrder.forEach(e=>{const t=`[index="${e}"]`,i=r.querySelector(t).parentElement;s.push(i)}),s.reverse().forEach(e=>{r.prepend(e)});for(let e=0;e<r.children.length;e++){const t=r.children[e];"rowheader"!==t.getAttribute("role")&&(t.style.order="unset",this.toggleVisibility(t,e<this.cMax))}r.prepend(n),i.innerHTML=r.innerHTML})},getStatSubCopyHeight(){let e=document.getElementsByClassName("compare-template-preview-item-stat");if(e){let t=[];Array.from(e).forEach((e,i)=>{const r=e.children;let n=[];Array.from(r).forEach(e=>{"visible"===e.style.visibility&&n.push(e.children[0].children[0])});let s=[];n.forEach(e=>{let r=[],n=0;Array.from(e.children).forEach(e=>{const s=e;s.style.height="",s.children[0].className.includes("stat-value")||s.children[0].className.includes("image")||s.children[0].className.includes("mdash")||(r.push(s),void 0===t[i]?t[i]=[s.offsetHeight]:void 0===t[i][n]?t[i][n]=s.offsetHeight:void 0!==t[i][n]&&s.offsetHeight>t[i][n]&&(t[i][n]=s.offsetHeight),n++)}),s.push(r)}),s.forEach(e=>{e.forEach((e,r)=>{e.style.height=`${t[i][r]}px`})})})}},toggleVisibility(e,t){e.style.visibility=t?"visible":"hidden",e.style.display=t?"flex":"none",e.style.order="unset"},init(e,t,i,r,n){this.useStatic=n,this.capturedEls=document.querySelectorAll(e),this.capturedElsQuery=e,this.headerEl=document.querySelector(i),this.selectorEls=document.querySelectorAll(t),this.selectorElsQuery=t,this.staticElQuery=r,this.staticEl=this.useStatic&&document.querySelector(this.staticElQuery).cloneNode(!0),this.useStatic=n,this.clonedEls=this.arrayFromNodeList(this.capturedEls),this.addListeners()}},viewportManager={nState:null,cState:null,init:function(){this.addListeners()},addListeners:function(){const e={small:window.matchMedia("(max-width: 734px)"),medium:window.matchMedia("(min-width: 735px) and (max-width: 1068px)"),large:window.matchMedia("(min-width: 1069px)")};Object.keys(e).forEach(t=>{const i=e[t];"function"!=typeof i.addEventListener?i.addListener(()=>{i.matches&&this.viewportObserve(t)}):i.addEventListener("change",()=>{i.matches&&this.viewportObserve(t)}),i.matches&&this.viewportObserve(t)})},viewportObserve:function(e){this.nState=e,this.cState!==this.nState&&(this.cState=this.nState,this.dispatch(this.cState))},dispatch:function(e){const t=new CustomEvent("channel:viewport-change",{detail:e});window.dispatchEvent(t)}},orientationManager={orienation:null,init:function(){window.matchMedia("(orientation: portrait)").addEventListener("change",e=>{e.matches?this.orienation="portrait":this.orienation="landscape",this.dispatch(this.orienation)})},dispatch:function(e){const t=new CustomEvent("channel:orientation-change",{detail:e});window.dispatchEvent(t)}},selectorManager={init:function(e,t){const i=document.querySelectorAll(e);i.forEach((e,t)=>{e.addEventListener("change",()=>{const r=e.selectedIndex,n=e.value,s=Number(e.options[r].getAttribute("value"));this.dispatch({elIndex:t,selectedIndex:s,value:n,selectorEls:i}),e.focus()})})},dispatch:function(e){const t=new CustomEvent("channel:pre-user-select",{detail:e});window.dispatchEvent(t)}},buyButtonManager={buyButtonQuery:null,init:function(e){this.buyButtonQuery=e,this.addListeners(),this.attachButtonListeners()},addListeners:function(){window.addEventListener("channel:reorder-dom",()=>{this.attachButtonListeners()})},attachButtonListeners:function(){document.querySelectorAll(this.buyButtonQuery).forEach(e=>{e.addEventListener("click",t=>{const i=0===t.screenX&&0===t.screenY?"Keyboard Interaction":"Mouse Click";this.dispatch({productName:e.id,eventSource:i})})})},dispatch:function(e){const t=new CustomEvent("channel:buy-button-click",{detail:e});window.dispatchEvent(t)}},dataManager={order:null,viewportKey:null,viewportOrder:null,viewportMax:null,init:function(e,t){this.order=e,this.useStatic=t,this.addListeners()},viewportChange(e){this.viewportKey=e,this.viewportOrder=this.order[this.viewportKey],this.viewportMax=this.order.max[this.viewportKey],this.dispatch({order:this.viewportOrder,max:this.viewportMax,useStatic:this.useStatic})},blurSelects(e){document.querySelectorAll(e).forEach(e=>{e.blur()})},flattenOrders(){this.viewportOrder=this.order[this.viewportKey],this.viewportMax=this.order.max[this.viewportKey],["small","medium","large"].forEach(e=>{this.order[e]=this.viewportOrder})},getLineupInfo(e,t){const i={};return e.forEach((e,r)=>{i[r]={columnIndex:r,deviceName:e.options[e.selectedIndex].text,hasChanged:r===t}}),i},userSelect(e){const{elIndex:t,selectedIndex:i}=e,r=this.viewportOrder[t],n=this.viewportOrder.find(e=>e===i),s=this.viewportOrder.indexOf(n);void 0!==n?(this.viewportOrder[s]=r,this.viewportOrder[t]=n):this.viewportOrder[t]=i,this.flattenOrders(),this.dispatch({order:this.viewportOrder,max:this.viewportMax,useStatic:this.useStatic,selectorIndex:t}),e.deviceLineup=this.getLineupInfo(e.selectorEls,t),delete e.selectorEls;const o=Object.keys(e.deviceLineup).slice(0,this.viewportMax).reduce((t,i)=>(t[i]=e.deviceLineup[i],t),{});this.dispatchPostUserSelect({deviceLineup:o})},addListeners:function(){window.addEventListener("channel:pre-user-select",e=>{this.userSelect(e.detail)}),window.addEventListener("channel:user-refresh",e=>{this.dispatch({order:this.viewportOrder,max:this.viewportMax,useStatic:this.useStatic})}),window.addEventListener("channel:viewport-change",e=>{this.viewportChange(e.detail),this.blurSelects(this.selectorElsQuery)}),window.addEventListener("change:orientation-change",()=>{this.blurSelects(this.selectorElsQuery)})},dispatch:function(e){const t=new CustomEvent("channel:reorder-dom",{detail:e});window.dispatchEvent(t)},dispatchPostUserSelect:function(e){const t=new CustomEvent("channel:user-select",{detail:e});window.dispatchEvent(t)}},channelCompare={inited:!1,init:function(e=null){if(this.inited)return;let t;if(this.isDev=window.location.host.indexOf("127.0.0.1")>-1,e)t=e;else if(!e){const e=document.querySelector("[data-channel-html-compare]");if(!e)return void console.warn("channelCompare: element[data-channel-html-compare not found]");try{const i=e.getAttribute("data-channel-html-compare");t=JSON.parse(i)}catch(e){return void console.warn("channelCompare: error parsing JSON",e)}}if(t.isConfigurableCompare){let e={large:[],medium:[],small:[]},i=[];const r=document.querySelector("[data-compare-lineup]");if(r)try{const e=r.getAttribute("data-compare-lineup"),t=JSON.parse(null!==e&&void 0!==e?e:"{}");t["apple-compare"]&&(i=t["apple-compare"])}catch(e){return void console.warn("channelCompare: error parsing JSON",e)}const n=new URL(window.location.toLocaleString()).searchParams;n.get("apple-compare")&&(i=n.get("apple-compare").split(",")),Object.keys(e).forEach(t=>{var r;e[t]=[...new Set(null!==(r=null===i||void 0===i?void 0:i.map(e=>Number(e)-1))&&void 0!==r?r:[])].filter(e=>Number(e)>=0)}),t.order=this.orderOverwrite(t.order,e)}const i=t.order,r=t.headerEl,n=t.selectorEls,s=t.swapEls,o=t.staticEl,a=t.useStatic;reorderDOM.init(s,n,r,o,a),!a&&selectorManager.init(n),buyButtonManager.init(".compare-button"),dataManager.init(i,a),viewportManager.init(),orientationManager.init(),this.inited=!0},orderOverwrite:function(e,t){const i=Object.assign({},e);return Object.keys(t).forEach(e=>{const r=i[e].filter(i=>!t[e].includes(i)),n=[...t[e],...r].slice(0,5);i[e]=n}),i}};window.addEventListener("pageshow",e=>{const{persisted:t}=e;if(t)window.addEventListener("scroll",()=>{const e=new CustomEvent("channel:user-refresh");window.dispatchEvent(e)},{once:!0});else{channelCompare.init(),document.querySelector(".channel-compare").classList.remove("channel-compare--hidden")}});</script>
 <!--END > SCRIPTS:BASE -->